/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** ACHPaymentProcessingSettingsDto */
export interface ACHPaymentProcessingSettingsDto {
  allowHighRiskAch: boolean;
}

/** ACHPaymentProcessingSettingsDtoSettingsWithOverrideDto */
export interface ACHPaymentProcessingSettingsDtoSettingsWithOverrideDto {
  settings?: ACHPaymentProcessingSettingsDto;
  level: SettingsLevel;
  levelId: string;
}

/** ACHPaymentProcessingSettingsDtoSettingsWithOverridesDto */
export interface ACHPaymentProcessingSettingsDtoSettingsWithOverridesDto {
  settings?: ACHPaymentProcessingSettingsDto;
  overrides: ACHPaymentProcessingSettingsDtoSettingsWithOverrideDto[];
}

/** AddAssociationViolationLeaseBillDto */
export interface AddAssociationViolationLeaseBillDto {
  description: string;
  chartOfAccountId: string;
  /** @format double */
  amount: number;
  companyCharge: boolean;
}

/** AddCompanyPayOutDto */
export interface AddCompanyPayOutDto {
  bankAccountId: string;
  /** @format double */
  amount: number;
  memo?: string;
  paymentType: PayBillType;
  paymentMethod?: TransactionPaymentMethod;
  externalTransactionId?: string;
}

/** AddCompanyPayOutsDto */
export interface AddCompanyPayOutsDto {
  payOuts: AddCompanyPayOutDto[];
  /** @format date-time */
  paymentDate?: string;
  setPayOutDate?: boolean;
}

/** AddDraftWorkOrderBillDto */
export interface AddDraftWorkOrderBillDto {
  /** @format date */
  billDate?: string;
  /** @format date */
  dueDate: string;
  lineItems: WorkOrderBillLineItemDto[];
}

/** AddLeaseDepositRequestDto */
export interface AddLeaseDepositRequestDto {
  /**
   * Value must be a decimal greater than or equal to 0.01 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0.01
   * @max 1000000000000
   */
  amount: number;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  chartOfAccountId: string;
  /** @format date */
  dueDate: string;
  description?: string;
  /** @format date */
  billDate?: string;
}

/** AddManagementFeesDto */
export interface AddManagementFeesDto {
  /** @format date-time */
  calculateFeesUntil: string;
  /** @minItems 1 */
  managementFees: ManagementFeeDto[];
}

/** AddPropertyManagerOverwriteForRunBookRequestDto */
export interface AddPropertyManagerOverwriteForRunBookRequestDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyManagerId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  portfolioId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId?: string;
}

/** AddServiceBillDto */
export interface AddServiceBillDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  unitId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseId?: string;
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount: number;
  /**
   * @minLength 0
   * @maxLength 150
   */
  propertyBillMemo?: string;
  /**
   * @minLength 0
   * @maxLength 150
   */
  companyBillMemo?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyChartOfAccountId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  companyChartOfAccountId: string;
}

/** AddTransactionToReconciliationDto */
export interface AddTransactionToReconciliationDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  transactionId: string;
  type: ReconciliationEntryType;
}

/** AddVendorOverwriteForRunBookRequestDto */
export interface AddVendorOverwriteForRunBookRequestDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  vendorId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  portfolioId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId?: string;
  timeFrame?: TimeFrameDto;
}

/** AddressDto */
export interface AddressDto {
  /**
   * @minLength 1
   * @maxLength 250
   */
  streetAddress1?: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  streetAddress2?: string;
  /**
   * @minLength 2
   * @maxLength 150
   */
  city?: string;
  /**
   * @minLength 2
   * @maxLength 25
   */
  state?: string;
  /**
   * @minLength 2
   * @maxLength 25
   */
  zipCode?: string;
  /**
   * @minLength 2
   * @maxLength 25
   */
  country?: string;
  /** Indicates if the address is valid for a rental application */
  isValid: boolean;
}

/** AllocateDepositRequestDto */
export interface AllocateDepositRequestDto {
  /**
   * Value must be a decimal greater than or equal to 0.01 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0.01
   * @max 1000000000000
   */
  amount: number;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  chartOfAccountId: string;
  /**
   * @minLength 1
   * @maxLength 200
   */
  description?: string;
  /** @format date */
  date?: string;
  /**
   * The bank account to allocate the deposit to. If not provided, the default bank account in `DepositPaymentSettings` will be used.
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  bankAccountId?: string;
}

/** AmenityAvalability */
export enum AmenityAvalability {
  Unavailable = 'unavailable',
  Available = 'available',
  Limited = 'limited',
  Pending = 'pending',
}

/** AmenityDto */
export interface AmenityDto {
  type: AmenityType;
  /**
   * @minLength 2
   * @maxLength 50
   */
  name: string;
  /**
   * @minLength 2
   * @maxLength 50
   */
  icon?: string;
  avalability: AmenityAvalability;
  description?: string;
}

/** AmenityType */
export enum AmenityType {
  Infrastructure = 'infrastructure',
  Utility = 'utility',
  Interior = 'interior',
  Exterior = 'exterior',
  Outdoor = 'outdoor',
  Community = 'community',
  Security = 'security',
  Parking = 'parking',
  Storage = 'storage',
  Recreation = 'recreation',
  GreenSpace = 'greenSpace',
  Service = 'service',
  Other = 'other',
}

/** AnnouncementListDto */
export interface AnnouncementListDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  companyId: string;
  /** @format date-time */
  sentAt: string;
  chatMessage?: string;
  emailMessage?: string;
  /** @maxLength 250 */
  subject?: string;
  /** @format int32 */
  targetsCount: number;
}

/** AnnouncementsDto */
export interface AnnouncementsDto {
  announcements: AnnouncementListDto[];
  properties: PropertyDto[];
}

/** App */
export enum App {
  CompanyApp = 'companyApp',
  CompanyWeb = 'companyWeb',
  TenantApp = 'tenantApp',
  VendorApp = 'vendorApp',
  OwnerApp = 'ownerApp',
  Homepage = 'homepage',
  Internal = 'internal',
}

/** AppRegistrationInfoDto */
export interface AppRegistrationInfoDto {
  /** @minLength 1 */
  deviceToken: string;
  platform: Platform;
  /** @minLength 1 */
  appVersion: string;
}

/** ApplicationDecision */
export enum ApplicationDecision {
  NoDecision = 'noDecision',
  Approved = 'approved',
  Rejected = 'rejected',
  Ignored = 'ignored',
}

/** ApplicationPaymentStatus */
export enum ApplicationPaymentStatus {
  Unpaid = 'unpaid',
  Processing = 'processing',
  Paid = 'paid',
  Failed = 'failed',
  Refunded = 'refunded',
  Unrequired = 'unrequired',
  Skipped = 'skipped',
}

/** AssociationViolationDto */
export interface AssociationViolationDto {
  id: string;
  portfolioId: string;
  propertyId: string;
  unitId?: string;
  leaseId?: string;
  status: AssociationViolationStatus;
  hoaVendorId: string;
  reference: string;
  /** @format date */
  violationReceivedDate: string;
  /** @format date */
  violationDate: string;
  /** @format date */
  fixByDate?: string;
  /** @format double */
  associationFine?: number;
  title: string;
  description: string;
  /** @format date-time */
  notificationSentAt?: string;
  files: FileDto[];
  propertyFineBill?: BillDto;
  leaseFineBill?: BillDto;
  portfolio: PortfolioDto;
  property: PropertyDto;
  unit?: UnitDto;
  lease?: LeaseDto;
  workOrders: WorkOrderListDto[];
  leaseBills: BillDto[];
  owners: OwnerDto[];
  workOrderVendors: VendorDto[];
}

/** AssociationViolationListDto */
export interface AssociationViolationListDto {
  id: string;
  portfolioId: string;
  propertyId: string;
  unitId?: string;
  leaseId?: string;
  status: AssociationViolationStatus;
  hoaVendorId: string;
  reference: string;
  /** @format date */
  violationReceivedDate: string;
  /** @format date */
  violationDate: string;
  /** @format date */
  fixByDate?: string;
  /** @format double */
  associationFine?: number;
  title: string;
  description: string;
  /** @format date-time */
  notificationSentAt?: string;
}

/** AssociationViolationStatus */
export enum AssociationViolationStatus {
  Received = 'received',
  InProgress = 'inProgress',
  Resolved = 'resolved',
}

/** AuthResultDto */
export interface AuthResultDto {
  success: boolean;
  companies?: CompanyOptionDto[];
  interactionCode?: string;
}

/** AutoPayIncentiveType */
export enum AutoPayIncentiveType {
  None = 'none',
  Credit = 'credit',
}

/** AutoPayIncentivesSettingsDto */
export interface AutoPayIncentivesSettingsDto {
  incentiveType: AutoPayIncentiveType;
  /** @format double */
  minimalPayment: number;
  /** @format int32 */
  maxIncentivePerMonth: number;
  /** @format double */
  creditAmount: number;
  creditIsCompanyBill: boolean;
  creditChartOfAccount: string;
  creditDescription: string;
}

/** AutoPayIncentivesSettingsDtoSettingsWithOverrideDto */
export interface AutoPayIncentivesSettingsDtoSettingsWithOverrideDto {
  settings?: AutoPayIncentivesSettingsDto;
  level: SettingsLevel;
  levelId: string;
}

/** AutoPayIncentivesSettingsDtoSettingsWithOverridesDto */
export interface AutoPayIncentivesSettingsDtoSettingsWithOverridesDto {
  settings?: AutoPayIncentivesSettingsDto;
  overrides: AutoPayIncentivesSettingsDtoSettingsWithOverrideDto[];
}

/** AvailablePhoneNumberDto */
export interface AvailablePhoneNumberDto {
  phoneNumber: string;
  /** @format double */
  monthlyCost: number;
  /** @format double */
  upfrontCost: number;
}

/** AvailablePhoneNumbersDto */
export interface AvailablePhoneNumbersDto {
  phoneNumbers: AvailablePhoneNumberDto[];
}

/** BalanceSheetReportDataDto */
export interface BalanceSheetReportDataDto {
  groupHeaders: ReportGroupHeader[];
  assets: ChartOfAccountReportLineDto[];
  totalAssets: Record<string, number>;
  liabilities: ChartOfAccountReportLineDto[];
  totalLiabilities: Record<string, number>;
  capital: ChartOfAccountReportLineDto[];
  totalCapital: Record<string, number>;
}

/** BankAccountActivityDto */
export interface BankAccountActivityDto {
  /** @format date-time */
  date: string;
  payeeOrPayerName: string;
  transactionIdentity: TransactionIdentity;
  transactionPaymentMethod: TransactionPaymentMethod;
  transactionStatus: TransactionStatus;
  externalTransactionType?: ExternalTransactionType;
  externalTransactionId?: string;
  failureReason?: TransactionFailure;
  /** @format double */
  cashIn?: number;
  /** @format double */
  cashOut?: number;
  /** @format double */
  balance: number;
  description?: string;
  companyBill: boolean;
  cleared: boolean;
}

/** BankAccountActivityReportDto */
export interface BankAccountActivityReportDto {
  account: BankAccountDto;
  dateRange: DateRangeDto;
  /** @format double */
  startingBalance: number;
  /** @format double */
  netChange: number;
  activities: BankAccountActivityDto[];
  activitiesTotal: BankAccountActivityTotalDto;
}

/** BankAccountActivityTotalDto */
export interface BankAccountActivityTotalDto {
  /** @format double */
  cashIn: number;
  /** @format double */
  cashOut: number;
}

/** BankAccountConnectType */
export enum BankAccountConnectType {
  Plaid = 'plaid',
  Stripe = 'stripe',
}

/** BankAccountConnectionBalance */
export interface BankAccountConnectionBalance {
  /** @format double */
  available: number;
  /** @format double */
  pending: number;
}

/** BankAccountConnectionBalanceDto */
export interface BankAccountConnectionBalanceDto {
  /** @format double */
  available: number;
  /** @format double */
  pending: number;
}

/** BankAccountConnectionStatus */
export enum BankAccountConnectionStatus {
  Incomplete = 'incomplete',
  Pending = 'pending',
  Approved = 'approved',
  Denied = 'denied',
}

/** BankAccountConnectionsDto */
export interface BankAccountConnectionsDto {
  plaid: BankAccountPlaidConnectionDto;
  stripe: BankAccountStripeConnectionDto;
}

/** BankAccountDto */
export interface BankAccountDto {
  id: string;
  name: string;
  description?: string;
  active: boolean;
  accountNumber?: string;
  routingNumber?: string;
  type?: BankAccountType;
  scheduleSweepDays: number[];
}

/** BankAccountPlaidConnectionDto */
export interface BankAccountPlaidConnectionDto {
  eligible: boolean;
  status?: BankAccountConnectionStatus;
  balance?: BankAccountConnectionBalanceDto;
  notEligibleReason?: string;
  deniedReason?: string;
  externalAccountId?: string;
  limits?: PlaidTransferLimitsDto;
}

/** BankAccountStripeConnectionDto */
export interface BankAccountStripeConnectionDto {
  eligible: boolean;
  status?: BankAccountConnectionStatus;
  balance?: BankAccountConnectionBalanceDto;
  notEligibleReason?: string;
  deniedReason?: string;
  externalAccountId?: string;
}

/** BankAccountSweepLimitsDto */
export interface BankAccountSweepLimitsDto {
  /** @format int32 */
  interval: number;
}

/** BankAccountType */
export enum BankAccountType {
  Checking = 'checking',
  Savings = 'savings',
}

/** BankRoutingDto */
export interface BankRoutingDto {
  bankName: string;
  routingNumber: string;
  accountNumber: string;
  type: BankAccountType;
}

/** BatchCreateOwnerTaxDocumentDto */
export interface BatchCreateOwnerTaxDocumentDto {
  taxAmounts?: OwnerTaxDocumentAmountDto[];
}

/** BatchCreateTaxDocumentDto */
export interface BatchCreateTaxDocumentDto {
  taxAmounts?: CreateTaxDocumentAmountDto[];
}

/** BillAllocationDto */
export interface BillAllocationDto {
  transactionId: string;
  /** @format double */
  amount: number;
  /** @format date-time */
  paymentDate: string;
}

/** BillDto */
export interface BillDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  companyCharge: boolean;
  identity: BillIdentity;
  direction: CreditDebitDirection;
  /** @minLength 1 */
  reference?: string;
  /** @minLength 1 */
  memo?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  unitId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  portfolioId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  vendorId?: string;
  /** @format date */
  billDate: string;
  /** @format date */
  dueDate: string;
  /** @format double */
  totalAmount: number;
  /** @format double */
  paid: number;
  /** @format double */
  due: number;
  lineItems: BillLineItemDto[];
  recurringChargeId?: string;
  creator: CreatorDto;
}

/** BillFileDto */
export interface BillFileDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  fileId: string;
  fileName: string;
  signedUrl: string;
  signedThumbUrl?: string;
  /** @format int64 */
  fileSize: number;
  /** @format date-time */
  uploaded: string;
  description?: string;
}

/** BillIdentity */
export enum BillIdentity {
  Lease = 'lease',
  Vendor = 'vendor',
  MagicDoor = 'magicDoor',
  RentalApplication = 'rentalApplication',
  ProcessingFee = 'processingFee',
  ManagementFee = 'managementFee',
  LeaseDeposit = 'leaseDeposit',
  OwnerTransfer = 'ownerTransfer',
  ServiceBill = 'serviceBill',
  CompanyPropertyCredit = 'companyPropertyCredit',
}

/** BillLineItemBaseDto */
export interface BillLineItemBaseDto {
  chartOfAccountId: string;
  /** @minLength 1 */
  description?: string;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  amount: number;
}

/** BillLineItemDto */
export interface BillLineItemDto {
  chartOfAccountId: string;
  /** @minLength 1 */
  description?: string;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  amount: number;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  paid: number;
  allocations?: BillAllocationDto[];
}

/** BillPayProperty */
export interface BillPayProperty {
  property: PropertyDto;
  /** @format double */
  availableBalance: number;
  defaultBankAccountId?: string;
  bills: BillDto[];
}

/** BuyPhoneNumberRequestDto */
export interface BuyPhoneNumberRequestDto {
  /**
   * @minLength 10
   * @maxLength 13
   * @pattern ^\+{0,1}\d{0,1}\d{10}$
   */
  phoneNumber: string;
}

/** CalculateManagementFeesDto */
export interface CalculateManagementFeesDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyIds?: string[];
  managementFeeDate: ManagementFeeDate;
}

/** CalculatedDistributionsForPropertiesDto */
export interface CalculatedDistributionsForPropertiesDto {
  properties: CalculatedDistributionsForPropertyDto[];
}

/** CalculatedDistributionsForPropertyDto */
export interface CalculatedDistributionsForPropertyDto {
  property: PropertyDto;
  defaultBankAccountId?: string;
  /** @format double */
  currentPropertyBalance: number;
  /** @format double */
  propertyReserve: number;
  /** @format double */
  propertyBalance: number;
  /** @format double */
  availableForDistribution: number;
  defaultMemo: string;
  distributionOwners: DistributionOwnerDto[];
}

/** CannotSendTextMessagesReason */
export enum CannotSendTextMessagesReason {
  HasNoPhoneNumber = 'hasNoPhoneNumber',
  TcrCampaignNotApproved = 'tcrCampaignNotApproved',
}

/** CarDto */
export interface CarDto {
  /**
   * @minLength 1
   * @maxLength 150
   */
  carMake: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  model: string;
  /** @format int32 */
  year?: number;
  /**
   * @minLength 0
   * @maxLength 100
   */
  licensePlate?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  stateRegistration?: string;
  color?: string;
}

/** CardType */
export enum CardType {
  DebitCard = 'debitCard',
  CreditCard = 'creditCard',
}

/** CashFlowGroupBy */
export enum CashFlowGroupBy {
  Total = 'total',
  Property = 'property',
  Portfolio = 'portfolio',
  Month = 'month',
  Quarter = 'quarter',
  Year = 'year',
}

/** CashFlowReportDto */
export interface CashFlowReportDto {
  groupHeaders: ReportGroupHeaderDto[];
  income: ChartOfAccountReportLineDto[];
  incomeTotal: Record<string, number>;
  expenses: ChartOfAccountReportLineDto[];
  expensesTotal: Record<string, number>;
  netIncome: Record<string, number>;
  otherItems: ChartOfAccountReportLineDto[];
  netOtherItems: Record<string, number>;
  cashFlow: Record<string, number>;
  beginningCash: Record<string, number>;
  endingCash: Record<string, number>;
}

/** ChargeAssociationFineToPropertyDto */
export interface ChargeAssociationFineToPropertyDto {
  /** @format date */
  dueDate?: string;
}

/** ChargeFrequency */
export enum ChargeFrequency {
  Monthly = 'monthly',
  Weekly = 'weekly',
  Daily = 'daily',
  Monthly2XSplit = 'monthly2XSplit',
  Quarterly = 'quarterly',
  Yearly = 'yearly',
}

/** ChartOfAccountDto */
export interface ChartOfAccountDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  parentId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  offsetChartOfAccountId?: string;
  /** @minLength 1 */
  name: string;
  /** @format int32 */
  number?: number;
  type: ChartOfAccountType;
  isDefault: boolean;
}

/** ChartOfAccountReportDto */
export interface ChartOfAccountReportDto {
  chartOfAccount: ChartOfAccountDto;
  lineItems: LineItemReportDto[];
  /** @format double */
  startingBalance: number;
  /** @format double */
  totalDebit: number;
  /** @format double */
  totalCredit: number;
  /** @format double */
  endingBalance: number;
  /** @format double */
  netChange: number;
}

/** ChartOfAccountReportLineDto */
export interface ChartOfAccountReportLineDto {
  chartOfAccount: ChartOfAccountDto;
  children: ChartOfAccountReportLineDto[];
  groups: Record<string, number>;
  groupTotal?: Record<string, number>;
}

/** ChartOfAccountType */
export enum ChartOfAccountType {
  Asset = 'asset',
  Equity = 'equity',
  Liability = 'liability',
  Revenue = 'revenue',
  Expense = 'expense',
  Capital = 'capital',
}

/** ChatAILeaseSettingsDto */
export interface ChatAILeaseSettingsDto {
  enabled: boolean;
  additionalInstructions: string;
}

/** ChatAILeaseSettingsDtoSettingsWithOverrideDto */
export interface ChatAILeaseSettingsDtoSettingsWithOverrideDto {
  settings?: ChatAILeaseSettingsDto;
  level: SettingsLevel;
  levelId: string;
}

/** ChatAILeaseSettingsDtoSettingsWithOverridesDto */
export interface ChatAILeaseSettingsDtoSettingsWithOverridesDto {
  settings?: ChatAILeaseSettingsDto;
  overrides: ChatAILeaseSettingsDtoSettingsWithOverrideDto[];
}

/** ChatAIMaintenanceRequestsSettingsDto */
export interface ChatAIMaintenanceRequestsSettingsDto {
  enabled: boolean;
  additionalInstructions: string;
}

/** ChatAIMaintenanceRequestsSettingsDtoSettingsWithOverrideDto */
export interface ChatAIMaintenanceRequestsSettingsDtoSettingsWithOverrideDto {
  settings?: ChatAIMaintenanceRequestsSettingsDto;
  level: SettingsLevel;
  levelId: string;
}

/** ChatAIMaintenanceRequestsSettingsDtoSettingsWithOverridesDto */
export interface ChatAIMaintenanceRequestsSettingsDtoSettingsWithOverridesDto {
  settings?: ChatAIMaintenanceRequestsSettingsDto;
  overrides: ChatAIMaintenanceRequestsSettingsDtoSettingsWithOverrideDto[];
}

/** ChatCreateResponseDto */
export interface ChatCreateResponseDto {
  chatId?: string;
  failureReason?: string;
}

/** ChatMessageDto */
export interface ChatMessageDto {
  id: string;
  chatId: string;
  messageType: MessageType;
  participantId?: string;
  message?: string;
  messageLanguage?: string;
  translatedMessage?: string;
  translatedMessageLanguage?: string;
  translatedFailed: boolean;
  aiEnhanced: boolean;
  /** @format date-time */
  sentAt: string;
  sendText: boolean;
  textStatus?: TextStatus;
  /** @format date-time */
  textSentAt?: string;
  /** @format date-time */
  textDeliveredAt?: string;
  textSendStatuses?: Record<string, string>;
  textFailedReason?: string;
  sendEmail: boolean;
  source: MessageSource;
  files: ChatMessageFileDto[];
  read: boolean;
  /** @format date-time */
  readAt?: string;
  emailStatus?: EmailStatus;
  /** @format date-time */
  emailSentAt?: string;
  /** @format date-time */
  emailDeliveredAt?: string;
}

/** ChatMessageFileDto */
export interface ChatMessageFileDto {
  id: string;
  fileName: string;
  fileExtension: string;
  fileUrl: string;
  thumbUrl?: string;
  contentType: string;
  /** @format int64 */
  fileSize: number;
}

/** ChatMessagesDto */
export interface ChatMessagesDto {
  /** @format int32 */
  totalCount: number;
  messages: ChatMessageDto[];
}

/** ChatParticipantType */
export enum ChatParticipantType {
  Tenant = 'tenant',
  Unknown = 'unknown',
  Vendor = 'vendor',
  PropertyManager = 'propertyManager',
  Company = 'company',
  Owner = 'owner',
}

/** ChatSettingsDto */
export interface ChatSettingsDto {
  personalChats: boolean;
  enableTranslation: boolean;
  quitHours?: TimeRange;
}

/** ChatTypes */
export enum ChatTypes {
  Lease = 'lease',
  Tenant = 'tenant',
  Vendor = 'vendor',
  MaintenanceRequest = 'maintenanceRequest',
  WorkOrder = 'workOrder',
  WorkOrderGroup = 'workOrderGroup',
  Unknown = 'unknown',
  Owner = 'owner',
}

/** CheckBillPaymentDto */
export interface CheckBillPaymentDto {
  billId?: string;
  data: Record<string, string | null>;
  /** @format double */
  amount: number;
}

/** CheckDto */
export interface CheckDto {
  id: string;
  companyId: string;
  /** @format int32 */
  checkNumber: number;
  vendorId?: string;
  ownerId?: string;
  bankAccountId: string;
  /** @format double */
  amount: number;
  memo?: string;
  /** @format date-time */
  createdOn: string;
  /** @format date-time */
  date: string;
  transactionId?: string;
  billPayments: CheckBillPaymentDto[];
  dataHeaders: string[];
  voided: boolean;
  voidReason?: string;
  amountString: string;
}

/** CheckIdentity */
export enum CheckIdentity {
  VendorBill = 'vendorBill',
  OwnerDistribution = 'ownerDistribution',
  CompanyPayOut = 'companyPayOut',
  LeaseBalanceRelease = 'leaseBalanceRelease',
}

/** CheckScreeningStatusResultDto */
export interface CheckScreeningStatusResultDto {
  isScreeningComplete: boolean;
  status: ScreeningStatus;
  /** @format int32 */
  transunionScreeningRequestId?: number;
  /** @format int32 */
  transunionScreeningRequestRenterId?: number;
}

/** ClientVersionInfoDto */
export interface ClientVersionInfoDto {
  app: App;
  platform: Platform;
  appVersion: string;
  status?: VersionStatus;
}

/** CommentSection */
export enum CommentSection {
  ApplicantInformation = 'applicantInformation',
  PotentialUnits = 'potentialUnits',
  RentalHistory = 'rentalHistory',
  WorkHistory = 'workHistory',
  Pets = 'pets',
  Cars = 'cars',
  Questions = 'questions',
  TermsAndConditions = 'termsAndConditions',
  Payment = 'payment',
  Screening = 'screening',
  Other = 'other',
}

/** CompanyBusinessInfoDto */
export interface CompanyBusinessInfoDto {
  id: string;
  legalName: string;
  status: CompanyBusinessInfoStatus;
  rejectedReason?: string;
  isPrimary: boolean;
}

/** CompanyBusinessInfoStatus */
export enum CompanyBusinessInfoStatus {
  Pending = 'pending',
  Approved = 'approved',
  Rejected = 'rejected',
}

/** CompanyChargeService */
export enum CompanyChargeService {
  AchReturnFee = 'achReturnFee',
  AchFailedProcessingFee = 'achFailedProcessingFee',
  AchTenantProcessingFee = 'achTenantProcessingFee',
  AchOutgoingProcessingFee = 'achOutgoingProcessingFee',
  TransunionScreening = 'transunionScreening',
  Subscription = 'subscription',
  TcrCampaign = 'tcrCampaign',
  DisputeAmount = 'disputeAmount',
  DisputeProcessingFee = 'disputeProcessingFee',
}

/** CompanyDomainDto */
export interface CompanyDomainDto {
  /** @pattern ^[a-z0-9][a-z0-9-]+(\.[a-z0-9][a-z0-9-]+)*\.[a-z]{2,}$ */
  domain?: string;
}

/** CompanyDto */
export interface CompanyDto {
  id: string;
  name: string;
  email: string;
  subUrl: string;
  language: string;
  phoneNumber?: string;
  timeZoneInfo: string;
  customDomain?: string;
  address: AddressDto;
  onboarded: boolean;
  onboardingStatus?: string;
  publicUrl: string;
}

/** CompanyInvoiceAllocationDto */
export interface CompanyInvoiceAllocationDto {
  transaction: TransactionDto;
  /** @format double */
  amount: number;
  /** @format date-time */
  paymentDate: string;
}

/** CompanyInvoiceChargeDto */
export interface CompanyInvoiceChargeDto {
  service: CompanyChargeService;
  /** @format double */
  amount: number;
  /** @format date-time */
  chargeTime: string;
  /** @format date-time */
  dueTime: string;
  description: string;
  billId: string;
  metadata?: Record<string, string>;
}

/** CompanyInvoiceDto */
export interface CompanyInvoiceDto {
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format double */
  totalAmount: number;
  /** @format double */
  allocated: number;
  /** @format double */
  due: number;
  summaries: CompanyInvoiceSummaryDto[];
  charges: CompanyInvoiceChargeDto[];
  allocations: CompanyInvoiceAllocationDto[];
  file?: FileDto;
}

/** CompanyInvoiceSummaryDto */
export interface CompanyInvoiceSummaryDto {
  service: CompanyChargeService;
  /** @format int32 */
  itemCount: number;
  /** @format double */
  itemTotal: number;
}

/** CompanyOptionDto */
export interface CompanyOptionDto {
  id: string;
  name: string;
}

/** CompanyPayOutBankAccountDto */
export interface CompanyPayOutBankAccountDto {
  bankAccount: BankAccountDto;
  /** @format double */
  amount: number;
  lineItems: LineItemDto[];
}

/** CompanyPayOutDto */
export interface CompanyPayOutDto {
  /** @format date-time */
  lastRun?: string;
  bankAccountPayOuts: CompanyPayOutBankAccountDto[];
  chartOfAccounts: ChartOfAccountDto[];
}

/** CompanyPaymentsDto */
export interface CompanyPaymentsDto {
  hasRentPayments: boolean;
}

/** CompanyPhoneNumberStatusDto */
export interface CompanyPhoneNumberStatusDto {
  canSend: boolean;
  forbiddenReason?: CannotSendTextMessagesReason;
  chatPhoneNumber?: string;
}

/** CompanySettingsDto */
export interface CompanySettingsDto {
  workHours: TimeRange;
  /** @minLength 1 */
  subscriptionChartOfAccountId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  invoiceBankAccountId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  invoicePaymentAccountId?: string;
}

/** CompanyStatusDto */
export interface CompanyStatusDto {
  phoneNumberSettled: boolean;
  businessInfoSubmitted: boolean;
  hasBankAccounts: boolean;
  plaidConnected: boolean;
  stripeConnected: boolean;
  hasPaymentAccounts: boolean;
  invoiceSettingsConfigured: boolean;
  rentPaymentSettingsConfigured: boolean;
  depositPaymentSettingsConfigured: boolean;
  rentalApplicationSettingsConfigured: boolean;
}

/** CompanySubUrlDto */
export interface CompanySubUrlDto {
  /**
   * @minLength 3
   * @maxLength 150
   * @pattern ^[a-z0-9][a-z0-9-_]+$
   */
  url: string;
}

/** ConditionDto */
export interface ConditionDto {
  type: string;
  operator: ConditionOperator;
}

/** ConditionGroupDto */
export interface ConditionGroupDto {
  operator: LogicalOperator;
  /** @minItems 1 */
  conditions: (
    | RentAmountConditionDto
    | TenantCountConditionDto
    | MaintenanceRequestCountConditionDto
    | LatePaymentCountConditionDto
    | LeaseBalanceConditionDto
    | SecurityDepositConditionDto
  )[];
}

/** ConditionOperator */
export enum ConditionOperator {
  LessThan = 'lessThan',
  LessThanOrEqual = 'lessThanOrEqual',
  Equal = 'equal',
  GreaterThanOrEqual = 'greaterThanOrEqual',
  GreaterThan = 'greaterThan',
  NotEqual = 'notEqual',
}

/** ConnectBankAccountDto */
export interface ConnectBankAccountDto {
  /**
   * Required for Plaid connection
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   * @minItems 2
   */
  statementFileIds?: string[];
  /**
   * Only applicable for Plaid connection, if not provided, will use the primary company business info
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  companyBusinessInfoId?: string;
  /** Only applicable for Stripe connection, if true, will return a client secret for embedding the Stripe onboarding page, otherwise will return a link to the Stripe onboarding page */
  isEmbedded?: boolean;
}

/** ConnectBankAccountResultDto */
export interface ConnectBankAccountResultDto {
  /** Stripe hosted onboarding link */
  link?: string;
  /** Stripe embedded onboarding client secret */
  clientSecret?: string;
}

/** ContactDto */
export interface ContactDto {
  /**
   * @minLength 10
   * @maxLength 13
   * @pattern ^\+{0,1}\d{0,1}\d{10}$
   */
  phone?: string;
  /**
   * @format email
   * @minLength 1
   * @maxLength 250
   */
  email?: string;
  address?: AddressDto;
}

/** ContactPhoneEmailDto */
export interface ContactPhoneEmailDto {
  /**
   * @minLength 10
   * @maxLength 13
   * @pattern ^\+{0,1}\d{0,1}\d{10}$
   */
  phone?: string;
  /**
   * @format email
   * @minLength 1
   * @maxLength 250
   */
  email?: string;
}

/** ContributionSettingsDto */
export interface ContributionSettingsDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  contributionChartOfAccountId: string;
}

/** ContributionSettingsDtoSettingsWithOverrideDto */
export interface ContributionSettingsDtoSettingsWithOverrideDto {
  settings?: ContributionSettingsDto;
  level: SettingsLevel;
  levelId: string;
}

/** ContributionSettingsDtoSettingsWithOverridesDto */
export interface ContributionSettingsDtoSettingsWithOverridesDto {
  settings?: ContributionSettingsDto;
  overrides: ContributionSettingsDtoSettingsWithOverrideDto[];
}

/** CopyLeaseTemplateDto */
export interface CopyLeaseTemplateDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  fromLeaseTemplateId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseTemplateCategoryId: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  name: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  description?: string;
}

/** CreateAssociationViolationRequestDto */
export interface CreateAssociationViolationRequestDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  unitId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseId?: string;
  status?: AssociationViolationStatus;
  /**
   * @minLength 0
   * @maxLength 150
   */
  reference?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  hoaVendorId: string;
  /** @format date */
  violationReceivedDate: string;
  /** @format date */
  violationDate: string;
  /** @format date */
  fixByDate?: string;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  associationFine?: number;
  /**
   * @minLength 0
   * @maxLength 150
   */
  title?: string;
  description: string;
}

/** CreateBankAccountDto */
export interface CreateBankAccountDto {
  /**
   * @minLength 1
   * @maxLength 150
   */
  name: string;
  /**
   * @minLength 1
   * @maxLength 500
   */
  description?: string;
  type: BankAccountType;
  scheduleSweepDays?: number[];
  /**
   * A valid 4 to 17 digit account number.
   * @minLength 1
   * @pattern ^[0-9]{4,17}$
   */
  accountNumber: string;
  /**
   * A valid 9-digit bank routing number.
   * @minLength 1
   * @pattern ^[0-9]{9}$
   */
  routingNumber: string;
}

/** CreateChartOfAccountDto */
export interface CreateChartOfAccountDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  parentId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  offsetChartOfAccountId?: string;
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  number?: number;
  /**
   * @minLength 1
   * @maxLength 150
   */
  name: string;
  type: ChartOfAccountType;
}

/** CreateCompanyBusinessInfoDto */
export interface CreateCompanyBusinessInfoDto {
  /**
   * @minLength 0
   * @maxLength 150
   */
  legalName: string;
  /**
   * A valid SSN or EIN.
   * @minLength 9
   * @maxLength 11
   * @pattern ^(\d{3}-?\d{2}-?\d{4}|\d{9}|\d{2}-?\d{7})$
   */
  ein: string;
  legalEntityType: LegalEntityType;
  businessAddress: RequiredAddressDto;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  businessNameFileId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  businessAddressFileId: string;
  /** @minLength 1 */
  irsFileId: string;
  /** @minItems 1 */
  principals: UpdateCompanyPrincipalDto[];
}

/** CreateCompanyPaymentAccountDto */
export interface CreateCompanyPaymentAccountDto {
  /**
   * Required for ACH accounts
   * @minLength 3
   * @maxLength 100
   */
  bankName?: string;
  /**
   * A valid 9-digit bank routing number.
   * @pattern ^[0-9]{9}$
   */
  routingNumber?: string;
  /**
   * A valid 4 to 17 digit account number.
   * @pattern ^[0-9]{4,17}$
   */
  accountNumber?: string;
  /** Required for ACH accounts */
  accountType?: BankAccountType;
  /** Required for Stripe accounts */
  stripeSessionId?: string;
}

/** CreateCustomFieldDto */
export interface CreateCustomFieldDto {
  entityType: EntityType;
  /**
   * @minLength 1
   * @maxLength 100
   */
  name: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string;
  public: boolean;
  filterable: boolean;
  listable: boolean;
  /** @format int32 */
  order: number;
  options:
    | CustomStringFieldOptionsDto
    | CustomNumberFieldOptionsDto
    | CustomBooleanFieldOptionsDto
    | CustomDateTimeFieldOptionsDto
    | CustomReferenceFieldOptionsDto;
}

/** CreateDepositSlipsRequestDto */
export interface CreateDepositSlipsRequestDto {
  transactionIds: string[];
}

/** CreateLeaseChargeDto */
export interface CreateLeaseChargeDto {
  /** @format date */
  dueDate: string;
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount: number;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  chartOfAccountId: string;
  /** @minLength 1 */
  description?: string;
  companyCharge: boolean;
}

/** CreateLeaseCreditDto */
export interface CreateLeaseCreditDto {
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount: number;
  /** @minLength 1 */
  chartOfAccountId: string;
  description?: string;
  /** @format date */
  issueDate: string;
}

/** CreateLeaseDto */
export interface CreateLeaseDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  unitId: string;
  /** @format date */
  start: string;
  /** @format date */
  end?: string;
  monthToMonth: boolean;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  tenantIds: string[];
  rent: LeaseChargeDto;
  otherCharges?: LeaseChargeDto[];
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  proratedAmount?: number;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  deposit?: number;
  draft: boolean;
  fromType?: LeaseFromType;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  fromEntityId?: number;
}

/** CreateLeaseRecurringOfflinePaymentDto */
export interface CreateLeaseRecurringOfflinePaymentDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  tenantId: string;
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount: number;
  chargeFrequency: ChargeFrequency;
  /** @format date */
  startFrom: string;
  /** @format date */
  end?: string;
  /** @minLength 1 */
  description?: string;
  paymentMethod?: OfflineTransactionPaymentMethod;
  /**
   * @minLength 0
   * @maxLength 150
   */
  reference?: string;
  createPastPayments: boolean;
}

/** CreateLeaseRenewalOfferAutomaticSettingDto */
export interface CreateLeaseRenewalOfferAutomaticSettingDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  portfolioId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId?: string;
  /**
   * @format int32
   * @min 1
   * @max 365
   */
  addDaysBefore?: number;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  rentIncrease?: number;
  /**
   * @format int32
   * @min 1
   * @max 60
   */
  newLeaseLengthMonths?: number;
  newRecurringCharges?: NewRecurringChargeDto[];
  conditions?: ConditionGroupDto[];
  sendTenantNotifyOnRenewal?: boolean;
  leaseTemplateIds?: string[];
}

/** CreateLeaseRenewalOfferDto */
export interface CreateLeaseRenewalOfferDto {
  /** @format date */
  newEndDate?: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  customLeaseText?: string;
  recurringChargeChanges: RecurringChargeChangeDto[];
  newRecurringCharges?: NewRecurringChargeDto[];
  /** @format date-time */
  offerExpires?: string;
  requiresSigning: boolean;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseTemplateIds?: string[];
}

/** CreateLeaseRentersInsuranceDto */
export interface CreateLeaseRentersInsuranceDto {
  /**
   * @minLength 1
   * @maxLength 200
   */
  carrierName: string;
  /**
   * @minLength 1
   * @maxLength 200
   */
  policyNumber?: string;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  coverageAmount?: number;
  /** @format date */
  policyStartDate?: string;
  /** @format date */
  policyEndDate?: string;
  /** @format date */
  policyCanceledDate?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  insurancePolicyFileId?: string;
  /**
   * @minLength 1
   * @maxLength 100
   */
  externalIdentifier?: string;
  source?: LeaseRentersInsuranceSource;
}

/** CreateLeaseTemplateCategoryDto */
export interface CreateLeaseTemplateCategoryDto {
  /**
   * @minLength 0
   * @maxLength 150
   */
  name: string;
}

/** CreateMaintenanceRequestCategoryDto */
export interface CreateMaintenanceRequestCategoryDto {
  /**
   * @minLength 0
   * @maxLength 150
   */
  name: string;
  /**
   * @minLength 0
   * @maxLength 2000
   */
  description?: string;
}

/** CreateMaintenanceRequestDto */
export interface CreateMaintenanceRequestDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  requesterId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  assignedPropertyManagerId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseId: string;
  files?: UpdateMaintenanceRequestFileDto[];
  /** @minLength 1 */
  description: string;
  /** @minLength 1 */
  internalDescription?: string;
  status: MaintenanceRequestStatus;
  urgency: Urgency;
  permissionToEnter: boolean;
  disableAi: boolean;
  /** @format date */
  due?: string;
}

/** CreateMeetingScheduleDto */
export interface CreateMeetingScheduleDto {
  /**
   * @minLength 0
   * @maxLength 200
   */
  title: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  description?: string;
  /**
   * @minLength 0
   * @maxLength 200
   */
  link?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  externalProvider?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  externalIdentifier?: string;
  /** @format date-time */
  startTime: string;
  /** @format date-time */
  startTimeUtc?: string;
  /** @format date-time */
  endTime: string;
  /** @format date-time */
  endTimeUtc?: string;
  /** @format date-time */
  cancelled?: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  cancellationReason?: string;
  source: MeetingScheduleSource;
}

/** CreateNotificationScheduleDto */
export interface CreateNotificationScheduleDto {
  target: TenantNotificationTargetDto;
  template: NotificationTemplateDto;
  /** @format date-time */
  time: string;
}

/** CreateOrUpdateNoteDto */
export interface CreateOrUpdateNoteDto {
  /** @minLength 1 */
  content: string;
}

/** CreateOrUpdatePortfolioDto */
export interface CreateOrUpdatePortfolioDto {
  /**
   * @minLength 1
   * @maxLength 150
   */
  name: string;
  icons?: string[];
}

/** CreateOrUpdateRentalApplicationDto */
export interface CreateOrUpdateRentalApplicationDto {
  /**
   * @minLength 1
   * @maxLength 20
   */
  password?: string;
  /**
   * @minLength 2
   * @maxLength 150
   */
  firstName?: string;
  /**
   * @minLength 2
   * @maxLength 150
   */
  lastName?: string;
  /**
   * A valid email address.
   * @minLength 0
   * @maxLength 250
   * @pattern ^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$
   */
  email?: string;
  /**
   * @minLength 10
   * @maxLength 13
   * @pattern ^\+{0,1}\d{0,1}\d{10}$
   */
  phone?: string;
  /**
   * A valid SSN or EIN.
   * @minLength 9
   * @maxLength 11
   * @pattern ^(\d{3}-?\d{2}-?\d{4}|\d{9}|\d{2}-?\d{7})$
   */
  ssn?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  tenantId?: string;
  /**
   * Date of birth of the renter. Must be between 18 and 125 years old.
   * @format date
   */
  dateOfBirth?: string;
  applyingWith?: string[];
  /** @format date */
  desiredMoveInDate?: string;
  maritalStatus?: MaritalStatus;
  driversLicense?: DriversLicenseDto;
  incomeInformation?: IncomeInformationDto;
  pets?: PetDto[];
  cars?: CarDto[];
  residentialHistory?: ResidentialHistoryDto[];
  emergencyContact?: EmergencyContactDto;
  employment?: RentalApplicationEmploymentDto[];
  comments?: RentalApplicationCommentDto[];
  questions?: Record<string, string>;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  interestedUnitIds?: string[];
  files?: UpdateRentalApplicationFileDto[];
  lastStep?: RentalApplicationStep;
}

/** CreateOrUpdateVendorDto */
export interface CreateOrUpdateVendorDto {
  /**
   * @minLength 1
   * @maxLength 200
   */
  name: string;
  /**
   * @minLength 2
   * @maxLength 2
   */
  language:
    | 'aa'
    | 'ab'
    | 'ae'
    | 'af'
    | 'ak'
    | 'am'
    | 'an'
    | 'ar'
    | 'as'
    | 'av'
    | 'ay'
    | 'az'
    | 'ba'
    | 'be'
    | 'bg'
    | 'bh'
    | 'bi'
    | 'bm'
    | 'bn'
    | 'bo'
    | 'br'
    | 'bs'
    | 'ca'
    | 'ce'
    | 'ch'
    | 'co'
    | 'cr'
    | 'cs'
    | 'cu'
    | 'cv'
    | 'cy'
    | 'da'
    | 'de'
    | 'dv'
    | 'dz'
    | 'ee'
    | 'el'
    | 'en'
    | 'eo'
    | 'es'
    | 'et'
    | 'eu'
    | 'fa'
    | 'ff'
    | 'fi'
    | 'fj'
    | 'fo'
    | 'fr'
    | 'fy'
    | 'ga'
    | 'gd'
    | 'gl'
    | 'gn'
    | 'gu'
    | 'gv'
    | 'ha'
    | 'he'
    | 'hi'
    | 'ho'
    | 'hr'
    | 'ht'
    | 'hu'
    | 'hy'
    | 'hz'
    | 'ia'
    | 'id'
    | 'ie'
    | 'ig'
    | 'ii'
    | 'ik'
    | 'io'
    | 'is'
    | 'it'
    | 'iu'
    | 'ja'
    | 'jv'
    | 'ka'
    | 'kg'
    | 'ki'
    | 'kj'
    | 'kk'
    | 'kl'
    | 'km'
    | 'kn'
    | 'ko'
    | 'kr'
    | 'ks'
    | 'ku'
    | 'kv'
    | 'kw'
    | 'ky'
    | 'la'
    | 'lb'
    | 'lg'
    | 'li'
    | 'ln'
    | 'lo'
    | 'lt'
    | 'lu'
    | 'lv'
    | 'mg'
    | 'mh'
    | 'mi'
    | 'mk'
    | 'ml'
    | 'mn'
    | 'mr'
    | 'ms'
    | 'mt'
    | 'my'
    | 'na'
    | 'nb'
    | 'nd'
    | 'ne'
    | 'ng'
    | 'nl'
    | 'nn'
    | 'no'
    | 'nr'
    | 'nv'
    | 'ny'
    | 'oc'
    | 'oj'
    | 'om'
    | 'or'
    | 'os'
    | 'pa'
    | 'pi'
    | 'pl'
    | 'ps'
    | 'pt'
    | 'qu'
    | 'rm'
    | 'rn'
    | 'ro'
    | 'ru'
    | 'rw'
    | 'sa'
    | 'sc'
    | 'sd'
    | 'se'
    | 'sg'
    | 'si'
    | 'sk'
    | 'sl'
    | 'sm'
    | 'sn'
    | 'so'
    | 'sq'
    | 'sr'
    | 'ss'
    | 'st'
    | 'su'
    | 'sv'
    | 'sw'
    | 'ta'
    | 'te'
    | 'tg'
    | 'th'
    | 'ti'
    | 'tk'
    | 'tl'
    | 'tn'
    | 'to'
    | 'tr'
    | 'ts'
    | 'tt'
    | 'tw'
    | 'ty'
    | 'ug'
    | 'uk'
    | 'ur'
    | 'uz'
    | 've'
    | 'vi'
    | 'vo'
    | 'wa'
    | 'wo'
    | 'xh'
    | 'yi'
    | 'yo'
    | 'za'
    | 'zh'
    | 'zu';
  contact?: ContactPhoneEmailDto;
  address?: AddressDto;
  /** @minLength 1 */
  memo?: string;
  /** @minLength 1 */
  website?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  categoryId?: string;
  irs1099Form?: FederalTaxInformationDto;
  insurancePolicy?: InsurancePolicyDto;
  icons?: string[];
  type: VendorType;
  defaultMemo?: string;
  paymentSettings?: PaymentSettingsDto;
  /**
   * @minLength 5
   * @maxLength 150
   */
  password?: string;
}

/** CreateOwnerDistributionDto */
export interface CreateOwnerDistributionDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId: string;
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  distributionAmount: number;
  /**
   * @minLength 0
   * @maxLength 250
   */
  memo?: string;
}

/** CreateOwnerDistributionsDto */
export interface CreateOwnerDistributionsDto {
  /** @minItems 1 */
  groups: CreateOwnerDistributionsGroupDto[];
}

/** CreateOwnerDistributionsGroupDto */
export interface CreateOwnerDistributionsGroupDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  ownerId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  bankAccountId: string;
  paymentType: PayBillType;
  /** Required if payment type is `Manual` */
  paymentMethod?: TransactionPaymentMethod;
  /**
   * Required if payment type is `Manual`
   * @minLength 0
   * @maxLength 100
   */
  externalTransactionId?: string;
  /**
   * Required if payment type is `ACH`
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  paymentAccountId?: string;
  /**
   * @minLength 0
   * @maxLength 250
   */
  memo?: string;
  distributions: CreateOwnerDistributionDto[];
}

/** CreateOwnerDto */
export interface CreateOwnerDto {
  /**
   * @minLength 1
   * @maxLength 150
   */
  firstName: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  lastName?: string;
  isCompany: boolean;
  /**
   * A valid email address.
   * @minLength 0
   * @maxLength 250
   * @pattern ^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$
   */
  email?: string;
  /**
   * @minLength 10
   * @maxLength 13
   * @pattern ^\+{0,1}\d{0,1}\d{10}$
   */
  phone?: string;
  federalTaxInformation?: FederalTaxInformationDto;
  /**
   * @minLength 2
   * @maxLength 2
   */
  language?:
    | 'aa'
    | 'ab'
    | 'ae'
    | 'af'
    | 'ak'
    | 'am'
    | 'an'
    | 'ar'
    | 'as'
    | 'av'
    | 'ay'
    | 'az'
    | 'ba'
    | 'be'
    | 'bg'
    | 'bh'
    | 'bi'
    | 'bm'
    | 'bn'
    | 'bo'
    | 'br'
    | 'bs'
    | 'ca'
    | 'ce'
    | 'ch'
    | 'co'
    | 'cr'
    | 'cs'
    | 'cu'
    | 'cv'
    | 'cy'
    | 'da'
    | 'de'
    | 'dv'
    | 'dz'
    | 'ee'
    | 'el'
    | 'en'
    | 'eo'
    | 'es'
    | 'et'
    | 'eu'
    | 'fa'
    | 'ff'
    | 'fi'
    | 'fj'
    | 'fo'
    | 'fr'
    | 'fy'
    | 'ga'
    | 'gd'
    | 'gl'
    | 'gn'
    | 'gu'
    | 'gv'
    | 'ha'
    | 'he'
    | 'hi'
    | 'ho'
    | 'hr'
    | 'ht'
    | 'hu'
    | 'hy'
    | 'hz'
    | 'ia'
    | 'id'
    | 'ie'
    | 'ig'
    | 'ii'
    | 'ik'
    | 'io'
    | 'is'
    | 'it'
    | 'iu'
    | 'ja'
    | 'jv'
    | 'ka'
    | 'kg'
    | 'ki'
    | 'kj'
    | 'kk'
    | 'kl'
    | 'km'
    | 'kn'
    | 'ko'
    | 'kr'
    | 'ks'
    | 'ku'
    | 'kv'
    | 'kw'
    | 'ky'
    | 'la'
    | 'lb'
    | 'lg'
    | 'li'
    | 'ln'
    | 'lo'
    | 'lt'
    | 'lu'
    | 'lv'
    | 'mg'
    | 'mh'
    | 'mi'
    | 'mk'
    | 'ml'
    | 'mn'
    | 'mr'
    | 'ms'
    | 'mt'
    | 'my'
    | 'na'
    | 'nb'
    | 'nd'
    | 'ne'
    | 'ng'
    | 'nl'
    | 'nn'
    | 'no'
    | 'nr'
    | 'nv'
    | 'ny'
    | 'oc'
    | 'oj'
    | 'om'
    | 'or'
    | 'os'
    | 'pa'
    | 'pi'
    | 'pl'
    | 'ps'
    | 'pt'
    | 'qu'
    | 'rm'
    | 'rn'
    | 'ro'
    | 'ru'
    | 'rw'
    | 'sa'
    | 'sc'
    | 'sd'
    | 'se'
    | 'sg'
    | 'si'
    | 'sk'
    | 'sl'
    | 'sm'
    | 'sn'
    | 'so'
    | 'sq'
    | 'sr'
    | 'ss'
    | 'st'
    | 'su'
    | 'sv'
    | 'sw'
    | 'ta'
    | 'te'
    | 'tg'
    | 'th'
    | 'ti'
    | 'tk'
    | 'tl'
    | 'tn'
    | 'to'
    | 'tr'
    | 'ts'
    | 'tt'
    | 'tw'
    | 'ty'
    | 'ug'
    | 'uk'
    | 'ur'
    | 'uz'
    | 've'
    | 'vi'
    | 'vo'
    | 'wa'
    | 'wo'
    | 'xh'
    | 'yi'
    | 'yo'
    | 'za'
    | 'zh'
    | 'zu';
  address?: AddressDto;
  /**
   * @minLength 5
   * @maxLength 150
   */
  password?: string;
}

/** CreateOwnerPaymentAccountDto */
export interface CreateOwnerPaymentAccountDto {
  /**
   * Required for ACH accounts
   * @minLength 3
   * @maxLength 100
   */
  bankName?: string;
  /**
   * A valid 9-digit bank routing number.
   * @pattern ^[0-9]{9}$
   */
  routingNumber?: string;
  /**
   * A valid 4 to 17 digit account number.
   * @pattern ^[0-9]{4,17}$
   */
  accountNumber?: string;
  /** Required for ACH accounts */
  accountType?: BankAccountType;
  /** Required for Stripe accounts */
  stripeSessionId?: string;
}

/** CreateOwnerTaxDocumentDto */
export interface CreateOwnerTaxDocumentDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  accountId: string;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  rentAmount: number;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  otherAmount: number;
}

/** CreatePhoneChatDto */
export interface CreatePhoneChatDto {
  /**
   * @minLength 10
   * @maxLength 13
   * @pattern ^\+{0,1}\d{0,1}\d{10}$
   */
  phoneNumber: string;
  /** @minLength 1 */
  participantName?: string;
  /** @minLength 1 */
  subject?: string;
}

/** CreatePropertyDto */
export interface CreatePropertyDto {
  /**
   * @minLength 1
   * @maxLength 150
   */
  name?: string;
  address: RequiredAddressDto;
  type: PropertyType;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  portfolioId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  imageId?: string;
  magicTags?: Record<string, string>;
  /**
   * @format int32
   * @min 1
   * @max 200
   */
  totalFloors?: number;
}

/** CreatePropertyManagerDto */
export interface CreatePropertyManagerDto {
  /**
   * @minLength 1
   * @maxLength 150
   */
  firstName: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  lastName?: string;
  /**
   * A valid email address.
   * @minLength 1
   * @pattern ^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$
   */
  email: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  clearTextPassword?: string;
}

/** CreateRecurringLeaseChargeDto */
export interface CreateRecurringLeaseChargeDto {
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount: number;
  chargeFrequency: ChargeFrequency;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  chartOfAccountId: string;
  /** @minLength 1 */
  description?: string;
  /** @format date */
  startFrom: string;
  /** @format date */
  end?: string;
  createPastCharges: boolean;
  companyCharge: boolean;
}

/** CreateRecurringVendorBillDto */
export interface CreateRecurringVendorBillDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  unitId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  vendorId: string;
  reference?: string;
  memo?: string;
  companyCharge: boolean;
  /** @format int32 */
  dueDays?: number;
  lineItems: BillLineItemBaseDto[];
  chargeFrequency: ChargeFrequency;
  /** @format date */
  startsFrom: string;
  /** @format date */
  ends?: string;
}

/** CreateRunBookDto */
export interface CreateRunBookDto {
  /** @maxLength 150 */
  title?: string;
  /** @maxLength 250 */
  description?: string;
  /** @minLength 50 */
  script: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  defaultVendorId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  defaultPropertyManagerId?: string;
}

/** CreateSyndicationDto */
export interface CreateSyndicationDto {
  /**
   * @minLength 1
   * @maxLength 200
   */
  name: string;
  /**
   * @minLength 1
   * @maxLength 200
   */
  website: string;
  type: SyndicationType;
  config?: Record<string, any>;
}

/** CreateTaxDocumentAmountDto */
export interface CreateTaxDocumentAmountDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  accountId: string;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  amount: number;
}

/** CreateTaxDocumentDto */
export interface CreateTaxDocumentDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  accountId: string;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  amount: number;
}

/** CreateTenantDto */
export interface CreateTenantDto {
  /**
   * @minLength 1
   * @maxLength 150
   */
  firstName: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  lastName?: string;
  /**
   * A valid email address.
   * @minLength 0
   * @maxLength 250
   * @pattern ^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$
   */
  email?: string;
  /**
   * @minLength 10
   * @maxLength 13
   * @pattern ^\+{0,1}\d{0,1}\d{10}$
   */
  phone?: string;
  /**
   * @minLength 5
   * @maxLength 150
   */
  password?: string;
  /**
   * @minLength 2
   * @maxLength 2
   */
  language?:
    | 'aa'
    | 'ab'
    | 'ae'
    | 'af'
    | 'ak'
    | 'am'
    | 'an'
    | 'ar'
    | 'as'
    | 'av'
    | 'ay'
    | 'az'
    | 'ba'
    | 'be'
    | 'bg'
    | 'bh'
    | 'bi'
    | 'bm'
    | 'bn'
    | 'bo'
    | 'br'
    | 'bs'
    | 'ca'
    | 'ce'
    | 'ch'
    | 'co'
    | 'cr'
    | 'cs'
    | 'cu'
    | 'cv'
    | 'cy'
    | 'da'
    | 'de'
    | 'dv'
    | 'dz'
    | 'ee'
    | 'el'
    | 'en'
    | 'eo'
    | 'es'
    | 'et'
    | 'eu'
    | 'fa'
    | 'ff'
    | 'fi'
    | 'fj'
    | 'fo'
    | 'fr'
    | 'fy'
    | 'ga'
    | 'gd'
    | 'gl'
    | 'gn'
    | 'gu'
    | 'gv'
    | 'ha'
    | 'he'
    | 'hi'
    | 'ho'
    | 'hr'
    | 'ht'
    | 'hu'
    | 'hy'
    | 'hz'
    | 'ia'
    | 'id'
    | 'ie'
    | 'ig'
    | 'ii'
    | 'ik'
    | 'io'
    | 'is'
    | 'it'
    | 'iu'
    | 'ja'
    | 'jv'
    | 'ka'
    | 'kg'
    | 'ki'
    | 'kj'
    | 'kk'
    | 'kl'
    | 'km'
    | 'kn'
    | 'ko'
    | 'kr'
    | 'ks'
    | 'ku'
    | 'kv'
    | 'kw'
    | 'ky'
    | 'la'
    | 'lb'
    | 'lg'
    | 'li'
    | 'ln'
    | 'lo'
    | 'lt'
    | 'lu'
    | 'lv'
    | 'mg'
    | 'mh'
    | 'mi'
    | 'mk'
    | 'ml'
    | 'mn'
    | 'mr'
    | 'ms'
    | 'mt'
    | 'my'
    | 'na'
    | 'nb'
    | 'nd'
    | 'ne'
    | 'ng'
    | 'nl'
    | 'nn'
    | 'no'
    | 'nr'
    | 'nv'
    | 'ny'
    | 'oc'
    | 'oj'
    | 'om'
    | 'or'
    | 'os'
    | 'pa'
    | 'pi'
    | 'pl'
    | 'ps'
    | 'pt'
    | 'qu'
    | 'rm'
    | 'rn'
    | 'ro'
    | 'ru'
    | 'rw'
    | 'sa'
    | 'sc'
    | 'sd'
    | 'se'
    | 'sg'
    | 'si'
    | 'sk'
    | 'sl'
    | 'sm'
    | 'sn'
    | 'so'
    | 'sq'
    | 'sr'
    | 'ss'
    | 'st'
    | 'su'
    | 'sv'
    | 'sw'
    | 'ta'
    | 'te'
    | 'tg'
    | 'th'
    | 'ti'
    | 'tk'
    | 'tl'
    | 'tn'
    | 'to'
    | 'tr'
    | 'ts'
    | 'tt'
    | 'tw'
    | 'ty'
    | 'ug'
    | 'uk'
    | 'ur'
    | 'uz'
    | 've'
    | 'vi'
    | 'vo'
    | 'wa'
    | 'wo'
    | 'xh'
    | 'yi'
    | 'yo'
    | 'za'
    | 'zh'
    | 'zu';
  /**
   * A valid SSN or EIN.
   * @minLength 9
   * @maxLength 11
   * @pattern ^(\d{3}-?\d{2}-?\d{4}|\d{9}|\d{2}-?\d{7})$
   */
  ssn?: string;
  driversLicense?: DriverLicenseDto;
  /** @format date */
  dateOfBirth?: string;
  gender?: Gender;
  currentAddress?: AddressDto;
  emergencyContacts?: EmergencyContactDto[];
  icons?: string[];
  sendPortalInvite?: boolean;
}

/** CreateTenantPaymentAccountDto */
export interface CreateTenantPaymentAccountDto {
  /**
   * Required for ACH accounts
   * @minLength 3
   * @maxLength 100
   */
  bankName?: string;
  /**
   * A valid 9-digit bank routing number.
   * @pattern ^[0-9]{9}$
   */
  routingNumber?: string;
  /**
   * A valid 4 to 17 digit account number.
   * @pattern ^[0-9]{4,17}$
   */
  accountNumber?: string;
  /** Required for ACH accounts */
  accountType?: BankAccountType;
  /** Required for Stripe accounts */
  stripeSessionId?: string;
}

/** CreateUnitDto */
export interface CreateUnitDto {
  /**
   * @minLength 1
   * @maxLength 150
   */
  name: string;
  address?: RequiredAddressDto;
  /**
   * Value must be a double greater than or equal to 0 and evenly divisible by 0.5.
   * @format double
   * @min 0
   */
  beds?: number;
  /**
   * Value must be a double greater than or equal to 0 and evenly divisible by 0.5.
   * @format double
   * @min 0
   */
  baths?: number;
  /**
   * Value must be either null or greater than or equal to 0.
   * @format int32
   * @min 0
   */
  unitSizeSqft?: number;
  /**
   * @format int32
   * @min 1
   * @max 200
   */
  floor?: number;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  imageId?: string;
  createUnitListing?: boolean;
  magicTags?: Record<string, string>;
}

/** CreateVendorBillDto */
export interface CreateVendorBillDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  vendorId: string;
  reference?: string;
  memo?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  unitId?: string;
  /** @format date */
  billDate: string;
  /** @format date */
  dueDate: string;
  /** @minItems 1 */
  lineItems: BillLineItemDto[];
  /** @default false */
  companyBill: boolean;
}

/** CreateVendorPaymentAccountDto */
export interface CreateVendorPaymentAccountDto {
  /**
   * Required for ACH accounts
   * @minLength 3
   * @maxLength 100
   */
  bankName?: string;
  /**
   * A valid 9-digit bank routing number.
   * @pattern ^[0-9]{9}$
   */
  routingNumber?: string;
  /**
   * A valid 4 to 17 digit account number.
   * @pattern ^[0-9]{4,17}$
   */
  accountNumber?: string;
  /** Required for ACH accounts */
  accountType?: BankAccountType;
  /** Required for Stripe accounts */
  stripeSessionId?: string;
}

/** CreateWorkOrderDto */
export interface CreateWorkOrderDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  unitId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  vendorId?: string;
  urgency: Urgency;
  status?: WorkOrderStatus;
  /** @format date */
  dueDate?: string;
  permissionToEnter: boolean;
  /**
   * @minLength 0
   * @maxLength 150
   */
  title?: string;
  description: string;
  internalDescription?: string;
  assignedPropertyManagerId?: string;
}

/** CreateWorkOrderFromAssociationViolationDto */
export interface CreateWorkOrderFromAssociationViolationDto {
  vendorId?: string;
  permissionToEnter: boolean;
}

/** CreateWorkOrderFromMaintenanceRequestRequestDto */
export interface CreateWorkOrderFromMaintenanceRequestRequestDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  vendorId?: string;
  /** @format date */
  dueDate?: string;
  urgency?: Urgency;
  status?: WorkOrderStatus;
}

/** CreationSource */
export enum CreationSource {
  None = 'none',
  Direct = 'direct',
  Import = 'import',
  AutoPay = 'autoPay',
  Recurring = 'recurring',
}

/** CreatorDto */
export interface CreatorDto {
  type: MagicUserType;
  source: CreationSource;
  vendorId?: string;
  tenantId?: string;
  propertyManagerId?: string;
  ownerId?: string;
}

/** CreatorInfoDto */
export interface CreatorInfoDto {
  vendor?: VendorDto;
  tenant?: TenantDto;
  propertyManager?: PropertyManagerDto;
  owner?: OwnerDto;
}

/** CreditDebitDirection */
export enum CreditDebitDirection {
  Debit = 'debit',
  Credit = 'credit',
}

/** CustomBooleanFieldOptionsDto */
export type CustomBooleanFieldOptionsDto = CustomFieldOptionsDto & {
  default?: boolean;
};

/** CustomDateTimeFieldOptionsDto */
export type CustomDateTimeFieldOptionsDto = CustomFieldOptionsDto & {
  dateOnly?: boolean;
  /** @format date-time */
  min?: string;
  /** @format date-time */
  max?: string;
  /** @format date-time */
  default?: string;
};

/** CustomFieldComponentType */
export enum CustomFieldComponentType {
  Input = 'input',
  Textarea = 'textarea',
  Select = 'select',
  Number = 'number',
  Checkbox = 'checkbox',
  Date = 'date',
  DateTime = 'dateTime',
  File = 'file',
}

/** CustomFieldDto */
export interface CustomFieldDto {
  id: string;
  entityType: EntityType;
  name: string;
  description?: string;
  public: boolean;
  filterable: boolean;
  listable: boolean;
  /** @format int32 */
  order: number;
  options:
    | CustomStringFieldOptionsDto
    | CustomNumberFieldOptionsDto
    | CustomBooleanFieldOptionsDto
    | CustomDateTimeFieldOptionsDto
    | CustomReferenceFieldOptionsDto;
  active: boolean;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** CustomFieldOptionsDto */
export interface CustomFieldOptionsDto {
  type: string;
  required: boolean;
  componentType?: CustomFieldComponentType;
}

/** CustomFieldPaginationDto */
export interface CustomFieldPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: CustomFieldDto[];
}

/** CustomFieldValueDto */
export interface CustomFieldValueDto {
  customFieldId: string;
  entityType: EntityType;
  entityId: string;
  stringValue?: string;
  stringArray?: string[];
  /** @format double */
  numberValue?: number;
  booleanValue?: boolean;
  /** @format date-time */
  dateTimeValue?: string;
  referenceValue?: string;
  referenceArray?: string[];
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  referenceFiles?: FileDto[];
}

/** CustomNumberFieldOptionsDto */
export type CustomNumberFieldOptionsDto = CustomFieldOptionsDto & {
  /**
   * @format int32
   * @min -2147483648
   * @max 2147483647
   */
  min?: number;
  /**
   * @format int32
   * @min -2147483648
   * @max 2147483647
   */
  max?: number;
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  step?: number;
  /**
   * @format int32
   * @min -2147483648
   * @max 2147483647
   */
  default?: number;
};

/** CustomReferenceFieldOptionsDto */
export type CustomReferenceFieldOptionsDto = CustomFieldOptionsDto & {
  referenceEntityType: EntityType;
  multiple?: boolean;
};

/** CustomStringFieldOptionsDto */
export type CustomStringFieldOptionsDto = CustomFieldOptionsDto & {
  multiple?: boolean;
  multiline?: boolean;
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  maxLength?: number;
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  minLength?: number;
  /**
   * @minLength 0
   * @maxLength 2000
   */
  default?: string;
  /**
   * @minLength 0
   * @maxLength 200
   */
  values?: string[];
  allowUnknown?: boolean;
};

/** DataPathDto */
export interface DataPathDto {
  key: string;
  name: string;
  type: DataPathValueType;
  children?: DataPathDto[];
  text?: string;
}

/** DataPathValueType */
export enum DataPathValueType {
  None = 'none',
  String = 'string',
  DateOnly = 'dateOnly',
  Currency = 'currency',
  Flag = 'flag',
}

/** DataPathsDto */
export interface DataPathsDto {
  dataPaths: DataPathDto[];
}

/** DateDto */
export interface DateDto {
  /** @format date */
  date: string;
}

/** DateOnlyRangeDto */
export interface DateOnlyRangeDto {
  /** @format date */
  start?: string;
  /** @format date */
  end?: string;
}

/** DateRangeDto */
export interface DateRangeDto {
  /** @format date */
  start?: string;
  /** @format date */
  end?: string;
}

/** DayOfWeek */
export enum DayOfWeek {
  Sunday = 'sunday',
  Monday = 'monday',
  Tuesday = 'tuesday',
  Wednesday = 'wednesday',
  Thursday = 'thursday',
  Friday = 'friday',
  Saturday = 'saturday',
}

/** DeleteAssociationViolationRequestDto */
export interface DeleteAssociationViolationRequestDto {
  deleteBills: boolean;
}

/** DeleteBillDto */
export interface DeleteBillDto {
  /**
   * The behavior to apply to the bill's payments
   * @default "leaveTransactionAsIs"
   */
  deleteBehavior?: DeleteBillPaymentBehavior;
}

/** DeleteBillPaymentBehavior */
export enum DeleteBillPaymentBehavior {
  AdjustTransaction = 'adjustTransaction',
  LeaveTransactionAsIs = 'leaveTransactionAsIs',
}

/** DeleteBillPaymentDto */
export interface DeleteBillPaymentDto {
  deleteBehavior?: DeleteBillPaymentBehavior;
}

/** DeleteChartOfAccountDto */
export interface DeleteChartOfAccountDto {
  replacementId: string;
}

/** DeleteCheckRequestDto */
export interface DeleteCheckRequestDto {
  deleteTransactions: boolean;
}

/** DeleteLeaseRecurringChargeDto */
export interface DeleteLeaseRecurringChargeDto {
  deletePostedCharges: boolean;
}

/** DeleteLeaseRecurringOfflinePaymentDto */
export interface DeleteLeaseRecurringOfflinePaymentDto {
  deleteAllPayments: boolean;
}

/** DeleteVendorBillDto */
export interface DeleteVendorBillDto {
  /**
   * The behavior to apply to the bill's payments
   * @default "adjustTransaction"
   */
  deleteBehavior?: DeleteBillPaymentBehavior;
}

/** DelinquencyReportDto */
export interface DelinquencyReportDto {
  groups: DelinquencyReportGroupDto[];
  metadata: DelinquencyReportMetadataDto;
}

/** DelinquencyReportGroupDto */
export interface DelinquencyReportGroupDto {
  portfolio: PortfolioDto;
  property: PropertyDto;
  items: DelinquencyReportItemDto[];
}

/** DelinquencyReportItemDto */
export interface DelinquencyReportItemDto {
  lease: LeaseDto;
  unit: UnitDto;
  tenants: LeaseWithTenantDto[];
}

/** DelinquencyReportMetadataDto */
export interface DelinquencyReportMetadataDto {
  /** @format double */
  totalDeposit: number;
}

/** DepositPaymentSettingsDto */
export interface DepositPaymentSettingsDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  bankAccountId?: string;
  allowOnlinePayments: boolean;
  allowAchPayments: boolean;
  allowCardPayments: boolean;
  allowPartialPayments: boolean;
  minimumPaymentType: MinimumPaymentType;
  /**
   * @format double
   * @min 0.01
   * @max 1
   */
  minimumPaymentPercent?: number;
  /**
   * @format double
   * @min 1
   * @max 1000
   */
  minimumPaymentAmount?: number;
}

/** DepositPaymentSettingsDtoSettingsWithOverrideDto */
export interface DepositPaymentSettingsDtoSettingsWithOverrideDto {
  settings?: DepositPaymentSettingsDto;
  level: SettingsLevel;
  levelId: string;
}

/** DepositPaymentSettingsDtoSettingsWithOverridesDto */
export interface DepositPaymentSettingsDtoSettingsWithOverridesDto {
  settings?: DepositPaymentSettingsDto;
  overrides: DepositPaymentSettingsDtoSettingsWithOverrideDto[];
}

/** DepositSlipDto */
export interface DepositSlipDto {
  id: string;
  bankAccountId: string;
  reference: string;
  /** @format date-time */
  date: string;
  transaction: TransactionDto[];
  bankAccounts: BankAccountDto[];
  tenants: TenantDto[];
  vendors: VendorDto[];
  owners: OwnerDto[];
  leases: LeaseDto[];
  units: UnitDto[];
  properties: PropertyDto[];
}

/** DepositSlipListDto */
export interface DepositSlipListDto {
  id: string;
  bankAccountId: string;
  reference: string;
  /** @format date-time */
  date: string;
  transactionIds: string[];
}

/** DepositSlipPaginatedDto */
export interface DepositSlipPaginatedDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: DepositSlipListDto[];
  bankAccounts: BankAccountDto[];
}

/** DepositSlipsDto */
export interface DepositSlipsDto {
  depositSlips: DepositSlipListDto[];
  transaction: TransactionDto[];
  bankAccounts: BankAccountDto[];
  tenants: TenantDto[];
  vendors: VendorDto[];
  owners: OwnerDto[];
  leases: LeaseDto[];
  units: UnitDto[];
  properties: PropertyDto[];
}

/** DestinationType */
export enum DestinationType {
  Email = 'email',
  Text = 'text',
}

/** DistributionOwnerDto */
export interface DistributionOwnerDto {
  owner: OwnerDto;
  /** @format double */
  ownershipPercentage: number;
  /** @format double */
  distributionAmount: number;
  paymentAccounts: DistributionOwnerPaymentAccountDto[];
}

/** DistributionOwnerPaymentAccountDto */
export interface DistributionOwnerPaymentAccountDto {
  id: string;
  name: string;
  accountMask?: string;
}

/** DistributionValidatePropertiesDto */
export interface DistributionValidatePropertiesDto {
  propertyIds?: string[];
}

/** DistributionValidationDto */
export interface DistributionValidationDto {
  needsAttentionProperties: InvalidPropertyDto[];
  validProperties: ValidPropertyDto[];
  owners: OwnerDto[];
}

/** DriverLicenseDto */
export interface DriverLicenseDto {
  /** @minLength 1 */
  number: string;
  /**
   * @minLength 2
   * @maxLength 2
   */
  state: string;
}

/** DriversLicenseDto */
export interface DriversLicenseDto {
  /**
   * @minLength 0
   * @maxLength 100
   */
  number: string;
  /**
   * @minLength 2
   * @maxLength 2
   */
  state: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  country: string;
}

/** EligibleDto */
export interface EligibleDto {
  eligible: boolean;
  reason?: string;
}

/** EmailDto */
export interface EmailDto {
  id: string;
  targets: HydratedEmailTargetDto[];
  /** @format date-time */
  sent: string;
  subject: string;
  body: string;
  template?: EmailTemplates;
  metadata?: Record<string, string>;
  files: FileDto[];
  propertyManager?: PropertyManagerDto;
}

/** EmailListDto */
export interface EmailListDto {
  id: string;
  subject: string;
  /** @format date-time */
  sent: string;
  body: string;
  template?: EmailTemplates;
  metadata?: Record<string, string>;
  targets: EmailTargetDto[];
  propertyManagerId?: string;
}

/** EmailStatus */
export enum EmailStatus {
  NotSent = 'notSent',
  Disabled = 'disabled',
  NoRecipients = 'noRecipients',
  Sent = 'sent',
  Delivered = 'delivered',
  Bounce = 'bounce',
  Complaint = 'complaint',
  DeliveryDelay = 'deliveryDelay',
  Reject = 'reject',
  Failed = 'failed',
}

/** EmailTargetDto */
export interface EmailTargetDto {
  email: string;
  ownerId?: string;
  tenantId?: string;
  leaseId?: string;
  vendorId?: string;
}

/** EmailTemplates */
export enum EmailTemplates {
  Empty = 'empty',
  CompanyGeneric = 'companyGeneric',
  MagicDoor = 'magicDoor',
}

/** EmailsDto */
export interface EmailsDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: EmailListDto[];
  owners: OwnerDto[];
  tenants: TenantDto[];
  leases: LeaseDto[];
  vendors: VendorDto[];
  propertyManagers: PropertyManagerDto[];
}

/** EmbedFileDto */
export interface EmbedFileDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  fileId: string;
  default?: boolean;
  /** @maxLength 200 */
  description?: string;
  signedUrl?: string;
  signedThumbUrl?: string;
}

/** EmergencyContactDto */
export interface EmergencyContactDto {
  /**
   * @minLength 1
   * @maxLength 150
   */
  name: string;
  /**
   * @minLength 10
   * @maxLength 13
   * @pattern ^\+{0,1}\d{0,1}\d{10}$
   */
  phone?: string;
  /** @format email */
  email?: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  relationship?: string;
}

/** EmploymentDto */
export interface EmploymentDto {
  /**
   * @minLength 1
   * @maxLength 150
   */
  name?: string;
  /**
   * @minLength 10
   * @maxLength 13
   * @pattern ^\+{0,1}\d{0,1}\d{10}$
   */
  phone?: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  position?: string;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  salary?: number;
  /**
   * @minLength 1
   * @maxLength 150
   */
  jobTitle?: string;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  annualIncome?: number;
  /** @format date */
  startDate?: string;
  /** @format date */
  endDate?: string;
}

/** EntityCustomFieldDto */
export interface EntityCustomFieldDto {
  id: string;
  name: string;
  description?: string;
  public: boolean;
  filterable: boolean;
  listable: boolean;
  /** @format int32 */
  order: number;
  options:
    | CustomStringFieldOptionsDto
    | CustomNumberFieldOptionsDto
    | CustomBooleanFieldOptionsDto
    | CustomDateTimeFieldOptionsDto
    | CustomReferenceFieldOptionsDto;
  value?: CustomFieldValueDto;
}

/** EntityCustomFieldsDto */
export interface EntityCustomFieldsDto {
  customFields: EntityCustomFieldDto[];
}

/** EntityType */
export enum EntityType {
  Lease = 'lease',
  Unit = 'unit',
  Property = 'property',
  Portfolio = 'portfolio',
  Company = 'company',
  Tenant = 'tenant',
  Vendor = 'vendor',
  MaintenanceRequest = 'maintenanceRequest',
  WorkOrder = 'workOrder',
  Bill = 'bill',
  Transaction = 'transaction',
  Chat = 'chat',
  ChatMessage = 'chatMessage',
  PropertyManager = 'propertyManager',
  Unknown = 'unknown',
  RentalApplication = 'rentalApplication',
  LeaseTemplate = 'leaseTemplate',
  LeaseDocument = 'leaseDocument',
  AssociationViolation = 'associationViolation',
  Owner = 'owner',
  UnitListing = 'unitListing',
  File = 'file',
}

/** ExamQuestionDto */
export interface ExamQuestionDto {
  questionKeyName?: string;
  questionDisplayName?: string;
  type?: string;
  choices?: QuestionChoiceDto[];
}

/** ExpiringLeaseCounts */
export interface ExpiringLeaseCounts {
  /** @format int32 */
  lessThanOneMonth: number;
  /** @format int32 */
  oneToTwoMonths: number;
  /** @format int32 */
  twoToThreeMonths: number;
  /** @format int32 */
  moreThanThreeMonths: number;
  /** @format int32 */
  total: number;
}

/** ExpiringStatus */
export enum ExpiringStatus {
  None = 'none',
  Soon = 'soon',
  Imminent = 'imminent',
  Immediate = 'immediate',
}

/** ExternalTransactionType */
export enum ExternalTransactionType {
  Plaid = 'plaid',
  Stripe = 'stripe',
  Offline = 'offline',
}

/** FailedOwnerDistributionAchResultDto */
export interface FailedOwnerDistributionAchResultDto {
  owner: OwnerDto;
  bankAccount: BankAccountDto;
  transaction: TransactionDto;
  properties: OwnerDistributionPropertyResultDto[];
  failureReason: StartOutgoingAchFailure;
}

/** FailedVendorBillResultDto */
export interface FailedVendorBillResultDto {
  vendor: VendorDto;
  bankAccount: BankAccountDto;
  transaction: TransactionDto;
  payments: VendorBillPaymentResultDto[];
  failureReason: StartOutgoingAchFailure;
}

/** FederalTaxInformationDto */
export interface FederalTaxInformationDto {
  taxIdType: IdentificationType;
  /**
   * @minLength 1
   * @maxLength 200
   */
  taxId: string;
  overwriteAddress?: AddressDto;
  /**
   * @minLength 1
   * @maxLength 150
   */
  overwriteName?: string;
}

/** FileDto */
export interface FileDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  fileId: string;
  fileName: string;
  signedUrl: string;
  signedThumbUrl?: string;
  /** @format int64 */
  fileSize: number;
  /** @format date-time */
  uploaded: string;
}

/** FileType */
export enum FileType {
  Identification = 'identification',
  BankStatement = 'bankStatement',
  EmploymentVerification = 'employmentVerification',
  Additional = 'additional',
  Ssn = 'ssn',
  Paystub = 'paystub',
  Pet = 'pet',
}

/** FlyerTemplate */
export enum FlyerTemplate {
  QrCode = 'qrCode',
  TenantNotice = 'tenantNotice',
  Welcome = 'welcome',
}

/** Gender */
export enum Gender {
  Male = 'male',
  Female = 'female',
  Other = 'other',
  PreferNotToSay = 'preferNotToSay',
}

/** GeneralLedgerReportDataDto */
export interface GeneralLedgerReportDataDto {
  properties: PropertyDto[];
  vendors: VendorDto[];
  tenants: TenantDto[];
  chartOfAccounts: ChartOfAccountReportDto[];
}

/** GetAnnouncementTargetsRequestDto */
export interface GetAnnouncementTargetsRequestDto {
  targetType: TargetType;
  /** Applicable only for Lease targets */
  includeEnded?: boolean;
  /** Applicable only for Tenant targets */
  hasActiveLease?: boolean;
  /** Applicable only for Tenant targets */
  hasLeaseWithoutPaymentMethod?: boolean;
  /** Applicable only for Tenant targets */
  hasNoPortalActivity?: boolean;
  /** Applicable only for Tenant or Lease targets */
  hasBalanceDue?: boolean;
  /**
   * Applicable only for Tenant or Lease or Owner targets
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  portfolioIds?: string[];
  /**
   * Applicable only for Tenant or Lease or Owner targets
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyIds?: string[];
  /**
   * Applicable only for Tenant or Lease targets
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  unitIds?: string[];
}

/** GivePropertyCreditDto */
export interface GivePropertyCreditDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  bankAccountId: string;
  /** @format date */
  creditDate?: string;
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount: number;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  companyChartOfAccountsId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyChartOfAccountsId?: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  memo?: string;
}

/** HotpadsSyndicationStatusDto */
export interface HotpadsSyndicationStatusDto {
  status: SyndicationStatus;
  url: string;
}

/** HydratePaginatedLeaseRenewalOffersDto */
export interface HydratePaginatedLeaseRenewalOffersDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: LeaseRenewalOfferListItemDto[];
  chartOfAccounts: ChartOfAccountDto[];
  leases: LeaseDto[];
}

/** HydratedAnnouncementDto */
export interface HydratedAnnouncementDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  companyId: string;
  /** @format date-time */
  sentAt: string;
  chatMessage?: string;
  emailMessage?: string;
  /** @maxLength 250 */
  subject?: string;
  targets: HydratedAnnouncementTargetsDto;
  chatAttachments?: FileDto[];
  emailAttachments?: FileDto[];
}

/** HydratedAnnouncementPortfolioTargetsDto */
export interface HydratedAnnouncementPortfolioTargetsDto {
  portfolio: PortfolioDto;
  properties: HydratedAnnouncementPropertyTargetsDto[];
}

/** HydratedAnnouncementPropertyTargetsDto */
export interface HydratedAnnouncementPropertyTargetsDto {
  property: PropertyDto;
  units: HydratedAnnouncementUnitTargetsDto[];
}

/** HydratedAnnouncementTargetsDto */
export interface HydratedAnnouncementTargetsDto {
  portfolioTargets: HydratedAnnouncementPortfolioTargetsDto[];
  owners: OwnerDto[];
  vendors: VendorDto[];
  tenants: TenantDto[];
  targetTypes: TargetType[];
}

/** HydratedAnnouncementUnitTargetsDto */
export interface HydratedAnnouncementUnitTargetsDto {
  unit: UnitDto;
  tenants: TenantDto[];
  leases: LeaseDto[];
  vendors: VendorDto[];
  owners: OwnerDto[];
}

/** HydratedBankAccountDto */
export interface HydratedBankAccountDto {
  id: string;
  name: string;
  description?: string;
  active: boolean;
  accountNumber?: string;
  routingNumber?: string;
  type?: BankAccountType;
  scheduleSweepDays: number[];
  plaid?: PlaidConnectedStatusDto;
  stripe?: StripeConnectedStatusDto;
}

/** HydratedBillDto */
export interface HydratedBillDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  companyCharge: boolean;
  identity: BillIdentity;
  direction: CreditDebitDirection;
  /** @minLength 1 */
  reference?: string;
  /** @minLength 1 */
  memo?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  unitId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  portfolioId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  vendorId?: string;
  /** @format date */
  billDate: string;
  /** @format date */
  dueDate: string;
  /** @format double */
  totalAmount: number;
  /** @format double */
  paid: number;
  /** @format double */
  due: number;
  lineItems: HydratedBillLineItemDto[];
  recurringChargeId?: string;
  creator: CreatorDto;
  files: BillFileDto[];
  transactions: Record<string, TransactionDto>;
  portfolio?: PortfolioDto;
  property?: PropertyDto;
  unit?: UnitDto;
  vendor?: VendorDto;
  lease?: LeaseDto;
  creatorInfo: CreatorInfoDto;
}

/** HydratedBillDtoPaginationDto */
export interface HydratedBillDtoPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: HydratedBillDto[];
}

/** HydratedBillLineItemDto */
export interface HydratedBillLineItemDto {
  chartOfAccountId: string;
  /** @minLength 1 */
  description?: string;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  amount: number;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  paid: number;
  allocations?: BillAllocationDto[];
  chartOfAccount: ChartOfAccountDto;
}

/** HydratedChatParticipantDto */
export interface HydratedChatParticipantDto {
  id: string;
  participantType: ChatParticipantType;
  accountId?: string;
  name?: string;
  phoneNumber?: string;
  email?: string;
  tenant?: TenantDto;
  active: boolean;
}

/** HydratedCheckDto */
export interface HydratedCheckDto {
  id: string;
  companyId: string;
  /** @format int32 */
  checkNumber: number;
  vendorId?: string;
  ownerId?: string;
  bankAccountId: string;
  /** @format double */
  amount: number;
  memo?: string;
  /** @format date-time */
  createdOn: string;
  /** @format date-time */
  date: string;
  transactionId?: string;
  billPayments: CheckBillPaymentDto[];
  dataHeaders: string[];
  voided: boolean;
  voidReason?: string;
  amountString: string;
  bankAccount: BankAccountDto;
  company: CompanyDto;
  vendor?: VendorDto;
  owner?: OwnerDto;
  bills: BillDto[];
  transactions: TransactionDto[];
  micrCode: string;
}

/** HydratedEmailTargetDto */
export interface HydratedEmailTargetDto {
  email: string;
  owner?: OwnerDto;
  tenants?: TenantDto[];
  lease?: LeaseDto;
  vendor?: VendorDto;
}

/** HydratedFileAttachmentDto */
export interface HydratedFileAttachmentDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  /** @minLength 1 */
  fileName: string;
  description?: string;
  /** @minLength 1 */
  fileId: string;
  /** @minLength 1 */
  fileUrl: string;
  /** @minLength 1 */
  fileThumbUrl: string;
  /** @format int64 */
  fileSizeBytes: number;
  /** @format date-time */
  created: string;
  uploaderName?: string;
  uploaderType?: string;
}

/** HydratedGetLeaseTransactionsDto */
export interface HydratedGetLeaseTransactionsDto {
  /** @format double */
  currentBalance: number;
  /** @format double */
  postedBalance: number;
  transactions: HydratedLeaseTransactionDto[];
}

/** HydratedLeaseDocumentDto */
export interface HydratedLeaseDocumentDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  companyId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  portfolioId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  unitId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseTemplateIds: string[];
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  fileId: string;
  /** @minLength 1 */
  name: string;
  status: LeaseDocumentStatus;
  signers: LeaseDocumentSignerDto[];
  annotations: LeaseDocumentAnnotationDto[];
  type: LeaseDocumentType;
  file: FileDto;
}

/** HydratedLeaseDto */
export interface HydratedLeaseDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  portfolioId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  unitId: string;
  /** @format date */
  start: string;
  /** @format date */
  end?: string;
  ended: boolean;
  monthToMonth: boolean;
  eviction: boolean;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  chatId?: string;
  tenants: HydratedLeaseTenantDto[];
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  balance: number;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  currentRent: number;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  securityDepositPaid: number;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  securityDepositRequested: number;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  securityDepositDue: number;
  /** @format date */
  lastPaymentDate?: string;
  /** @format date */
  earliestUnpaidBillDueDate?: string;
  icons: string[];
  /** @format date */
  moveOutDate?: string;
  draft: boolean;
  status: LeaseStatus;
  expiringStatus: ExpiringStatus;
  /** @format int32 */
  pastDueDays?: number;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  postedBalance: number;
  unit: UnitDto;
  property: PropertyDto;
  activeRentersInsurances: LeaseRentersInsuranceItemDto[];
  customFieldValues?: CustomFieldValueDto[];
}

/** HydratedLeaseDtoPaginationDto */
export interface HydratedLeaseDtoPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: HydratedLeaseDto[];
}

/** HydratedLeasePaginationDto */
export interface HydratedLeasePaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: HydratedLeaseDto[];
  customFields: CustomFieldDto[];
}

/** HydratedLeaseTenantDto */
export interface HydratedLeaseTenantDto {
  tenant: TenantDto;
  /** @format date */
  moveIn: string;
  /** @format date */
  moveOut?: string;
  isMovedOut: boolean;
}

/** HydratedLeaseTransactionDto */
export interface HydratedLeaseTransactionDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  type: RentTransactionType;
  status: LeaseTransactionStatus;
  /** @format date */
  transactionDate: string;
  /** @minLength 1 */
  description?: string;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  amount: number;
  /** @format double */
  balance: number;
  /** @format double */
  postedBalance: number;
  transaction?: HydratedTransactionDto;
  bill?: HydratedBillDto;
}

/** HydratedMagicChatDto */
export interface HydratedMagicChatDto {
  id: string;
  type: ChatTypes;
  typeKey: string;
  groupNumber?: string;
  participants: HydratedChatParticipantDto[];
  subject: string;
  participantLanguage: string;
  closed: boolean;
  /** @format date-time */
  created: string;
  latestMessageId?: string;
  /** @format date-time */
  lastMessageSentAt?: string;
  /** @format int32 */
  messageCount: number;
  latestMessage?: ChatMessageDto;
  lease?: LeaseDto;
  /** @format int32 */
  unreadMessages: number;
}

/** HydratedNewOwnerDto */
export interface HydratedNewOwnerDto {
  id: string;
  active: boolean;
  email?: string;
  firstName: string;
  lastName?: string;
  isCompany: boolean;
  phone?: string;
  federalTaxInformation?: FederalTaxInformationDto;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format date-time */
  lastSeen?: string;
  /** @format date-time */
  lastPortalInvite?: string;
  chatId?: string;
  language: string;
  icons: string[];
  address?: AddressDto;
  portalStatus: PortalStatus;
  ownerProperties: OwnerPropertyDto[];
  portfolios: PortfolioDto[];
  properties: PropertyDto[];
  paymentAccounts: PaymentAccountDto[];
  password: string;
}

/** HydratedOwnerDto */
export interface HydratedOwnerDto {
  id: string;
  active: boolean;
  email?: string;
  firstName: string;
  lastName?: string;
  isCompany: boolean;
  phone?: string;
  federalTaxInformation?: FederalTaxInformationDto;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format date-time */
  lastSeen?: string;
  /** @format date-time */
  lastPortalInvite?: string;
  chatId?: string;
  language: string;
  icons: string[];
  address?: AddressDto;
  portalStatus: PortalStatus;
  ownerProperties: OwnerPropertyDto[];
  portfolios: PortfolioDto[];
  properties: PropertyDto[];
  paymentAccounts: PaymentAccountDto[];
}

/** HydratedOwnerListDto */
export interface HydratedOwnerListDto {
  id: string;
  active: boolean;
  email?: string;
  firstName: string;
  lastName?: string;
  isCompany: boolean;
  phone?: string;
  federalTaxInformation?: FederalTaxInformationDto;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format date-time */
  lastSeen?: string;
  /** @format date-time */
  lastPortalInvite?: string;
  chatId?: string;
  language: string;
  icons: string[];
  address?: AddressDto;
  portalStatus: PortalStatus;
  ownerProperties: OwnerPropertyDto[];
}

/** HydratedOwnerListPaginationDto */
export interface HydratedOwnerListPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: HydratedOwnerListDto[];
  portfolios: PortfolioDto[];
  properties: PropertyDto[];
}

/** HydratedOwnerPropertyDto */
export interface HydratedOwnerPropertyDto {
  owner: OwnerDto;
  property: PropertyDto;
  portfolio: PortfolioDto;
  /** @format double */
  ownershipPercentage: number;
}

/** HydratedPortfolioDto */
export interface HydratedPortfolioDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  active: boolean;
  /**
   * @minLength 1
   * @maxLength 150
   */
  name: string;
  /** @format int32 */
  propertyCount: number;
  icons: string[];
  /** @format int32 */
  activePropertyCount: number;
  properties: HydratedPortfolioPropertyDto[];
  /** @format int32 */
  recentRentalApplications: number;
  latestRentalApplication?: RentalApplicationListDto;
}

/** HydratedPortfolioPropertyDto */
export interface HydratedPortfolioPropertyDto {
  id: string;
  name?: string;
  displayName: string;
  address?: AddressDto;
  portfolioId: string;
  type: PropertyType;
  /** @format int32 */
  totalFloors?: number;
  /** @format int32 */
  unitCount: number;
  /** @format int32 */
  recentRentalApplications: number;
  active: boolean;
  imageId?: string;
  icons: string[];
  magicTags?: Record<string, string>;
  /** @format int32 */
  activeUnitCount: number;
}

/** HydratedPropertyDto */
export interface HydratedPropertyDto {
  id: string;
  name?: string;
  displayName: string;
  address?: AddressDto;
  portfolioId: string;
  type: PropertyType;
  /** @format int32 */
  totalFloors?: number;
  /** @format int32 */
  unitCount: number;
  /** @format int32 */
  recentRentalApplications: number;
  active: boolean;
  imageId?: string;
  icons: string[];
  magicTags?: Record<string, string>;
  image?: FileDto;
  portfolio: PortfolioDto;
  latestRentalApplication?: RentalApplicationListDto;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  totalRent: number;
  /** @format double */
  currentBalance: number;
  /** @format double */
  postedBalance: number;
  /** @format double */
  totalDeposit: number;
  /** @format int32 */
  occupiedUnits: number;
  /** @format int32 */
  activeUnits: number;
  /** @format int32 */
  emptyUnits: number;
  owners: HydratedPropertyOwnerDto[];
  defaultUnit?: UnitDto;
  customFieldValues?: CustomFieldValueDto[];
}

/** HydratedPropertyOwnerDto */
export interface HydratedPropertyOwnerDto {
  owner: OwnerDto;
  /** @format double */
  ownershipPercentage: number;
}

/** HydratedPropertyPaginationDto */
export interface HydratedPropertyPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: HydratedPropertyDto[];
  customFields: CustomFieldDto[];
}

/** HydratedRecurringLeaseChargeDto */
export interface HydratedRecurringLeaseChargeDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount: number;
  chargeFrequency: ChargeFrequency;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  chartOfAccountId: string;
  /** @minLength 1 */
  description?: string;
  companyCharge: boolean;
  /** @format date */
  lastCharge?: string;
  /** @format date */
  nextCharge: string;
  /** @format date */
  startFrom: string;
  /** @format date */
  end?: string;
  status: LeaseRecurringChargeStatus;
  chartOfAccount: ChartOfAccountDto;
}

/** HydratedRunBookDto */
export interface HydratedRunBookDto {
  publicRunBook: boolean;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  title: string;
  /**
   * @minLength 1
   * @maxLength 250
   */
  description: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string;
  /** @deprecated */
  vendorId?: string;
  defaultVendorId?: string;
  defaultPropertyManagerId?: string;
  enabled: boolean;
  /** @format int32 */
  usageCount: number;
  /** @format date-time */
  lastUsed?: string;
  /** @minLength 1 */
  script: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  lastUseMaintenanceRequestId?: string;
  vendorOverwrites?: RunBookVendorOverwriteDto[];
  propertyManagerOverwrites?: RunBookPropertyManagerOverwriteDto[];
  actionExitCounts: {
    /** @format int32 */
    askQuestion?: number;
    /** @format int32 */
    closeRequest?: number;
    /** @format int32 */
    createWorkOrder?: number;
    /** @format int32 */
    handOverToHuman?: number;
    /** @format int32 */
    reselectRunBook?: number;
  };
  propertyManagers: PropertyManagerDto[];
  vendors: VendorDto[];
  properties: PropertyDto[];
  portfolios: PortfolioDto[];
  lastUseMaintenanceRequest?: MaintenanceRequestListDto;
}

/** HydratedServiceBillPaginationDto */
export interface HydratedServiceBillPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: ServiceBillResultListDto[];
  portfolios: PortfolioDto[];
  properties: PropertyDto[];
  units: UnitDto[];
  vendors: VendorDto[];
  chartOfAccounts: ChartOfAccountDto[];
}

/** HydratedTenantAutoPayDto */
export interface HydratedTenantAutoPayDto {
  id: string;
  type: TenantAutoPayType;
  /** @format double */
  fixedAmount?: number;
  /** @format double */
  maximumAmount?: number;
  frequency: ChargeFrequency;
  /** @format date */
  start: string;
  /** @format date */
  end?: string;
  /** @format date */
  lastPayment?: string;
  /** @format date */
  nextPayment?: string;
  lease: LeaseDto;
  paymentAccount: PaymentAccountDto;
  tenant: TenantDto;
  portfolio: PortfolioDto;
  property: PropertyDto;
  unit: UnitDto;
}

/** HydratedTenantDto */
export interface HydratedTenantDto {
  id: string;
  active: boolean;
  email?: string;
  firstName: string;
  lastName?: string;
  phone?: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format date-time */
  lastSeen?: string;
  /** @format date-time */
  lastPortalInvite?: string;
  portalStatus: PortalStatus;
  chatId?: string;
  language?: string;
  ssn?: string;
  driversLicense?: DriverLicenseDto;
  /** @format date */
  dateOfBirth?: string;
  gender?: Gender;
  currentAddress?: AddressDto;
  emergencyContacts?: EmergencyContactDto[];
  icons: string[];
  primaryLeaseId?: string;
  currentLeases?: LeaseDto[];
  properties?: PropertyDto[];
  units?: UnitDto[];
}

/** HydratedTenantListDto */
export interface HydratedTenantListDto {
  id: string;
  active: boolean;
  email?: string;
  firstName: string;
  lastName?: string;
  phone?: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format date-time */
  lastSeen?: string;
  /** @format date-time */
  lastPortalInvite?: string;
  portalStatus: PortalStatus;
  chatId?: string;
  language?: string;
  ssn?: string;
  driversLicense?: DriverLicenseDto;
  /** @format date */
  dateOfBirth?: string;
  gender?: Gender;
  currentAddress?: AddressDto;
  emergencyContacts?: EmergencyContactDto[];
  icons: string[];
  primaryLeaseId?: string;
  currentLeases?: LeaseDto[];
}

/** HydratedTenantListPaginationDto */
export interface HydratedTenantListPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: HydratedTenantListDto[];
  properties: PropertyDto[];
  units: UnitDto[];
}

/** HydratedTransactionDto */
export interface HydratedTransactionDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  /** @format date */
  transactionDate: string;
  transactionIdentity: TransactionIdentity;
  transactionPaymentMethod: TransactionPaymentMethod;
  status: TransactionStatus;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  amount: number;
  memo?: string;
  direction: TransactionDirection;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  bankAccountId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  tenantId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  vendorId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  unitId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  portfolioId?: string;
  /** @format date-time */
  created: string;
  /** @format date */
  transactionFinalizedDate?: string;
  externalTransactionType?: ExternalTransactionType;
  /** @minLength 1 */
  externalTransactionId?: string;
  failureReason?: TransactionFailure;
  paymentProcessorErrorMessage?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  refundTransactionId?: string;
  reference?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  depositSlipId?: string;
  creator: CreatorDto;
  bankAccount: BankAccountDto;
  tenant?: TenantDto;
  vendor?: VendorDto;
  lease?: LeaseDto;
  property?: PropertyDto;
  unit?: UnitDto;
  check?: CheckDto;
  creatorInfo: CreatorInfoDto;
}

/** HydratedTransactionDtoPaginationDto */
export interface HydratedTransactionDtoPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: HydratedTransactionDto[];
}

/** HydratedUnitDto */
export interface HydratedUnitDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  name: string;
  address?: AddressDto;
  /**
   * Value must be a double greater than or equal to 0 and evenly divisible by 0.5.
   * @format double
   * @min 0
   */
  beds?: number;
  /**
   * Value must be a double greater than or equal to 0 and evenly divisible by 0.5.
   * @format double
   * @min 0
   */
  baths?: number;
  /**
   * Value must be either null or greater than or equal to 0.
   * @format int32
   * @min 0
   */
  unitSizeSqft?: number;
  /**
   * @format int32
   * @min 1
   * @max 200
   */
  floor?: number;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  portfolioId: string;
  active: boolean;
  imageId?: string;
  icons: string[];
  magicTags?: Record<string, string>;
  image?: FileDto;
  property: PropertyDto;
  activeLeases: LeaseDto[];
  /** @format int32 */
  recentRentalApplications: number;
  latestRentalApplication?: RentalApplicationListDto;
  /** @format double */
  postedBalance: number;
  singleLineAddress?: string;
}

/** HydratedUnitDtoPaginationDto */
export interface HydratedUnitDtoPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: HydratedUnitDto[];
}

/** HydratedUnitListingDto */
export interface HydratedUnitListingDto {
  id: string;
  portfolioId: string;
  propertyId: string;
  unitId: string;
  status: UnitListingStatus;
  /** @format double */
  marketRent?: number;
  /** @format double */
  rentalPrice?: number;
  /** @format double */
  securityDeposit?: number;
  /** @format date */
  availableFrom?: string;
  leaseTerm?: LeaseTerm;
  title?: string;
  /** @format date */
  listed?: string;
  /** @format date-time */
  updated: string;
  pinned: boolean;
  primaryImage?: EmbedFileDto;
  primaryVideo?: EmbedFileDto;
  propertyType?: PropertyType;
  singleLineAddress?: string;
  /** @format int32 */
  recentRentalApplications?: number;
  description?: string;
  descriptionTranslations?: TranslationDto[];
  images?: EmbedFileDto[];
  videos?: EmbedFileDto[];
  tags?: string[];
  petPolicy?: PetPolicyDto;
  amenities?: AmenityDto[];
  locationAnalysis?: string;
  terms?: Record<string, string>;
  unit: UnitDto;
  portfolio: PortfolioDto;
  property: PropertyDto;
  /** Reasons why the unit listing cannot be listed, null if it can be listed */
  canNotBeListedReasons?: Record<string, string>;
}

/** HydratedVendorDto */
export interface HydratedVendorDto {
  id: string;
  name: string;
  language: string;
  contact: ContactDto;
  memo?: string;
  active: boolean;
  website?: string;
  irs1099Form?: FederalTaxInformationDto;
  insurancePolicy?: InsurancePolicyDto;
  chatId?: string;
  icons: string[];
  type: VendorType;
  defaultMemo?: string;
  paymentSettings: PaymentSettingsDto;
  /** @format date-time */
  lastSeen?: string;
  /** @format date-time */
  lastPortalInvite?: string;
  portalStatus: PortalStatus;
  paymentAccounts: PaymentAccountDto[];
}

/** HydratedVendorDtoPaginationDto */
export interface HydratedVendorDtoPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: HydratedVendorDto[];
}

/** HydratedWorkOrderDto */
export interface HydratedWorkOrderDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  portfolioId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  unitId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  vendorId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  chatId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  groupChatId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  assignedPropertyManagerId?: string;
  reference: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  maintenanceRequestId?: string;
  status: WorkOrderStatus;
  /**
   * @minLength 1
   * @maxLength 150
   */
  title: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string;
  /** @format date */
  dueDate?: string;
  urgency: Urgency;
  /** @minLength 1 */
  description: string;
  internalDescription?: string;
  permissionToEnter: boolean;
  portfolio: PortfolioDto;
  property: PropertyDto;
  unit?: UnitDto;
  lease?: LeaseDto;
  vendor?: VendorDto;
  maintenanceRequest?: MaintenanceRequestListDto;
  assignedPropertyManager?: PropertyManagerDto;
  bills?: WorkOrderBillDto[];
  files: WorkOrderFileDto[];
  chartOfAccounts: ChartOfAccountDto[];
  owners: PropertyOwnerDto[];
  /** @format double */
  ownerApprovalLimit?: number;
  tenants: TenantDto[];
}

/** IdentificationType */
export enum IdentificationType {
  Ssn = 'ssn',
  Ein = 'ein',
}

/** ImportUnitListingDto */
export interface ImportUnitListingDto {
  unitListingIds: string[];
}

/** ImportUnitListingRequestDto */
export interface ImportUnitListingRequestDto {
  portfolioIds?: string[];
  propertyIds?: string[];
  unitIds?: string[];
}

/** IncomeExpenses */
export interface IncomeExpenses {
  /** @format double */
  income: number;
  /** @format double */
  expenses: number;
}

/** IncomeInformationDto */
export interface IncomeInformationDto {
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  annualIncome?: number;
}

/** IncomeStatementDto */
export interface IncomeStatementDto {
  groupHeaders: ReportGroupHeader[];
  income: ChartOfAccountReportLineDto[];
  totalIncome: Record<string, number>;
  expenses: ChartOfAccountReportLineDto[];
  totalExpense: Record<string, number>;
  netOperatingIncome: Record<string, number>;
}

/** InsurancePolicyDto */
export interface InsurancePolicyDto {
  /**
   * @minLength 1
   * @maxLength 200
   */
  policyNumber: string;
  /**
   * @minLength 1
   * @maxLength 200
   */
  provider?: string;
  /** @format date */
  expirationDate?: string;
}

/** InvalidPropertyDto */
export interface InvalidPropertyDto {
  property: PropertyDto;
  isMissingOwnerInformation: boolean;
  owners: PropertyOwnerIdDto[];
  /** @format double */
  calculatedOwnershipPercentage: number;
}

/** JsonNode */
export interface JsonNode {
  options?: JsonNodeOptions;
  parent?: JsonNode;
  root: JsonNode;
}

/** JsonNodeOptions */
export interface JsonNodeOptions {
  propertyNameCaseInsensitive: boolean;
}

/** LastCompanyPayOutRunDto */
export interface LastCompanyPayOutRunDto {
  /** @format date-time */
  lastRun?: string;
}

/** LateFeeCalculation */
export enum LateFeeCalculation {
  Fixed = 'fixed',
  Percent = 'percent',
  PercentOrMinimum = 'percentOrMinimum',
  Formula = 'formula',
}

/** LateFeeFormulaTestDto */
export interface LateFeeFormulaTestDto {
  /** @minLength 1 */
  formula: string;
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  due: number;
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  total: number;
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  lateBills: number;
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  lateDays: number;
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  gracePeriod: number;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  graceBalance: number;
}

/** LateFeeFormulaTestResultDto */
export interface LateFeeFormulaTestResultDto {
  /** @format double */
  result: number;
}

/** LateFeeFrequency */
export enum LateFeeFrequency {
  Once = 'once',
  Daily = 'daily',
  Monthly = 'monthly',
}

/** LateFeesSettingsDto */
export interface LateFeesSettingsDto {
  enabled: boolean;
  /**
   * @format int32
   * @min 0
   * @max 31
   */
  gracePeriod: number;
  /**
   * @format double
   * @min 0
   * @max 1000000
   */
  graceBalance: number;
  calculation: LateFeeCalculation;
  /**
   * Amount to charge for late fees, required if `Calculation` is `Fixed` or `PercentOrMinimum`.
   * @format double
   * @min 0
   * @max 1000
   */
  amount?: number;
  /**
   * Percentage to charge for late fees, required if `Calculation` is `Percent` or `PercentOrMinimum`.
   * @format double
   * @min 0
   * @max 1
   */
  feePercent?: number;
  /**
   * Formula for calculating late fee, required if `Calculation` is `Formula`. The formula should be a valid expression that can be evaluated by NCalc. The variables available are: due, total, lateBills, lateDays, gracePeriod.
   * @minLength 1
   */
  formula?: string;
  /**
   * Frequency for applying late fees: `Once`, `Daily`, or `Monthly`. Default is `Once`.
   * @default "once"
   */
  frequency: LateFeeFrequency;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  lateFeeChartOfAccountId: string;
  /** @minLength 1 */
  lateFeeDescription: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  lateFeeIncludeChartOfAccountIds?: string[];
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  lateFeePreventChartOfAccountIds?: string[];
  lateFeeIsCompanyBill: boolean;
}

/** LateFeesSettingsDtoSettingsWithOverrideDto */
export interface LateFeesSettingsDtoSettingsWithOverrideDto {
  settings?: LateFeesSettingsDto;
  level: SettingsLevel;
  levelId: string;
}

/** LateFeesSettingsDtoSettingsWithOverridesDto */
export interface LateFeesSettingsDtoSettingsWithOverridesDto {
  settings?: LateFeesSettingsDto;
  overrides: LateFeesSettingsDtoSettingsWithOverrideDto[];
}

/** LatePaymentCountConditionDto */
export type LatePaymentCountConditionDto = ConditionDto & {
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  count: number;
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  lookbackPeriod: number;
  lookbackPeriodUnit: TimePeriod;
};

/** LeaseBalanceConditionDto */
export type LeaseBalanceConditionDto = ConditionDto & {
  /** @format double */
  amount: number;
};

/** LeaseChargeDto */
export interface LeaseChargeDto {
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount: number;
  isCompanyBill: boolean;
  chargeFrequency: ChargeFrequency;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  chartOfAccountId: string;
  description?: string;
  /** @format date */
  startFrom?: string;
}

/** LeaseChartOfAccountSettingsDto */
export interface LeaseChartOfAccountSettingsDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  rentChartOfAccountIds?: string[];
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  defaultSecurityDepositChartOfAccountId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  defaultRentChartOfAccountId: string;
}

/** LeaseChartOfAccountSettingsDtoSettingsWithOverrideDto */
export interface LeaseChartOfAccountSettingsDtoSettingsWithOverrideDto {
  settings?: LeaseChartOfAccountSettingsDto;
  level: SettingsLevel;
  levelId: string;
}

/** LeaseChartOfAccountSettingsDtoSettingsWithOverridesDto */
export interface LeaseChartOfAccountSettingsDtoSettingsWithOverridesDto {
  settings?: LeaseChartOfAccountSettingsDto;
  overrides: LeaseChartOfAccountSettingsDtoSettingsWithOverrideDto[];
}

/** LeaseDocumentAnnotationDto */
export interface LeaseDocumentAnnotationDto {
  /** @minLength 1 */
  id: string;
  signerId?: string;
  /**
   * @format int32
   * @min 1
   * @max 10000
   */
  page: number;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  x: number;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  y: number;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  width: number;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  height: number;
  /**
   * @format double
   * @min 1
   * @max 1000
   */
  fontSize: number;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  text?: string;
  type: LeaseDocumentAnnotationType;
  dataPath?: string;
  isInputField: boolean;
  isVisible?: boolean;
}

/** LeaseDocumentAnnotationType */
export enum LeaseDocumentAnnotationType {
  Text = 'text',
  Initials = 'initials',
  Signature = 'signature',
  DateOnly = 'dateOnly',
  DateTime = 'dateTime',
  Bool = 'bool',
  Flag = 'flag',
  Currency = 'currency',
  Autofill = 'autofill',
  FullName = 'fullName',
  Created = 'created',
}

/** LeaseDocumentDto */
export interface LeaseDocumentDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  companyId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  portfolioId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  unitId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseTemplateIds: string[];
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  fileId: string;
  /** @minLength 1 */
  name: string;
  status: LeaseDocumentStatus;
  signers: LeaseDocumentSignerDto[];
  annotations: LeaseDocumentAnnotationDto[];
  type: LeaseDocumentType;
}

/** LeaseDocumentSignatureDto */
export interface LeaseDocumentSignatureDto {
  /** @minLength 1 */
  destination: string;
  type: DestinationType;
  /** @format date-time */
  sentDate?: string;
  /** @format date-time */
  viewedDate?: string;
  /** @format date-time */
  signedDate?: string;
  signedIp?: string;
}

/** LeaseDocumentSignerDto */
export interface LeaseDocumentSignerDto {
  /** @minLength 1 */
  id: string;
  /**
   * @minLength 2
   * @maxLength 100
   */
  name: string;
  type: LeaseDocumentSignerType;
  signatureStatus: StatusType;
  /** @minLength 1 */
  signatureName: string;
  /** @minLength 1 */
  signatureInitials: string;
  emailSignature?: LeaseDocumentSignatureDto;
  textSignature?: LeaseDocumentSignatureDto;
}

/** LeaseDocumentSignerType */
export enum LeaseDocumentSignerType {
  PropertyManager = 'propertyManager',
  Tenant = 'tenant',
}

/** LeaseDocumentStatus */
export enum LeaseDocumentStatus {
  Draft = 'draft',
  PendingSignatures = 'pendingSignatures',
  Completed = 'completed',
}

/** LeaseDocumentType */
export enum LeaseDocumentType {
  Lease = 'lease',
  LeaseRenewal = 'leaseRenewal',
}

/** LeaseDto */
export interface LeaseDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  portfolioId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  unitId: string;
  /** @format date */
  start: string;
  /** @format date */
  end?: string;
  ended: boolean;
  monthToMonth: boolean;
  eviction: boolean;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  chatId?: string;
  tenants: LeaseTenantDto[];
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  balance: number;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  currentRent: number;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  securityDepositPaid: number;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  securityDepositRequested: number;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  securityDepositDue: number;
  /** @format date */
  lastPaymentDate?: string;
  /** @format date */
  earliestUnpaidBillDueDate?: string;
  icons: string[];
  /** @format date */
  moveOutDate?: string;
  draft: boolean;
  status: LeaseStatus;
  expiringStatus: ExpiringStatus;
  /** @format int32 */
  pastDueDays?: number;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  postedBalance: number;
}

/** LeaseFromType */
export enum LeaseFromType {
  RentalApplication = 'rentalApplication',
}

/** LeaseInvoiceDto */
export interface LeaseInvoiceDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseId: string;
  /** @format date-time */
  issueDate: string;
  /** @format date */
  dueDate: string;
  /** @minLength 1 */
  invoiceNumber: string;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  totalAmount: number;
}

/** LeaseInvoiceSettingsDto */
export interface LeaseInvoiceSettingsDto {
  sendRecurringChargeInvoiceEmail: boolean;
}

/** LeaseInvoiceSettingsDtoSettingsWithOverrideDto */
export interface LeaseInvoiceSettingsDtoSettingsWithOverrideDto {
  settings?: LeaseInvoiceSettingsDto;
  level: SettingsLevel;
  levelId: string;
}

/** LeaseInvoiceSettingsDtoSettingsWithOverridesDto */
export interface LeaseInvoiceSettingsDtoSettingsWithOverridesDto {
  settings?: LeaseInvoiceSettingsDto;
  overrides: LeaseInvoiceSettingsDtoSettingsWithOverrideDto[];
}

/** LeaseMoveOutRequestDto */
export interface LeaseMoveOutRequestDto {
  id: string;
  leaseId: string;
  status: LeaseMoveOutRequestStatus;
  /** @format date-time */
  moveOutDate: string;
  reason?: string;
  /** @format date-time */
  createdDate: string;
  tenant?: TenantDto;
}

/** LeaseMoveOutRequestStatus */
export enum LeaseMoveOutRequestStatus {
  Requested = 'requested',
  Rejected = 'rejected',
  Approved = 'approved',
  Retracted = 'retracted',
}

/** LeaseRecurringChargeStatus */
export enum LeaseRecurringChargeStatus {
  Active = 'active',
  Ended = 'ended',
  DueSoon = 'dueSoon',
}

/** LeaseRecurringOfflinePaymentDto */
export interface LeaseRecurringOfflinePaymentDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  tenantId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  portfolioId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  unitId: string;
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount?: number;
  chargeFrequency: ChargeFrequency;
  paymentMethod: TransactionPaymentMethod;
  /** @minLength 1 */
  description?: string;
  /** @minLength 1 */
  reference?: string;
  /** @format date */
  lastPayment?: string;
  /** @format date */
  nextPayment: string;
  /** @format date */
  startFrom: string;
  /** @format date */
  end?: string;
}

/** LeaseRenewalOfferAutomaticSettingDto */
export interface LeaseRenewalOfferAutomaticSettingDto {
  id: string;
  companyId: string;
  portfolioId?: string;
  propertyId?: string;
  creator: CreatorDto;
  /** @format int32 */
  addDaysBefore: number;
  /** @format double */
  rentIncrease: number;
  /** @format int32 */
  newLeaseLengthMonths: number;
  newRecurringCharges: NewRecurringChargeDto[];
  conditions: ConditionGroupDto[];
  sendTenantNotifyOnRenewal: boolean;
  leaseTemplateIds: string[];
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** LeaseRenewalOfferAutomaticSettingGroupsDto */
export interface LeaseRenewalOfferAutomaticSettingGroupsDto {
  global: LeaseRenewalOfferAutomaticSettingDto[];
  portfolio: PortfolioGroupDto[];
  property: PropertyGroupDto[];
}

/** LeaseRenewalOfferDto */
export interface LeaseRenewalOfferDto {
  id: string;
  status: LeaseRenewalStatus;
  requiresSigning: boolean;
  recurringChargeChanges: RecurringChargeChangeDto[];
  newRecurringCharges: NewRecurringChargeDto[];
  /** @format date */
  newEndDate?: string;
  customLeaseText?: string;
  leaseDocumentId?: string;
  finalized: boolean;
  /** @format date */
  offerExpires?: string;
  currentCharges: RecurringLeaseChargeDto[];
  chartOfAccounts: ChartOfAccountDto[];
  leaseTemplateIds: string[];
}

/** LeaseRenewalOfferListItemDto */
export interface LeaseRenewalOfferListItemDto {
  id: string;
  status: LeaseRenewalStatus;
  requiresSigning: boolean;
  recurringChargeChanges: RecurringChargeChangeDto[];
  newRecurringCharges: NewRecurringChargeDto[];
  /** @format date */
  newEndDate?: string;
  customLeaseText?: string;
  leaseDocumentId?: string;
  finalized: boolean;
  /** @format date */
  offerExpires?: string;
  currentCharges: RecurringLeaseChargeDto[];
  leaseTemplateIds: string[];
}

/** LeaseRenewalOfferSummariesDto */
export interface LeaseRenewalOfferSummariesDto {
  offers: LeaseRenewalOfferSummaryDto[];
}

/** LeaseRenewalOfferSummaryDto */
export interface LeaseRenewalOfferSummaryDto {
  id: string;
  status: LeaseRenewalStatus;
  /** @format double */
  newRent: number;
  /** @format date */
  newEndDate?: string;
  month2Month: boolean;
  /** @format date */
  offerExpires?: string;
}

/** LeaseRenewalSettingsDto */
export interface LeaseRenewalSettingsDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  rentChartOfAccounts: string[];
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseTemplates: string[];
  sendTenantNotifyOnRenewal: boolean;
}

/** LeaseRenewalSettingsDtoSettingsWithOverrideDto */
export interface LeaseRenewalSettingsDtoSettingsWithOverrideDto {
  settings?: LeaseRenewalSettingsDto;
  level: SettingsLevel;
  levelId: string;
}

/** LeaseRenewalSettingsDtoSettingsWithOverridesDto */
export interface LeaseRenewalSettingsDtoSettingsWithOverridesDto {
  settings?: LeaseRenewalSettingsDto;
  overrides: LeaseRenewalSettingsDtoSettingsWithOverrideDto[];
}

/** LeaseRenewalStatus */
export enum LeaseRenewalStatus {
  Offered = 'offered',
  Signing = 'signing',
  Finalized = 'finalized',
  Rejected = 'rejected',
  Retracted = 'retracted',
}

/** LeaseRentersInsuranceDto */
export interface LeaseRentersInsuranceDto {
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  source: LeaseRentersInsuranceSource;
  active: boolean;
  carrierName: string;
  policyNumber?: string;
  /** @format double */
  coverageAmount?: number;
  /** @format date */
  policyStartDate?: string;
  /** @format date */
  policyEndDate?: string;
  /** @format date */
  policyCanceledDate?: string;
  status: LeaseRentersInsuranceStatus;
  insurancePolicyFileId?: string;
  insurancePolicyFile?: FileDto;
}

/** LeaseRentersInsuranceItemDto */
export interface LeaseRentersInsuranceItemDto {
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  source: LeaseRentersInsuranceSource;
  active: boolean;
  carrierName: string;
  policyNumber?: string;
  /** @format double */
  coverageAmount?: number;
  /** @format date */
  policyStartDate?: string;
  /** @format date */
  policyEndDate?: string;
  /** @format date */
  policyCanceledDate?: string;
  status: LeaseRentersInsuranceStatus;
  insurancePolicyFileId?: string;
}

/** LeaseRentersInsuranceSettingsDto */
export interface LeaseRentersInsuranceSettingsDto {
  reminderEnabled: boolean;
  /**
   * @format int32
   * @min -30
   * @max 30
   */
  reminderStartDays: number;
  /**
   * @format int32
   * @min 1
   * @max 31
   */
  reminderFrequencyBefore: number;
  /**
   * @format int32
   * @min 1
   * @max 31
   */
  reminderFrequencyAfter: number;
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  reminderEndDays: number;
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  reminderMaxCount: number;
  notifyTenantsOnPolicyIssued: boolean;
  notifyTenantsOnPolicyExpiring: boolean;
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  policyExpiringReminderDays: number;
}

/** LeaseRentersInsuranceSettingsDtoSettingsWithOverrideDto */
export interface LeaseRentersInsuranceSettingsDtoSettingsWithOverrideDto {
  settings?: LeaseRentersInsuranceSettingsDto;
  level: SettingsLevel;
  levelId: string;
}

/** LeaseRentersInsuranceSettingsDtoSettingsWithOverridesDto */
export interface LeaseRentersInsuranceSettingsDtoSettingsWithOverridesDto {
  settings?: LeaseRentersInsuranceSettingsDto;
  overrides: LeaseRentersInsuranceSettingsDtoSettingsWithOverrideDto[];
}

/** LeaseRentersInsuranceSource */
export enum LeaseRentersInsuranceSource {
  Manual = 'manual',
  Sure = 'sure',
}

/** LeaseRentersInsuranceStatus */
export enum LeaseRentersInsuranceStatus {
  UpComing = 'upComing',
  Active = 'active',
  Expired = 'expired',
  Canceled = 'canceled',
  Inactive = 'inactive',
}

/** LeaseRentersInsurancesDto */
export interface LeaseRentersInsurancesDto {
  insurances: LeaseRentersInsuranceItemDto[];
  insurancePolicyFiles: FileDto[];
}

/** LeaseStatus */
export enum LeaseStatus {
  Lease = 'lease',
  LeaseMonthToMonth = 'leaseMonthToMonth',
  MonthToMonth = 'monthToMonth',
  Eviction = 'eviction',
  Expired = 'expired',
  Draft = 'draft',
  Ended = 'ended',
  Future = 'future',
}

/** LeaseTemplateCategoryDto */
export interface LeaseTemplateCategoryDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  name: string;
  isDefault: boolean;
}

/** LeaseTemplateDto */
export interface LeaseTemplateDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseTemplateCategoryId: string;
  /** @minLength 1 */
  name: string;
  /** @minLength 1 */
  description?: string;
  signers: LeaseTemplateSignerDto[];
  annotations: LeaseDocumentAnnotationDto[];
  type: LeaseTemplateType;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  fileId: string;
  /** @minLength 1 */
  fileName: string;
  /**
   * @minLength 1
   * @maxLength 10
   */
  fileExtension: string;
  /** @minLength 1 */
  signedUrl: string;
  /** @minLength 1 */
  contentType: string;
  /** @format int64 */
  fileSize: number;
  isDefault: boolean;
}

/** LeaseTemplateSignerDto */
export interface LeaseTemplateSignerDto {
  /** @minLength 1 */
  id: string;
  /**
   * @minLength 2
   * @maxLength 100
   */
  name: string;
  type: LeaseDocumentSignerType;
}

/** LeaseTemplateType */
export enum LeaseTemplateType {
  Lease = 'lease',
  LeaseRenewal = 'leaseRenewal',
  LateRentNotice = 'lateRentNotice',
  Eviction = 'eviction',
  SignatureOnly = 'signatureOnly',
  Information = 'information',
}

/** LeaseTenantDto */
export interface LeaseTenantDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  tenantId: string;
  /** @format date */
  moveIn: string;
  /** @format date */
  moveOut?: string;
}

/** LeaseTerm */
export enum LeaseTerm {
  MonthToMonth = 'monthToMonth',
  HalfYear = 'halfYear',
  OneYear = 'oneYear',
  TwoYears = 'twoYears',
  ThreeYears = 'threeYears',
  Other = 'other',
}

/** LeaseTransactionStatus */
export enum LeaseTransactionStatus {
  Future = 'future',
  Due = 'due',
  PastDue = 'pastDue',
  Paid = 'paid',
  Failed = 'failed',
  Returned = 'returned',
  Processing = 'processing',
  Settled = 'settled',
  Disputing = 'disputing',
}

/** LeaseUnpaidLedgerReportDto */
export interface LeaseUnpaidLedgerReportDto {
  lease: LeaseDto;
  property: PropertyDto;
  unit: UnitDto;
  tenants: TenantDto[];
  unpaidBills: BillDto[];
  chartOfAccounts: ChartOfAccountDto[];
}

/** LeaseWithTenantDto */
export interface LeaseWithTenantDto {
  lease: LeaseTenantDto;
  tenant: TenantDto;
}

/** LegalEntityType */
export enum LegalEntityType {
  SoleProprietorship = 'soleProprietorship',
  Llc = 'llc',
  PrivateCompany = 'privateCompany',
  PublicCompanyUnlisted = 'publicCompanyUnlisted',
  PublicCompanyListed = 'publicCompanyListed',
  CharitableOrganizationNotForProfit = 'charitableOrganizationNotForProfit',
  Partnership = 'partnership',
}

/** LevelSearch */
export enum LevelSearch {
  Portfolio = 'portfolio',
  Property = 'property',
  Unit = 'unit',
  Lease = 'lease',
}

/** LineItemDto */
export interface LineItemDto {
  bill: BillDto;
  transaction: TransactionDto;
  /** @format double */
  amount: number;
  /** @format double */
  balance: number;
}

/** LineItemReportDto */
export interface LineItemReportDto {
  propertyId?: string;
  tenantId?: string;
  vendorId?: string;
  /** @format date-time */
  date: string;
  transactionId: string;
  paymentMethod: TransactionPaymentMethod;
  /** @format double */
  debit?: number;
  /** @format double */
  credit?: number;
  /** @format double */
  balance: number;
  memo?: string;
  payeeOrPayerName: string;
  billId: string;
}

/** ListRunBookDto */
export interface ListRunBookDto {
  publicRunBook: boolean;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  title: string;
  /**
   * @minLength 1
   * @maxLength 250
   */
  description: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string;
  /** @deprecated */
  vendorId?: string;
  defaultVendorId?: string;
  defaultPropertyManagerId?: string;
  enabled: boolean;
  /** @format int32 */
  usageCount: number;
  /** @format date-time */
  lastUsed?: string;
}

/** LogicalOperator */
export enum LogicalOperator {
  And = 'and',
  Or = 'or',
}

/** MagicChatTextRequestDto */
export interface MagicChatTextRequestDto {
  /** @minLength 1 */
  myText: string;
}

/** MagicChatTextResponseDto */
export interface MagicChatTextResponseDto {
  suggestedText?: string;
  failed: boolean;
}

/** MagicUserType */
export enum MagicUserType {
  System = 'system',
  MagicDoor = 'magicDoor',
  PropertyManager = 'propertyManager',
  Tenant = 'tenant',
  Vendor = 'vendor',
  Owner = 'owner',
}

/** MaintenanceRequestCategoryDto */
export interface MaintenanceRequestCategoryDto {
  id: string;
  name: string;
  description?: string;
}

/** MaintenanceRequestCountConditionDto */
export type MaintenanceRequestCountConditionDto = ConditionDto & {
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  count: number;
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  lookbackPeriod: number;
  lookbackPeriodUnit: TimePeriod;
};

/** MaintenanceRequestDto */
export interface MaintenanceRequestDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  assignedPropertyManagerId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  unitId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  portfolioId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  tenantId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  chatId?: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  title: string;
  status: MaintenanceRequestStatus;
  urgency: Urgency;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  categoryId?: string;
  disableAi: boolean;
  /**
   * @format int32
   * @min 0
   * @max 100
   */
  aiUrgencyScore: number;
  /** @format date-time */
  created: string;
  /** @format date-time */
  lastUpdated: string;
  aiProcessed: boolean;
  newRequest: boolean;
  /** @minLength 1 */
  description: string;
  /** @minLength 1 */
  internalDescription?: string;
  files: MaintenanceRequestFileDto[];
  permissionToEnter: boolean;
  /** @format date */
  due?: string;
  runBookId?: string;
  tenant: TenantDto;
  propertyManager?: PropertyManagerDto;
  property: PropertyDto;
  unit: UnitDto;
  lease: LeaseDto;
  category?: MaintenanceRequestCategoryDto;
  workOrder?: WorkOrderListDto;
  owners: PropertyOwnerDto[];
  /** @format double */
  ownerApprovalLimit?: number;
  runBook?: ListRunBookDto;
}

/** MaintenanceRequestFileDto */
export interface MaintenanceRequestFileDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  fileId: string;
  fileName: string;
  signedUrl: string;
  signedThumbUrl?: string;
  /** @format int64 */
  fileSize: number;
  /** @format date-time */
  uploaded: string;
  description?: string;
}

/** MaintenanceRequestListDto */
export interface MaintenanceRequestListDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  assignedPropertyManagerId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  unitId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  portfolioId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  tenantId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  chatId?: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  title: string;
  status: MaintenanceRequestStatus;
  urgency: Urgency;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  categoryId?: string;
  disableAi: boolean;
  /**
   * @format int32
   * @min 0
   * @max 100
   */
  aiUrgencyScore: number;
  /** @format date-time */
  created: string;
  /** @format date-time */
  lastUpdated: string;
  aiProcessed: boolean;
  newRequest: boolean;
}

/** MaintenanceRequestPaginationDto */
export interface MaintenanceRequestPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: MaintenanceRequestListDto[];
  tenants: TenantDto[];
  propertyManagers: PropertyManagerDto[];
  properties: PropertyDto[];
  units: UnitDto[];
  leases: LeaseDto[];
  categories: MaintenanceRequestCategoryDto[];
  runBooks: ListRunBookDto[];
}

/** MaintenanceRequestRunBookSettingsDto */
export interface MaintenanceRequestRunBookSettingsDto {
  enableRunBook: boolean;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  defaultPropertyManagerId?: string;
}

/** MaintenanceRequestRunBookSettingsDtoSettingsWithOverrideDto */
export interface MaintenanceRequestRunBookSettingsDtoSettingsWithOverrideDto {
  settings?: MaintenanceRequestRunBookSettingsDto;
  level: SettingsLevel;
  levelId: string;
}

/** MaintenanceRequestRunBookSettingsDtoSettingsWithOverridesDto */
export interface MaintenanceRequestRunBookSettingsDtoSettingsWithOverridesDto {
  settings?: MaintenanceRequestRunBookSettingsDto;
  overrides: MaintenanceRequestRunBookSettingsDtoSettingsWithOverrideDto[];
}

/** MaintenanceRequestSettingsDto */
export interface MaintenanceRequestSettingsDto {
  allowTenantToClose: boolean;
  onlyAllowRequesterToClose: boolean;
  allowTenantToEdit: boolean;
  onlyAllowRequesterToEdit: boolean;
  /** @format int32 */
  recentRequestsDays: number;
}

/** MaintenanceRequestSettingsDtoSettingsWithOverrideDto */
export interface MaintenanceRequestSettingsDtoSettingsWithOverrideDto {
  settings?: MaintenanceRequestSettingsDto;
  level: SettingsLevel;
  levelId: string;
}

/** MaintenanceRequestSettingsDtoSettingsWithOverridesDto */
export interface MaintenanceRequestSettingsDtoSettingsWithOverridesDto {
  settings?: MaintenanceRequestSettingsDto;
  overrides: MaintenanceRequestSettingsDtoSettingsWithOverrideDto[];
}

/** MaintenanceRequestStatus */
export enum MaintenanceRequestStatus {
  Closed = 'closed',
  Pending = 'pending',
  InProgress = 'inProgress',
  AiProcessing = 'aiProcessing',
  WaitingForWorkOrder = 'waitingForWorkOrder',
}

/** MaintenanceRequestsStatsDto */
export interface MaintenanceRequestsStatsDto {
  /** @format int32 */
  allOpen: number;
  /** @format int32 */
  newRequests: number;
  /** @format int32 */
  waitingForWorkOrder: number;
  /** @format int32 */
  aiProcessing: number;
  /** @format int32 */
  inProgress: number;
  /** @format int32 */
  pending: number;
  /** @format int32 */
  closed: number;
  /** @format date-time */
  cacheDate: string;
}

/** ManagementFeeDate */
export enum ManagementFeeDate {
  EndOfLastMonth = 'endOfLastMonth',
  Now = 'now',
}

/** ManagementFeeDto */
export interface ManagementFeeDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId: string;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  feeAmount: number;
  memo?: string;
}

/** ManagementFeeSettingsDto */
export interface ManagementFeeSettingsDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  ignoreChartOfAccounts: string[];
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  includeChartOfAccounts: string[];
  includeDebits: boolean;
  createSupplementaryBills: boolean;
  feeType: ManagementFeeType;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  feePercentage: number;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  minimumFee: number;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  maximumFee?: number;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  managementFeePropertyChartOfAccountId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  managementFeeCompanyChartOfAccountId: string;
}

/** ManagementFeeSettingsDtoSettingsWithOverrideDto */
export interface ManagementFeeSettingsDtoSettingsWithOverrideDto {
  settings?: ManagementFeeSettingsDto;
  level: SettingsLevel;
  levelId: string;
}

/** ManagementFeeSettingsDtoSettingsWithOverridesDto */
export interface ManagementFeeSettingsDtoSettingsWithOverridesDto {
  settings?: ManagementFeeSettingsDto;
  overrides: ManagementFeeSettingsDtoSettingsWithOverrideDto[];
}

/** ManagementFeeType */
export enum ManagementFeeType {
  Fixed = 'fixed',
  Percentage = 'percentage',
}

/** ManagementFeesPropertyDto */
export interface ManagementFeesPropertyDto {
  property: PropertyDto;
  /** @format date-time */
  managementFeeAlreadyChargedUntil?: string;
  /** @format int32 */
  year: number;
  /** @format int32 */
  month: number;
  /** @format double */
  managementFee: number;
  /** @format double */
  revenue: number;
  /** @format double */
  credits: number;
  /** @format double */
  debits: number;
  bills: HydratedBillDto[];
  settings: ManagementFeeSettingsDto;
  feeDateRange: DateOnlyRangeDto;
  memo: string;
}

/** ManagementFeesResultDto */
export interface ManagementFeesResultDto {
  /** @format date-time */
  calculateFeesUntil: string;
  properties: ManagementFeesPropertyDto[];
}

/** MaritalStatus */
export enum MaritalStatus {
  Single = 'single',
  Married = 'married',
  Divorced = 'divorced',
  Widowed = 'widowed',
}

/** MeetingScheduleDto */
export interface MeetingScheduleDto {
  id: string;
  source: MeetingScheduleSource;
  title: string;
  description?: string;
  link?: string;
  externalProvider?: string;
  externalIdentifier?: string;
  /** @format date-time */
  startTime: string;
  /** @format date-time */
  endTime: string;
  metadata?: Record<string, string>;
  /** @format date-time */
  cancelled?: string;
  cancellationReason?: string;
  status: MeetingScheduleStatus;
}

/** MeetingScheduleDtoPaginationDto */
export interface MeetingScheduleDtoPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: MeetingScheduleDto[];
}

/** MeetingScheduleSource */
export enum MeetingScheduleSource {
  Manual = 'manual',
  External = 'external',
}

/** MeetingScheduleStatus */
export enum MeetingScheduleStatus {
  Active = 'active',
  Ended = 'ended',
  Cancelled = 'cancelled',
}

/** MessageSource */
export enum MessageSource {
  App = 'app',
  Email = 'email',
  Text = 'text',
  System = 'system',
  Notification = 'notification',
}

/** MessageType */
export enum MessageType {
  Participant = 'participant',
  PropertyManager = 'propertyManager',
  Bot = 'bot',
  Announcement = 'announcement',
}

/** MineWorkOrdersDto */
export interface MineWorkOrdersDto {
  portfolios: PortfolioDto[];
  properties: PropertyDto[];
  units: UnitDto[];
  leases: LeaseDto[];
  vendors: VendorDto[];
  items: WorkOrderListDto[];
  /** @format int32 */
  totalCount: number;
  urgencies: {
    /** @format int32 */
    urgent?: number;
    /** @format int32 */
    high?: number;
    /** @format int32 */
    medium?: number;
    /** @format int32 */
    low?: number;
    /** @format int32 */
    none?: number;
  };
}

/** MinimumPaymentType */
export enum MinimumPaymentType {
  Fixed = 'fixed',
  Percent = 'percent',
  PercentOrMinimum = 'percentOrMinimum',
}

/** MoveInDto */
export interface MoveInDto {
  /** @format date */
  moveIn?: string;
}

/** MovePropertyDto */
export interface MovePropertyDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  portfolioId: string;
}

/** MoveUnitDto */
export interface MoveUnitDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId: string;
}

/** NameDto */
export interface NameDto {
  /** @minLength 1 */
  name: string;
}

/** NewPropertyManagerDto */
export interface NewPropertyManagerDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  /**
   * @format email
   * @minLength 1
   */
  email: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  firstName: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  lastName?: string;
  active: boolean;
  /** @format date-time */
  created: string;
  /** @format date-time */
  lastSeen?: string;
  name: string;
  imageId?: string;
  image?: PropertyManagerImageDto;
  /** @minLength 1 */
  clearTextPassword: string;
}

/** NewRecurringChargeDto */
export interface NewRecurringChargeDto {
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  amount: number;
  chargeFrequency: ChargeFrequency;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  chartOfAccountId: string;
  description?: string;
  companyCharge: boolean;
}

/** NextCheckNumberDto */
export interface NextCheckNumberDto {
  /** @format int32 */
  nextCheckNumber: number;
}

/** NoteDto */
export interface NoteDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  /** @minLength 1 */
  content: string;
  /** @format date-time */
  createdAt: string;
  propertyManager: PropertyManagerDto;
}

/** NoteListDto */
export interface NoteListDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  /** @minLength 1 */
  content: string;
  /** @format date-time */
  createdAt: string;
  propertyManager: PropertyManagerDto;
}

/** NoteListDtoPaginationDto */
export interface NoteListDtoPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: NoteListDto[];
}

/** NotificationScheduleDto */
export interface NotificationScheduleDto {
  id: string;
  source: NotificationSource;
  target: TenantNotificationTargetDto;
  template: NotificationTemplateDto;
  /** @format date-time */
  time: string;
  /** @format date-time */
  sent?: string;
  status: NotificationStatus;
  failureReason?: string;
  /** @format date-time */
  created: string;
}

/** NotificationScheduleDtoPaginationDto */
export interface NotificationScheduleDtoPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: NotificationScheduleDto[];
}

/** NotificationSource */
export enum NotificationSource {
  System = 'system',
  Manual = 'manual',
}

/** NotificationStatus */
export enum NotificationStatus {
  Pending = 'pending',
  Sent = 'sent',
  Skipped = 'skipped',
  Failed = 'failed',
}

/** NotificationTargetDto */
export interface NotificationTargetDto {
  type: string;
}

/** NotificationTemplateDto */
export interface NotificationTemplateDto {
  /**
   * @minLength 0
   * @maxLength 200
   */
  subject: string;
  /**
   * @minLength 0
   * @maxLength 20000
   */
  emailMessage?: string;
  /**
   * @minLength 0
   * @maxLength 2000
   */
  textMessage?: string;
}

/** OfflinePaymentDto */
export interface OfflinePaymentDto {
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount: number;
  /** @format date */
  date: string;
  /** @minLength 1 */
  description?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  tenantId?: string;
  paymentMethod?: OfflineTransactionPaymentMethod;
  /**
   * @minLength 0
   * @maxLength 150
   */
  reference?: string;
}

/** OfflineTransactionPaymentMethod */
export enum OfflineTransactionPaymentMethod {
  Check = 'check',
  CashiersCheck = 'cashiersCheck',
  MoneyOrder = 'moneyOrder',
  Cash = 'cash',
  Other = 'other',
}

/** OtpAuthDto */
export interface OtpAuthDto {
  /**
   * @minLength 1
   * @maxLength 64
   */
  requestId: string;
  /**
   * @minLength 6
   * @maxLength 6
   */
  otp: string;
}

/** OwnerDirectoryReportBillDueDto */
export interface OwnerDirectoryReportBillDueDto {
  billId: string;
  /** @format date-time */
  dueDate: string;
  description: string;
  /** @format double */
  amount: number;
  /** @format double */
  totalAmount: number;
}

/** OwnerDirectoryReportBillDueTotalDto */
export interface OwnerDirectoryReportBillDueTotalDto {
  /** @format double */
  amount: number;
}

/** OwnerDirectoryReportDto */
export interface OwnerDirectoryReportDto {
  items: OwnerDirectoryReportItemDto[];
}

/** OwnerDirectoryReportItemDto */
export interface OwnerDirectoryReportItemDto {
  owner: OwnerDto;
  properties: OwnerDirectoryReportItemPropertyDto[];
}

/** OwnerDirectoryReportItemPropertyDto */
export interface OwnerDirectoryReportItemPropertyDto {
  portfolio: PortfolioDto;
  property: PropertyDto;
  ownerProperty: OwnerPropertyDto;
}

/** OwnerDirectoryReportTransactionTotalDto */
export interface OwnerDirectoryReportTransactionTotalDto {
  /** @format double */
  cashIn: number;
  /** @format double */
  cashOut: number;
}

/** OwnerDistributionAchResultsDto */
export interface OwnerDistributionAchResultsDto {
  successful: OwnerDistributionResultDto[];
  scheduled: OwnerDistributionResultDto[];
  failed: FailedOwnerDistributionAchResultDto[];
}

/** OwnerDistributionPrintCheckResultDto */
export interface OwnerDistributionPrintCheckResultDto {
  owner: OwnerDto;
  bankAccount: BankAccountDto;
  transaction: TransactionDto;
  properties: OwnerDistributionPropertyResultDto[];
  check: HydratedCheckDto;
}

/** OwnerDistributionPropertyResultDto */
export interface OwnerDistributionPropertyResultDto {
  property: PropertyDto;
  bill: BillDto;
}

/** OwnerDistributionResultDto */
export interface OwnerDistributionResultDto {
  owner: OwnerDto;
  bankAccount: BankAccountDto;
  transaction: TransactionDto;
  properties: OwnerDistributionPropertyResultDto[];
}

/** OwnerDistributionsResultDto */
export interface OwnerDistributionsResultDto {
  manual: OwnerDistributionResultDto[];
  printCheck: OwnerDistributionPrintCheckResultDto[];
  ach: OwnerDistributionAchResultsDto;
}

/** OwnerDto */
export interface OwnerDto {
  id: string;
  active: boolean;
  email?: string;
  firstName: string;
  lastName?: string;
  isCompany: boolean;
  phone?: string;
  federalTaxInformation?: FederalTaxInformationDto;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format date-time */
  lastSeen?: string;
  /** @format date-time */
  lastPortalInvite?: string;
  chatId?: string;
  language: string;
  icons: string[];
  address?: AddressDto;
  portalStatus: PortalStatus;
}

/** OwnerPortalInviteResponseDto */
export interface OwnerPortalInviteResponseDto {
  /** @minLength 1 */
  newPassword: string;
}

/** OwnerPropertyDto */
export interface OwnerPropertyDto {
  id: string;
  portfolioId: string;
  propertyId: string;
  ownerId: string;
  /** @format double */
  ownershipPercentage: number;
}

/** OwnerStatementReportDto */
export interface OwnerStatementReportDto {
  owner: OwnerDto;
  dateRange: DateRangeDto;
  properties: OwnerStatementReportPropertyDto[];
  tenants: Record<string, TenantDto>;
  vendors: Record<string, VendorDto>;
}

/** OwnerStatementReportPropertyDto */
export interface OwnerStatementReportPropertyDto {
  /** @format double */
  beginningCash: number;
  /** @format double */
  cashIn: number;
  /** @format double */
  cashOut: number;
  /** @format double */
  ownerContributions: number;
  /** @format double */
  ownerDistributions: number;
  /** @format double */
  companyCredits: number;
  /** @format double */
  endingCash: number;
  /** @format double */
  unpaid: number;
  /** @format double */
  propertyReserve: number;
  /** @format double */
  netOwnerFunds: number;
  property: PropertyDto;
  portfolio: PortfolioDto;
  ownerProperty: OwnerPropertyDto;
  transactions: OwnerStatementReportTransactionDto[];
  transactionsTotal: OwnerDirectoryReportTransactionTotalDto;
  billsDue: OwnerDirectoryReportBillDueDto[];
  billsDueTotal: OwnerDirectoryReportBillDueTotalDto;
}

/** OwnerStatementReportTransactionDto */
export interface OwnerStatementReportTransactionDto {
  billId: string;
  chartOfAccountId: string;
  tenantId: string;
  vendorId: string;
  transactionId: string;
  /** @format date */
  paymentDate: string;
  payeeOrPayerName: string;
  description: string;
  /** @format double */
  cashIn: number;
  /** @format double */
  cashOut: number;
  /** @format double */
  balance: number;
}

/** OwnerTaxAmountDto */
export interface OwnerTaxAmountDto {
  accountId: string;
  /** @format int32 */
  calendarYear: number;
  /** @format double */
  rentAmount: number;
  /** @format double */
  otherAmount: number;
  documentAlreadyExists: boolean;
  amountHasChanged: boolean;
  hasTaxId: boolean;
  owner: OwnerDto;
}

/** OwnerTaxDocumentAmountDto */
export interface OwnerTaxDocumentAmountDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  accountId: string;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  rentAmount: number;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  otherAmount: number;
}

/** OwnerTaxDocumentDto */
export interface OwnerTaxDocumentDto {
  id: string;
  /** @format int32 */
  calendarYear: number;
  entityName?: string;
  entityId?: string;
  /** @format double */
  amount: number;
  taxDocumentType: TaxType;
  documentName?: string;
  documentUrl?: string;
  status: ProcessStatus;
  taskErrorMessage?: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  annotations?: TaxDocumentAnnotation[];
  /** @format double */
  otherAmount: number;
}

/** OwnerTaxDocumentListDto */
export interface OwnerTaxDocumentListDto {
  id: string;
  /** @format int32 */
  calendarYear: number;
  entityName?: string;
  entityId?: string;
  /** @format double */
  amount: number;
  taxDocumentType: TaxType;
  documentName?: string;
  documentUrl?: string;
  status: ProcessStatus;
  taskErrorMessage?: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  annotations?: TaxDocumentAnnotation[];
  /** @format double */
  otherAmount: number;
}

/** OwnerTaxDocumentPaginationDto */
export interface OwnerTaxDocumentPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: OwnerTaxDocumentListDto[];
}

/** OwnerTransferDto */
export interface OwnerTransferDto {
  id: string;
  companyId: string;
  ownerId: string;
  portfolioId: string;
  propertyId: string;
  type: OwnerTransferType;
  /** @format double */
  amount: number;
  /** @format date-time */
  created: string;
  bankAccountId?: string;
  billId?: string;
  transactionId?: string;
  owner: OwnerDto;
  property: PropertyDto;
  bankAccount?: BankAccountDto;
  bill?: BillDto;
  transaction?: TransactionDto;
}

/** OwnerTransferListDto */
export interface OwnerTransferListDto {
  id: string;
  companyId: string;
  ownerId: string;
  portfolioId: string;
  propertyId: string;
  type: OwnerTransferType;
  /** @format double */
  amount: number;
  /** @format date-time */
  created: string;
  bankAccountId?: string;
  billId?: string;
  transactionId?: string;
}

/** OwnerTransferPaginatedDto */
export interface OwnerTransferPaginatedDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: OwnerTransferListDto[];
  owners: OwnerDto[];
  properties: PropertyDto[];
  bankAccounts: BankAccountDto[];
  bills: BillDto[];
  transactions: TransactionDto[];
}

/** OwnerTransferType */
export enum OwnerTransferType {
  Contribution = 'contribution',
  Distribution = 'distribution',
}

/** PaginatedAssociationViolationListDto */
export interface PaginatedAssociationViolationListDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: AssociationViolationListDto[];
  portfolios: PortfolioDto[];
  properties: PropertyDto[];
  units: UnitDto[];
  leases: LeaseDto[];
  vendors: VendorDto[];
}

/** PaginatedBillsDto */
export interface PaginatedBillsDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: BillDto[];
  chartOfAccounts: ChartOfAccountDto[];
  portfolios: PortfolioDto[];
  properties: PropertyDto[];
  units: UnitDto[];
  vendors: VendorDto[];
  owners: OwnerDto[];
  tenants: TenantDto[];
  propertyManagers: PropertyManagerDto[];
}

/** PaginatedChecksDto */
export interface PaginatedChecksDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: CheckDto[];
  bankAccounts: BankAccountDto[];
  vendors: VendorDto[];
  owners: OwnerDto[];
}

/** PaginatedHydratedLeaseDocumentDto */
export interface PaginatedHydratedLeaseDocumentDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: LeaseDocumentDto[];
  properties: PropertyDto[];
  units: UnitDto[];
  leases: LeaseDto[];
  files: FileDto[];
}

/** PaginatedUnitListingDto */
export interface PaginatedUnitListingDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: UnitListingDto[];
  portfolios: PortfolioDto[];
  properties: PropertyDto[];
}

/** PasswordAuthDto */
export interface PasswordAuthDto {
  /**
   * @format email
   * @minLength 1
   * @maxLength 250
   */
  email: string;
  /**
   * @minLength 1
   * @maxLength 250
   */
  password: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  companyId?: string;
}

/** PastCompanyPayOutDto */
export interface PastCompanyPayOutDto {
  transaction: TransactionDto;
  check?: HydratedCheckDto;
}

/** PastCompanyPayOutDtoPaginationDto */
export interface PastCompanyPayOutDtoPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: PastCompanyPayOutDto[];
}

/** PayBillType */
export enum PayBillType {
  Manual = 'manual',
  PrintCheck = 'printCheck',
  Ach = 'ach',
}

/** PayBillsResultsDto */
export interface PayBillsResultsDto {
  manual: VendorBillResultDto[];
  printCheck: VendorBillPrintCheckResultDto[];
  ach: VendorBillAchResultsDto;
  properties: PropertyDto[];
}

/** PayCompanyInvoiceDto */
export interface PayCompanyInvoiceDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  paymentAccountId?: string;
}

/** PayOutResultDto */
export interface PayOutResultDto {
  /** @format double */
  amount: number;
  check: HydratedCheckDto;
  bankAccount: BankAccountDto;
  transaction: TransactionDto;
}

/** PayOutResultsDto */
export interface PayOutResultsDto {
  payOuts: PayOutResultDto[];
}

/** PayVendorBillsDto */
export interface PayVendorBillsDto {
  /** @format date */
  paymentDate?: string;
  /** @minItems 1 */
  groups: PayVendorBillsGroupDto[];
}

/** PayVendorBillsGroupDto */
export interface PayVendorBillsGroupDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  vendorId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  bankAccountId: string;
  paymentType: PayBillType;
  /** Required if payment type is `Manual` */
  paymentMethod?: TransactionPaymentMethod;
  /**
   * Required if payment type is `Manual`
   * @minLength 0
   * @maxLength 100
   */
  externalTransactionId?: string;
  /**
   * Required if payment type is `ACH`
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  paymentAccountId?: string;
  /**
   * @minLength 0
   * @maxLength 250
   */
  memo?: string;
  payments: VendorBillPaymentDto[];
}

/** PaymentAccountDto */
export interface PaymentAccountDto {
  id: string;
  name: string;
  accountMask?: string;
  accountProvider: PaymentAccountProvider;
  mapped: boolean;
  bankInformation?: BankRoutingDto;
  stripe?: StripePaymentAccountDto;
  plaid?: PlaidPaymentAccountDto;
}

/** PaymentAccountProvider */
export enum PaymentAccountProvider {
  Plaid = 'plaid',
  Stripe = 'stripe',
  None = 'none',
}

/** PaymentAccountsDto */
export interface PaymentAccountsDto {
  paymentAccounts: PaymentAccountDto[];
}

/** PaymentSettingsDto */
export interface PaymentSettingsDto {
  onePaymentPerBill: boolean;
}

/** PetDto */
export interface PetDto {
  /**
   * @minLength 1
   * @maxLength 150
   */
  name?: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  breed: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  weight?: string;
  /**
   * @format int32
   * @min 0
   * @max 100
   */
  age?: number;
  gender?: Gender;
  isSpayedOrNeutered?: boolean;
  isServiceAnimal?: boolean;
  isEmotionalSupportAnimal?: boolean;
}

/** PetPolicyDto */
export interface PetPolicyDto {
  allowed?: boolean;
  policies?: {
    cat?: boolean;
    dog?: boolean;
    fish?: boolean;
    bird?: boolean;
    reptile?: boolean;
    other?: boolean;
  };
  size?: PetSize;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  fee?: number;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  deposit?: number;
  /**
   * @minLength 0
   * @maxLength 200
   */
  description?: string;
}

/** PetSize */
export enum PetSize {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

/** PlaidConnectedStatusDto */
export interface PlaidConnectedStatusDto {
  status: BankAccountConnectionStatus;
  balance: BankAccountConnectionBalance;
  deniedReason?: string;
  externalAccountId?: string;
}

/** PlaidPaymentAccountDto */
export interface PlaidPaymentAccountDto {
  plaidAccountNumber: string;
  plaidAccountName: string;
  plaidAccountOfficialName?: string;
  plaidAccountType: string;
}

/** PlaidSweepStatus */
export enum PlaidSweepStatus {
  Pending = 'pending',
  Posted = 'posted',
  Settled = 'settled',
  Returned = 'returned',
  Failed = 'failed',
  Unknown = 'unknown',
}

/** PlaidSweepTrackingDto */
export interface PlaidSweepTrackingDto {
  id: string;
  direction: CreditDebitDirection;
  plaidSweepId: string;
  /** @format double */
  amount: number;
  /** @format double */
  facilitatorFee: number;
  /** @format double */
  companyProcessingFee?: number;
  /** @format date */
  expectedSettlementDate?: string;
  sweepStatus: PlaidSweepStatus;
  failureReason?: string;
  returnCode?: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** PlaidSweepTrackingDtoPaginationDto */
export interface PlaidSweepTrackingDtoPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: PlaidSweepTrackingDto[];
}

/** PlaidTransferLimitsDto */
export interface PlaidTransferLimitsDto {
  isoCurrencyCode: string;
  /** @format double */
  maxDailyCreditAmount?: number;
  /** @format double */
  maxDailyDebitAmount?: number;
  /** @format double */
  maxMonthlyCreditAmount?: number;
  /** @format double */
  maxMonthlyDebitAmount?: number;
  /** @format double */
  maxSingleTransferCreditAmount?: number;
  /** @format double */
  maxSingleTransferDebitAmount?: number;
}

/** Platform */
export enum Platform {
  Android = 'android',
  IOS = 'iOS',
  Web = 'web',
}

/** PortalInviteResponseDto */
export interface PortalInviteResponseDto {
  /** @minLength 1 */
  newPassword: string;
}

/** PortalSettingsDto */
export interface PortalSettingsDto {
  iconFileId?: string;
  logoFileId?: string;
  coverFileId?: string;
  metadata: WebsiteMetadata;
  contact: ContactPhoneEmailDto;
  socialLinks: {
    twitter?: string;
    facebook?: string;
    instagram?: string;
    linkedIn?: string;
    youTube?: string;
    tikTok?: string;
  };
  translationLanguages: string[];
  iconUrl?: string;
  iconThumbUrl?: string;
  logoUrl?: string;
  logoThumbUrl?: string;
  coverUrl?: string;
}

/** PortalStatus */
export enum PortalStatus {
  NotInvited = 'notInvited',
  Invited = 'invited',
  Active = 'active',
}

/** PortfolioDto */
export interface PortfolioDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  active: boolean;
  /**
   * @minLength 1
   * @maxLength 150
   */
  name: string;
  /** @format int32 */
  propertyCount: number;
  icons: string[];
}

/** PortfolioGroupDto */
export interface PortfolioGroupDto {
  portfolio: PortfolioDto;
  settings: LeaseRenewalOfferAutomaticSettingDto[];
}

/** PortfolioOverviewDto */
export interface PortfolioOverviewDto {
  portfolio: PortfolioDto;
  summary: PortfolioSummary;
  /** @format date-time */
  cacheDate: string;
}

/** PortfolioSummary */
export interface PortfolioSummary {
  propertiesDistribution: {
    /** @format int32 */
    singleFamily?: number;
    /** @format int32 */
    multiFamily?: number;
    /** @format int32 */
    commercial?: number;
    /** @format int32 */
    condo?: number;
    /** @format int32 */
    townHome?: number;
    /** @format int32 */
    other?: number;
  };
  /** @format int32 */
  activeProperties: number;
  /** @format int32 */
  totalProperties: number;
  /** @format int32 */
  occupiedUnits: number;
  /** @format int32 */
  activeUnits: number;
  /** @format int32 */
  unlistedUnits: number;
  /** @format int32 */
  totalUnits: number;
  /** @format double */
  totalRent: number;
  /** @format double */
  totalDeposit: number;
  /** @format double */
  currentBalance: number;
  /** @format int32 */
  vacantUnits: number;
}

/** PrincipalType */
export enum PrincipalType {
  ControlPerson = 'controlPerson',
  BeneficialOwner = 'beneficialOwner',
}

/** ProcessStatus */
export enum ProcessStatus {
  NotStarted = 'notStarted',
  InProgress = 'inProgress',
  Completed = 'completed',
  Failed = 'failed',
  NotFound = 'notFound',
}

/** PropertyBalanceDto */
export interface PropertyBalanceDto {
  /** @format double */
  income: number;
  /** @format double */
  expenses: number;
  /** @format double */
  balance: number;
}

/** PropertyDirectoryReportDto */
export interface PropertyDirectoryReportDto {
  items: PropertyDirectoryReportItemDto[];
}

/** PropertyDirectoryReportItemDto */
export interface PropertyDirectoryReportItemDto {
  property: PropertyDto;
  managementFeeType: ManagementFeeType;
  /** @format double */
  managementFeeRate: number;
  /** @format double */
  minimumManagementFee: number;
  /** @format double */
  maximumManagementFee: number;
  /** @format double */
  reserve: number;
  owners: OwnerDto[];
}

/** PropertyDto */
export interface PropertyDto {
  id: string;
  name?: string;
  displayName: string;
  address?: AddressDto;
  portfolioId: string;
  type: PropertyType;
  /** @format int32 */
  totalFloors?: number;
  /** @format int32 */
  unitCount: number;
  /** @format int32 */
  recentRentalApplications: number;
  active: boolean;
  imageId?: string;
  icons: string[];
  magicTags?: Record<string, string>;
}

/** PropertyGroupDto */
export interface PropertyGroupDto {
  property: PropertyDto;
  settings: LeaseRenewalOfferAutomaticSettingDto[];
}

/** PropertyManagerDto */
export interface PropertyManagerDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  /**
   * @format email
   * @minLength 1
   */
  email: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  firstName: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  lastName?: string;
  active: boolean;
  /** @format date-time */
  created: string;
  /** @format date-time */
  lastSeen?: string;
  name: string;
  imageId?: string;
  image?: PropertyManagerImageDto;
}

/** PropertyManagerImageDto */
export interface PropertyManagerImageDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  fileId: string;
  /** @minLength 1 */
  signedUrl: string;
  signedThumbUrl?: string;
}

/** PropertyManagerNotificationSettingDto */
export interface PropertyManagerNotificationSettingDto {
  key: string;
  name: string;
  description: string;
  enabled: boolean;
  defaultOn: boolean;
}

/** PropertyManagerNotificationSettingsDto */
export interface PropertyManagerNotificationSettingsDto {
  sendNotifyOnPaymentFailure: boolean;
  sendNotifyOnPaymentReturned: boolean;
}

/** PropertyManagerNotificationSettingsDtoSettingsWithOverrideDto */
export interface PropertyManagerNotificationSettingsDtoSettingsWithOverrideDto {
  settings?: PropertyManagerNotificationSettingsDto;
  level: SettingsLevel;
  levelId: string;
}

/** PropertyManagerNotificationSettingsDtoSettingsWithOverridesDto */
export interface PropertyManagerNotificationSettingsDtoSettingsWithOverridesDto {
  settings?: PropertyManagerNotificationSettingsDto;
  overrides: PropertyManagerNotificationSettingsDtoSettingsWithOverrideDto[];
}

/** PropertyOverviewDto */
export interface PropertyOverviewDto {
  property: PropertyDto;
  summary: PropertySummary;
  revenue: PropertyRevenueDto;
  owners: PropertyOwnerDto[];
  maintenanceRequests: MaintenanceRequestListDto[];
  upcomingRenewalLeases: LeaseDto[];
  outstandingBalanceLeases: LeaseDto[];
  tenants: TenantDto[];
  units: UnitDto[];
  expiringLeaseCounts: ExpiringLeaseCounts;
  /** @format date-time */
  cacheDate: string;
}

/** PropertyOwnerDto */
export interface PropertyOwnerDto {
  id: string;
  active: boolean;
  email?: string;
  firstName: string;
  lastName?: string;
  isCompany: boolean;
  phone?: string;
  federalTaxInformation?: FederalTaxInformationDto;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format date-time */
  lastSeen?: string;
  /** @format date-time */
  lastPortalInvite?: string;
  chatId?: string;
  language: string;
  icons: string[];
  address?: AddressDto;
  portalStatus: PortalStatus;
  /** @format double */
  ownershipPercentage: number;
}

/** PropertyOwnerIdDto */
export interface PropertyOwnerIdDto {
  ownerId: string;
  /** @format double */
  ownershipPercentage: number;
}

/** PropertyOwnershipDto */
export interface PropertyOwnershipDto {
  /** @format double */
  ownershipPercentage: number;
}

/** PropertyRevenueDto */
export interface PropertyRevenueDto {
  group: Record<string, IncomeExpenses>;
  /** @format double */
  income: number;
  /** @format double */
  expenses: number;
  /** @format double */
  balance: number;
}

/** PropertySettingsDto */
export interface PropertySettingsDto {
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  reserve: number;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  ownerApprovalLimit?: number;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  vendorApprovalLimit?: number;
}

/** PropertySettingsDtoSettingsWithOverrideDto */
export interface PropertySettingsDtoSettingsWithOverrideDto {
  settings?: PropertySettingsDto;
  level: SettingsLevel;
  levelId: string;
}

/** PropertySettingsDtoSettingsWithOverridesDto */
export interface PropertySettingsDtoSettingsWithOverridesDto {
  settings?: PropertySettingsDto;
  overrides: PropertySettingsDtoSettingsWithOverrideDto[];
}

/** PropertySummary */
export interface PropertySummary {
  /** @format int32 */
  totalUnits: number;
  /** @format int32 */
  occupiedUnits: number;
  /** @format int32 */
  activeUnits: number;
  /** @format int32 */
  unlistedUnits: number;
  /** @format double */
  totalRent: number;
  /** @format double */
  totalDeposit: number;
  /** @format double */
  currentBalance: number;
  /** @format int32 */
  vacantUnits: number;
}

/** PropertyType */
export enum PropertyType {
  SingleFamily = 'singleFamily',
  MultiFamily = 'multiFamily',
  Commercial = 'commercial',
  Condo = 'condo',
  TownHome = 'townHome',
  Other = 'other',
}

/** ProratedAmountResultDto */
export interface ProratedAmountResultDto {
  /** @format double */
  proratedAmount: number;
}

/** PublicCountry */
export interface PublicCountry {
  code: string;
  name: string;
  regions: PublicRegion[];
}

/** PublicLanguage */
export interface PublicLanguage {
  name: string;
  code: string;
}

/** PublicRegion */
export interface PublicRegion {
  code: string;
  name: string;
}

/** QuestionChoiceDto */
export interface QuestionChoiceDto {
  choiceKeyName: string;
  choiceDisplayName: string;
}

/** ReconciliationCandidateDto */
export interface ReconciliationCandidateDto {
  transactionId: string;
  /** @format double */
  amount: number;
  /** @format date */
  transactionDate: string;
  direction: TransactionDirection;
  identity: TransactionIdentity;
  memo?: string;
  /** If the transaction is selected for the reconciliation */
  isSelected: boolean;
  /** If the transaction is not in the reconciliation entries, this will be null */
  selectedType?: ReconciliationEntryType;
}

/** ReconciliationCandidatesDto */
export interface ReconciliationCandidatesDto {
  candidates: ReconciliationCandidateDto[];
}

/** ReconciliationDto */
export interface ReconciliationDto {
  id: string;
  bankAccountId: string;
  /** @format date */
  startDate: string;
  /** @format date */
  endDate: string;
  /** @format double */
  opening: number;
  /** @format double */
  additions: number;
  /** @format double */
  subtractions: number;
  /** @format double */
  closing: number;
  status: ReconciliationStatus;
  creator: CreatorDto;
  memo?: string;
  entries: ReconciliationEntryDto[];
  /** @format double */
  actualAdditions: number;
  /** @format double */
  actualSubtractions: number;
  /** @format double */
  actualClosing: number;
  /** @format double */
  additionsDifference: number;
  /** @format double */
  subtractionsDifference: number;
  /** @format double */
  closingDifference: number;
}

/** ReconciliationEntryDto */
export interface ReconciliationEntryDto {
  id: string;
  reconciliationId: string;
  transactionId: string;
  transactionSnapshot: string;
  /** @format double */
  amount: number;
  /** @format date */
  transactionDate: string;
  direction: TransactionDirection;
  identity: TransactionIdentity;
  type: ReconciliationEntryType;
  memo?: string;
}

/** ReconciliationEntryType */
export enum ReconciliationEntryType {
  Included = 'included',
  Excluded = 'excluded',
}

/** ReconciliationItemDto */
export interface ReconciliationItemDto {
  id: string;
  bankAccountId: string;
  /** @format date */
  startDate: string;
  /** @format date */
  endDate: string;
  /** @format double */
  opening: number;
  /** @format double */
  additions: number;
  /** @format double */
  subtractions: number;
  /** @format double */
  closing: number;
  status: ReconciliationStatus;
  creator: CreatorDto;
  memo?: string;
}

/** ReconciliationPaginationDto */
export interface ReconciliationPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: ReconciliationItemDto[];
}

/** ReconciliationResolution */
export enum ReconciliationResolution {
  Completed = 'completed',
  Cancelled = 'cancelled',
}

/** ReconciliationStatus */
export enum ReconciliationStatus {
  InProgress = 'inProgress',
  Completed = 'completed',
  Cancelled = 'cancelled',
}

/** RecoverPasswordDto */
export interface RecoverPasswordDto {
  /**
   * A valid email address.
   * @minLength 1
   * @pattern ^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$
   */
  email: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  companyId?: string;
}

/** RecurringChargeChangeDto */
export interface RecurringChargeChangeDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  recurringChargeId: string;
  /**
   * @format double
   * @min 0
   */
  newAmount: number;
  newDescription?: string;
}

/** RecurringLeaseChargeDto */
export interface RecurringLeaseChargeDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount: number;
  chargeFrequency: ChargeFrequency;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  chartOfAccountId: string;
  /** @minLength 1 */
  description?: string;
  companyCharge: boolean;
  /** @format date */
  lastCharge?: string;
  /** @format date */
  nextCharge: string;
  /** @format date */
  startFrom: string;
  /** @format date */
  end?: string;
}

/** RecurringLeaseOfflinePaymentsDto */
export interface RecurringLeaseOfflinePaymentsDto {
  recurringPayments: LeaseRecurringOfflinePaymentDto[];
}

/** RecurringVendorBillDto */
export interface RecurringVendorBillDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  unitId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  vendorId: string;
  reference?: string;
  memo?: string;
  companyCharge: boolean;
  /** @format int32 */
  dueDays?: number;
  lineItems: BillLineItemBaseDto[];
  chargeFrequency: ChargeFrequency;
  /** @format date */
  startsFrom: string;
  /** @format date */
  ends?: string;
  active: boolean;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

/** RecurringVendorBillDtoPaginationDto */
export interface RecurringVendorBillDtoPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: RecurringVendorBillDto[];
}

/** RefundRentalApplicationPaymentDto */
export interface RefundRentalApplicationPaymentDto {
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount: number;
  /** @minLength 1 */
  reason?: string;
}

/** RegisterOwnerContributionDto */
export interface RegisterOwnerContributionDto {
  propertyId: string;
  bankAccountId: string;
  /** @format date */
  contributionDate: string;
  paymentMethod: TransactionPaymentMethod;
  /** @format double */
  amount: number;
  memo?: string;
  externalTransactionId?: string;
}

/** ReleaseDepositRequestDto */
export interface ReleaseDepositRequestDto {
  /**
   * Value must be a decimal greater than or equal to 0.01 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0.01
   * @max 1000000000000
   */
  amount: number;
  /**
   * The bank account to release the deposit from. If not provided, the default bank account in `DepositPaymentSettings` will be used.
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  bankAccountId?: string;
}

/** ReleaseLeaseBalanceRequestDto */
export interface ReleaseLeaseBalanceRequestDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  bankAccountId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  tenantId: string;
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount: number;
  /** @maxLength 500 */
  memo?: string;
  paymentType: PayBillType;
  /** Required if payment type is `Manual` */
  paymentMethod?: TransactionPaymentMethod;
  /**
   * Optional if payment type is `Manual`
   * @maxLength 100
   */
  externalTransactionId?: string;
  /**
   * Required if payment type is `ACH`
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  paymentAccountId?: string;
}

/** RentAmountConditionDto */
export type RentAmountConditionDto = ConditionDto & {
  /**
   * @format double
   * @min 0
   */
  amount: number;
};

/** RentPaymentFailureFeeSettingsDto */
export interface RentPaymentFailureFeeSettingsDto {
  chargeFeeForFailedTransfers: boolean;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  noSufficientFundsFeeChargeChartOfAccountId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  achReturnFeeChartOfAccountId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  achFailedProcessingFeeChartOfAccountId: string;
  /**
   * @format double
   * @min 0
   * @max 1000
   */
  noSufficientFundsFee: number;
  /**
   * @format double
   * @min 0
   * @max 1000
   */
  achFailedFee: number;
  /**
   * @format double
   * @min 0
   * @max 1000
   */
  achReturnFee: number;
  /** @minLength 1 */
  disputedFeeChartOfAccountId: string;
  /** @format double */
  disputedFee: number;
}

/** RentPaymentFailureFeeSettingsDtoSettingsWithOverrideDto */
export interface RentPaymentFailureFeeSettingsDtoSettingsWithOverrideDto {
  settings?: RentPaymentFailureFeeSettingsDto;
  level: SettingsLevel;
  levelId: string;
}

/** RentPaymentFailureFeeSettingsDtoSettingsWithOverridesDto */
export interface RentPaymentFailureFeeSettingsDtoSettingsWithOverridesDto {
  settings?: RentPaymentFailureFeeSettingsDto;
  overrides: RentPaymentFailureFeeSettingsDtoSettingsWithOverrideDto[];
}

/** RentPaymentNotificationSettingsDto */
export interface RentPaymentNotificationSettingsDto {
  sendRentReceivedNotifications: boolean;
  sendRentReceivedNotificationAsText: boolean;
  sendRentReceivedNotificationAsEmail: boolean;
}

/** RentPaymentNotificationSettingsDtoSettingsWithOverrideDto */
export interface RentPaymentNotificationSettingsDtoSettingsWithOverrideDto {
  settings?: RentPaymentNotificationSettingsDto;
  level: SettingsLevel;
  levelId: string;
}

/** RentPaymentNotificationSettingsDtoSettingsWithOverridesDto */
export interface RentPaymentNotificationSettingsDtoSettingsWithOverridesDto {
  settings?: RentPaymentNotificationSettingsDto;
  overrides: RentPaymentNotificationSettingsDtoSettingsWithOverrideDto[];
}

/** RentPaymentProcessingFeesSettingsDto */
export interface RentPaymentProcessingFeesSettingsDto {
  propertyManagerPaysProcessingFees: boolean;
  /** @minLength 1 */
  propertyManagerPaysProcessingFeesChartOfAccountId: string;
  /** @format double */
  propertyManagerProcessingFee: number;
  /** @minLength 1 */
  propertyManagerProcessingFeeChartOfAccountId: string;
}

/** RentPaymentProcessingFeesSettingsDtoSettingsWithOverrideDto */
export interface RentPaymentProcessingFeesSettingsDtoSettingsWithOverrideDto {
  settings?: RentPaymentProcessingFeesSettingsDto;
  level: SettingsLevel;
  levelId: string;
}

/** RentPaymentProcessingFeesSettingsDtoSettingsWithOverridesDto */
export interface RentPaymentProcessingFeesSettingsDtoSettingsWithOverridesDto {
  settings?: RentPaymentProcessingFeesSettingsDto;
  overrides: RentPaymentProcessingFeesSettingsDtoSettingsWithOverrideDto[];
}

/** RentPaymentSettingsDto */
export interface RentPaymentSettingsDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  bankAccountId?: string;
  allowOnlinePayments: boolean;
  allowAchPayments: boolean;
  allowCardPayments: boolean;
  /**
   * @format int32
   * @min 1
   * @max 365
   */
  postBillsDaysBeforeDue: number;
  allowPartialPayments: boolean;
  minimumPaymentType: MinimumPaymentType;
  /**
   * @format double
   * @min 0.01
   * @max 1
   */
  minimumPaymentPercent?: number;
  /**
   * @format double
   * @min 1
   */
  minimumPaymentAmount?: number;
}

/** RentPaymentSettingsDtoSettingsWithOverrideDto */
export interface RentPaymentSettingsDtoSettingsWithOverrideDto {
  settings?: RentPaymentSettingsDto;
  level: SettingsLevel;
  levelId: string;
}

/** RentPaymentSettingsDtoSettingsWithOverridesDto */
export interface RentPaymentSettingsDtoSettingsWithOverridesDto {
  settings?: RentPaymentSettingsDto;
  overrides: RentPaymentSettingsDtoSettingsWithOverrideDto[];
}

/** RentRollReportDto */
export interface RentRollReportDto {
  groups: RentRollReportGroupDto[];
  metadata: RentRollReportMetadataDto;
}

/** RentRollReportGroupDto */
export interface RentRollReportGroupDto {
  portfolio: PortfolioDto;
  property: PropertyDto;
  items: RentRollReportItemDto[];
}

/** RentRollReportItemDto */
export interface RentRollReportItemDto {
  unit: UnitDto;
  lease?: LeaseDto;
  tenants?: RentRollReportItemTenantDto[];
  status: RentStatus;
}

/** RentRollReportItemTenantDto */
export interface RentRollReportItemTenantDto {
  id: string;
  active: boolean;
  email?: string;
  firstName: string;
  lastName?: string;
  phone?: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format date-time */
  lastSeen?: string;
  /** @format date-time */
  lastPortalInvite?: string;
  portalStatus: PortalStatus;
  chatId?: string;
  language?: string;
  ssn?: string;
  driversLicense?: DriverLicenseDto;
  /** @format date */
  dateOfBirth?: string;
  gender?: Gender;
  currentAddress?: AddressDto;
  emergencyContacts?: EmergencyContactDto[];
  icons: string[];
  /** @format date */
  moveInDate: string;
  /** @format date */
  moveOutDate?: string;
}

/** RentRollReportMetadataDto */
export interface RentRollReportMetadataDto {
  /** @format int32 */
  totalUnits: number;
  /** @format double */
  occupancyRate: number;
  /** @format int32 */
  totalSqft: number;
  /** @format double */
  totalRent: number;
  /** @format double */
  totalDeposit: number;
}

/** RentStatus */
export enum RentStatus {
  Rented = 'rented',
  UnRented = 'unRented',
}

/** RentTransactionType */
export enum RentTransactionType {
  Payment = 'payment',
  Charge = 'charge',
  LeaseCredit = 'leaseCredit',
  Return = 'return',
  Transfer = 'transfer',
}

/** RentalApplicationChartOfAccountSettingsDto */
export interface RentalApplicationChartOfAccountSettingsDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  rentalApplicationChartOfAccountId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  creditReportChartOfAccountId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  disputeFeeChartOfAccountId: string;
}

/** RentalApplicationCommentDto */
export interface RentalApplicationCommentDto {
  /**
   * @minLength 0
   * @maxLength 150
   */
  comment: string;
  section: CommentSection;
}

/** RentalApplicationCountsDto */
export interface RentalApplicationCountsDto {
  /** @format int32 */
  newRentalApplications: number;
  /** @format int32 */
  allApplications: number;
  /** @format int32 */
  approvedApplications: number;
  /** @format int32 */
  deniedApplications: number;
  /** @format date-time */
  cachedAt: string;
}

/** RentalApplicationDto */
export interface RentalApplicationDto {
  id: string;
  password: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  ssn?: string;
  tenant?: TenantDto;
  /** @format date */
  dateOfBirth?: string;
  applyingWith?: string[];
  /** @format date */
  desiredMoveInDate?: string;
  maritalStatus?: MaritalStatus;
  incomeInformation?: IncomeInformationDto;
  interests?: RentalApplicationInterestDto[];
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  draft: boolean;
  applicationDecision: ApplicationDecision;
  /** @format date-time */
  submittedAt?: string;
  screeningPaid: boolean;
  paymentStatus: ApplicationPaymentStatus;
  screeningStatus: ScreeningStatus;
  companyPaymentBillId?: string;
  reportStatus?: ReportStatus;
  /** @format int32 */
  aiApplicationScore?: number;
  aiApplicationDescription?: string;
  hasBeenSubmitted: boolean;
  chatId?: string;
  new: boolean;
  driversLicense?: DriversLicenseDto;
  pets?: PetDto[];
  cars?: CarDto[];
  residentialHistory?: ResidentialHistoryDto[];
  emergencyContact?: EmergencyContactDto;
  employment?: EmploymentDto[];
  files?: RentalApplicationFileDto[];
  questions?: Record<string, string>;
  comments?: RentalApplicationCommentDto[];
  reports?: RentalApplicationReport[];
  paymentBillId?: string;
  /** @format double */
  paymentAmount?: number;
  /** @format double */
  refundAmount?: number;
  rentalApplicationTransactionDto?: RentalApplicationTransactionDto;
  lease?: LeaseDto;
}

/** RentalApplicationEmploymentDto */
export interface RentalApplicationEmploymentDto {
  /**
   * @minLength 1
   * @maxLength 150
   */
  name: string;
  /**
   * @minLength 10
   * @maxLength 13
   * @pattern ^\+{0,1}\d{0,1}\d{10}$
   */
  phone?: string;
  /**
   * @minLength 0
   * @maxLength 150
   */
  position?: string;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  salary?: number;
  /**
   * @minLength 1
   * @maxLength 150
   */
  jobTitle?: string;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  annualIncome?: number;
  /** @format date */
  startDate?: string;
  /** @format date */
  endDate?: string;
}

/** RentalApplicationFileDto */
export interface RentalApplicationFileDto {
  /** @deprecated */
  type: string;
  fileId: string;
  name: string;
  description?: string;
  fileName: string;
  fileExtension: string;
  fileUrl: string;
  thumbUrl?: string;
  contentType: string;
  /** @format int64 */
  fileSize: number;
}

/** RentalApplicationFileRequirement */
export interface RentalApplicationFileRequirement {
  label: string;
  description?: string;
  step?: RentalApplicationStep;
  required: boolean;
  multiple: boolean;
}

/** RentalApplicationFileRequirementDto */
export interface RentalApplicationFileRequirementDto {
  /**
   * @minLength 1
   * @maxLength 100
   */
  label: string;
  /**
   * @minLength 0
   * @maxLength 2000
   */
  description?: string;
  step?: RentalApplicationStep;
  required: boolean;
  multiple: boolean;
}

/** RentalApplicationInterestDto */
export interface RentalApplicationInterestDto {
  portfolio: PortfolioDto;
  property: PropertyDto;
  unit: UnitDto;
}

/** RentalApplicationListDto */
export interface RentalApplicationListDto {
  id: string;
  password: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  ssn?: string;
  tenant?: TenantDto;
  /** @format date */
  dateOfBirth?: string;
  applyingWith?: string[];
  /** @format date */
  desiredMoveInDate?: string;
  maritalStatus?: MaritalStatus;
  incomeInformation?: IncomeInformationDto;
  interests?: RentalApplicationInterestDto[];
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  draft: boolean;
  applicationDecision: ApplicationDecision;
  /** @format date-time */
  submittedAt?: string;
  screeningPaid: boolean;
  paymentStatus: ApplicationPaymentStatus;
  screeningStatus: ScreeningStatus;
  companyPaymentBillId?: string;
  reportStatus?: ReportStatus;
  /** @format int32 */
  aiApplicationScore?: number;
  aiApplicationDescription?: string;
  hasBeenSubmitted: boolean;
  chatId?: string;
  new: boolean;
}

/** RentalApplicationListDtoPaginationDto */
export interface RentalApplicationListDtoPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: RentalApplicationListDto[];
}

/** RentalApplicationOfflinePaymentDto */
export interface RentalApplicationOfflinePaymentDto {
  paymentMethod: TransactionPaymentMethod;
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount: number;
  /**
   * @minLength 0
   * @maxLength 150
   */
  externalTransactionId: string;
  /** @minLength 1 */
  memo?: string;
}

/** RentalApplicationPaymentAccountSettingsDto */
export interface RentalApplicationPaymentAccountSettingsDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  rentalApplicationBankAccountId: string;
}

/** RentalApplicationPaymentIntentDto */
export interface RentalApplicationPaymentIntentDto {
  /**
   * @minLength 1
   * @maxLength 200
   */
  intentId: string;
  /**
   * @minLength 1
   * @maxLength 200
   */
  clientSecret: string;
  /**
   * @minLength 1
   * @maxLength 200
   */
  stripeAccountId: string;
  /**
   * Value must be a decimal greater than or equal to 0.01 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0.01
   * @max 1000000000000
   */
  totalAmount: number;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  processingFees: number;
}

/** RentalApplicationPaymentSettingsDto */
export interface RentalApplicationPaymentSettingsDto {
  requirePaymentForApplication: boolean;
  /**
   * @format double
   * @min 0
   * @max 1000
   */
  applicationFee: number;
}

/** RentalApplicationPaymentStatusDto */
export interface RentalApplicationPaymentStatusDto {
  paid: boolean;
}

/** RentalApplicationQuestion */
export interface RentalApplicationQuestion {
  text: string;
  type: RentalApplicationQuestionType;
  options?: string[];
}

/** RentalApplicationQuestionDto */
export interface RentalApplicationQuestionDto {
  /**
   * @minLength 1
   * @maxLength 500
   */
  text: string;
  type: RentalApplicationQuestionType;
  options?: string[];
}

/** RentalApplicationQuestionType */
export enum RentalApplicationQuestionType {
  Input = 'input',
  Select = 'select',
  MultiSelect = 'multiSelect',
  Boolean = 'boolean',
}

/** RentalApplicationReport */
export interface RentalApplicationReport {
  /** @format int64 */
  rentalApplicationId: number;
  reportType: TransunionReportType;
  reportCulture: string;
  reportData: string;
  reportStatus?: ReportStatus;
  /** @format int64 */
  id: number;
}

/** RentalApplicationScreeningSettingsDto */
export interface RentalApplicationScreeningSettingsDto {
  requireScreeningForApplication: boolean;
}

/** RentalApplicationSettingsDto */
export interface RentalApplicationSettingsDto {
  /**
   * @format int32
   * @min 0
   * @max 100
   */
  rentalApplicationRecencyInDays: number;
  /**
   * @format int32
   * @min 0
   * @max 100
   */
  draftExpirationDays?: number;
  /**
   * @format int32
   * @min 0
   * @max 20
   */
  draftReminderDays?: number;
  questions: RentalApplicationQuestionDto[];
  fileRequirements: RentalApplicationFileRequirementDto[];
  disableSteps?: RentalApplicationStep[];
  welcomeMessage?: string;
}

/** RentalApplicationStep */
export enum RentalApplicationStep {
  Welcome = 'welcome',
  ApplicantInformation = 'applicantInformation',
  PotentialUnits = 'potentialUnits',
  RentalHistory = 'rentalHistory',
  WorkHistory = 'workHistory',
  Pets = 'pets',
  Cars = 'cars',
  Questions = 'questions',
  TermsAndConditions = 'termsAndConditions',
  Payment = 'payment',
  TransUnionScreening = 'transUnionScreening',
  TransUnionQuestions = 'transUnionQuestions',
  ApplicationSubmitted = 'applicationSubmitted',
  ManualVerification = 'manualVerification',
}

/** RentalApplicationTransactionDto */
export interface RentalApplicationTransactionDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  transactionId: string;
  transactionStatus?: TransactionStatus;
  transactionType: TransactionType;
  /** @format date */
  transactionDate: string;
  /** @format date */
  paymentDate: string;
  /** @minLength 1 */
  transactionMemo?: string;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  transactionAmount: number;
  transactionPaymentMethod: TransactionPaymentMethod;
  transactionDirection: TransactionDirection;
  externalTransactionType: ExternalTransactionType;
  /** @minLength 1 */
  externalTransactionId: string;
}

/** RentalApplicationsSettingsDto */
export interface RentalApplicationsSettingsDto {
  canAcceptRentalApplications: boolean;
  requirePayment: boolean;
  /** @format double */
  paymentAmount: number;
  requireScreening: boolean;
  questions: RentalApplicationQuestion[];
  fileRequirements: RentalApplicationFileRequirement[];
  disableSteps?: RentalApplicationStep[];
  welcomeMessage?: string;
}

/** RentalInsuranceReportDto */
export interface RentalInsuranceReportDto {
  groups: RentalInsuranceReportGroupDto[];
  metadata: RentalInsuranceReportMetadataDto;
}

/** RentalInsuranceReportGroupDto */
export interface RentalInsuranceReportGroupDto {
  portfolio: PortfolioDto;
  property: PropertyDto;
  items: RentalInsuranceReportItemDto[];
}

/** RentalInsuranceReportItemDto */
export interface RentalInsuranceReportItemDto {
  unit: UnitDto;
  lease: LeaseDto;
  activeInsurance: LeaseRentersInsuranceItemDto;
}

/** RentalInsuranceReportMetadataDto */
export interface RentalInsuranceReportMetadataDto {
  /** @format int32 */
  totalLeases: number;
  /** @format int32 */
  totalInsured: number;
  /** @format int32 */
  totalUninsured: number;
  /** @format double */
  insuranceComplianceRate: number;
}

/** ReportGroupHeader */
export interface ReportGroupHeader {
  id: string;
  name: string;
}

/** ReportGroupHeaderDto */
export interface ReportGroupHeaderDto {
  id: string;
  name: string;
}

/** ReportStatus */
export enum ReportStatus {
  NotRequested = 'notRequested',
  Requested = 'requested',
  Available = 'available',
  Failed = 'failed',
}

/** RequiredAddressDto */
export interface RequiredAddressDto {
  /**
   * @minLength 1
   * @maxLength 250
   */
  streetAddress1: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  streetAddress2?: string;
  /**
   * @minLength 2
   * @maxLength 150
   */
  city: string;
  /**
   * @minLength 2
   * @maxLength 25
   */
  state: string;
  /**
   * @minLength 2
   * @maxLength 25
   */
  zipCode: string;
  /**
   * @minLength 3
   * @maxLength 25
   */
  country?: string;
}

/** ResetPasswordDto */
export interface ResetPasswordDto {
  /**
   * @minLength 3
   * @maxLength 100
   */
  token: string;
  /**
   * @minLength 6
   * @maxLength 100
   */
  requestId: string;
  /**
   * @minLength 5
   * @maxLength 150
   */
  newPassword: string;
}

/** ResidentialHistoryDto */
export interface ResidentialHistoryDto {
  address: AddressDto;
  /**
   * @minLength 1
   * @maxLength 150
   */
  landlordName?: string;
  /**
   * @minLength 10
   * @maxLength 13
   * @pattern ^\+{0,1}\d{0,1}\d{10}$
   */
  landlordPhone?: string;
  /**
   * @minLength 1
   * @maxLength 500
   */
  reasonForLeaving?: string;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  rent: number;
  /** @format date */
  moveInDate?: string;
  /** @format date */
  moveOutDate?: string;
}

/** ResolveReconciliationDto */
export interface ResolveReconciliationDto {
  resolution: ReconciliationResolution;
  /**
   * @minLength 1
   * @maxLength 1000
   */
  memo?: string;
}

/** ReturnLeasePaymentDto */
export interface ReturnLeasePaymentDto {
  /** @maxLength 150 */
  reason?: string;
}

/** RunBookPropertyManagerOverwriteDto */
export interface RunBookPropertyManagerOverwriteDto {
  overwriteId: string;
  propertyManagerId: string;
  portfolioId?: string;
  propertyId?: string;
}

/** RunBookVendorOverwriteDto */
export interface RunBookVendorOverwriteDto {
  overwriteId: string;
  vendorId: string;
  portfolioId?: string;
  propertyId?: string;
  timeFrame?: TimeFrameDto;
}

/** RunBooksPaginationDto */
export interface RunBooksPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: ListRunBookDto[];
  vendors: VendorDto[];
  propertyManagers: PropertyManagerDto[];
}

/** ScreeningStatus */
export enum ScreeningStatus {
  NotStarted = 'notStarted',
  Verified = 'verified',
  UnVerified = 'unVerified',
  ManualVerificationRequired = 'manualVerificationRequired',
}

/** SecurityDepositConditionDto */
export type SecurityDepositConditionDto = ConditionDto & {
  /** @format double */
  amount: number;
};

/** SelectSearchLeaseResultDto */
export interface SelectSearchLeaseResultDto {
  lease: LeaseDto;
  tenants?: TenantDto[];
}

/** SelectSearchPortfolioResultDto */
export interface SelectSearchPortfolioResultDto {
  portfolio: PortfolioDto;
  properties?: SelectSearchPropertyResultDto[];
}

/** SelectSearchPropertyResultDto */
export interface SelectSearchPropertyResultDto {
  property: PropertyDto;
  units?: SelectSearchUnitResultDto[];
}

/** SelectSearchRequestDto */
export interface SelectSearchRequestDto {
  /**
   * @minLength 1
   * @maxLength 150
   */
  search: string;
  levelSearch: LevelSearch;
  includeTenants: boolean;
  includeEndedLeases: boolean;
  includeDeactivated: boolean;
  includeFutureLease: boolean;
  excludeUnlistedUnit: boolean;
}

/** SelectSearchResultDto */
export interface SelectSearchResultDto {
  portfolios: SelectSearchPortfolioResultDto[];
}

/** SelectSearchUnitResultDto */
export interface SelectSearchUnitResultDto {
  unit: UnitDto;
  leases?: SelectSearchLeaseResultDto[];
}

/** SendAnnouncementRequestDto */
export interface SendAnnouncementRequestDto {
  targetType: TargetType;
  /** Applicable only for Lease targets */
  includeEnded?: boolean;
  /** Applicable only for Tenant targets */
  hasActiveLease?: boolean;
  /** Applicable only for Tenant targets */
  hasLeaseWithoutPaymentMethod?: boolean;
  /** Applicable only for Tenant targets */
  hasNoPortalActivity?: boolean;
  /** Applicable only for Tenant or Lease targets */
  hasBalanceDue?: boolean;
  /**
   * Applicable only for Tenant or Lease or Owner targets
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  portfolioIds?: string[];
  /**
   * Applicable only for Tenant or Lease or Owner targets
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyIds?: string[];
  /**
   * Applicable only for Tenant or Lease targets
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  unitIds?: string[];
  chatMessage?: string;
  emailMessage?: string;
  chatAttachmentFiles?: string[];
  emailAttachmentFiles?: string[];
  /** @maxLength 250 */
  subject?: string;
}

/** SendMagicLinkDto */
export interface SendMagicLinkDto {
  /**
   * A valid email address.
   * @minLength 1
   * @pattern ^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$
   */
  email: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  companyId?: string;
  /**
   * @minLength 1
   * @maxLength 500
   */
  redirect?: string;
}

/** SendOtpDto */
export interface SendOtpDto {
  /**
   * @format tel
   * @minLength 1
   */
  phone: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  companyId?: string;
}

/** SendResultDto */
export interface SendResultDto {
  companies?: CompanyOptionDto[];
  requestId?: string;
}

/** ServiceBillResultDto */
export interface ServiceBillResultDto {
  propertyBill: HydratedBillDto;
  companyBill: HydratedBillDto;
}

/** ServiceBillResultListDto */
export interface ServiceBillResultListDto {
  propertyBill: BillDto;
  companyBill: BillDto;
}

/** SetCustomFieldValueDto */
export interface SetCustomFieldValueDto {
  stringValue?: string;
  stringArray?: string[];
  /** @format double */
  numberValue?: number;
  booleanValue?: boolean;
  /** @format date-time */
  dateTimeValue?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  referenceValue?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  referenceArray?: string[];
}

/** SetLeaseMoveOutRequestDto */
export interface SetLeaseMoveOutRequestDto {
  /** @format date */
  moveOutDate: string;
}

/** SetMessagesReadDto */
export interface SetMessagesReadDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   * @minItems 1
   */
  messageIds: string[];
}

/** SetPrimaryCompanyBusinessInfoDto */
export interface SetPrimaryCompanyBusinessInfoDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  businessInfoId: string;
}

/** SetPropertyManagerNotificationSettingDto */
export interface SetPropertyManagerNotificationSettingDto {
  enabled: boolean;
}

/** SettingsLevel */
export enum SettingsLevel {
  Default = 'default',
  Company = 'company',
  Portfolio = 'portfolio',
  Property = 'property',
  Unit = 'unit',
  Lease = 'lease',
}

/** StandardizedImportData */
export interface StandardizedImportData {
  tenants: StandardizedImportDataTenant[];
  properties: StandardizedImportDataProperty[];
}

/** StandardizedImportDataAddress */
export interface StandardizedImportDataAddress {
  street1: string;
  street2?: string;
  city: string;
  state: string;
  zipcode: string;
  country: string;
}

/** StandardizedImportDataCharge */
export interface StandardizedImportDataCharge {
  name: string;
  'chart-of-account': string;
  /** @format double */
  amount: number;
}

/** StandardizedImportDataGender */
export enum StandardizedImportDataGender {
  Male = 'male',
  Female = 'female',
  Other = 'other',
  PreferNotToSay = 'preferNotToSay',
}

/** StandardizedImportDataLease */
export interface StandardizedImportDataLease {
  /** @format date */
  start: string;
  /** @format date */
  end?: string;
  month2month: boolean;
  tenants: string[];
  charges: StandardizedImportDataCharge[];
  /** @format double */
  deposit: number;
}

/** StandardizedImportDataProperty */
export interface StandardizedImportDataProperty {
  id: string;
  name: string;
  type: StandardizedImportDataPropertyType;
  address?: StandardizedImportDataAddress;
  units: StandardizedImportDataUnit[];
}

/** StandardizedImportDataPropertyType */
export enum StandardizedImportDataPropertyType {
  SingleFamily = 'singleFamily',
  MultiFamily = 'multiFamily',
  Commercial = 'commercial',
  Condo = 'condo',
  TownHome = 'townHome',
  Other = 'other',
}

/** StandardizedImportDataTenant */
export interface StandardizedImportDataTenant {
  id: string;
  'first-name': string;
  'last-name'?: string;
  email?: string;
  /** @format date */
  'date-of-birth'?: string;
  ssn?: string;
  phone?: string;
  gender?: StandardizedImportDataGender;
  'current-address'?: StandardizedImportDataAddress;
}

/** StandardizedImportDataUnit */
export interface StandardizedImportDataUnit {
  id: string;
  'property-id': string;
  name: string;
  /** @format int32 */
  beds?: number;
  /** @format int32 */
  baths?: number;
  /** @format int32 */
  sqft?: number;
  leases: StandardizedImportDataLease[];
}

/** StartOutgoingAchFailure */
export enum StartOutgoingAchFailure {
  CompanyAccountSetupError = 'companyAccountSetupError',
  PaymentAccountNotMapped = 'paymentAccountNotMapped',
  PaymentAccountNotActive = 'paymentAccountNotActive',
  TransferLimitReached = 'transferLimitReached',
  StartPaymentFailed = 'startPaymentFailed',
  Unknown = 'unknown',
}

/** StartReconciliationDto */
export interface StartReconciliationDto {
  /** @format date */
  asOf: string;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  additions: number;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  subtractions: number;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  opening?: number;
}

/** StatusType */
export enum StatusType {
  Draft = 'draft',
  Sent = 'sent',
  Viewed = 'viewed',
  Signed = 'signed',
}

/** StripeCheckoutDto */
export interface StripeCheckoutDto {
  sessionId: string;
  clientSecret: string;
}

/** StripeConnectedStatusDto */
export interface StripeConnectedStatusDto {
  status: BankAccountConnectionStatus;
  balance: BankAccountConnectionBalance;
  deniedReason?: string;
  externalAccountId?: string;
}

/** StripePaymentAccountDto */
export interface StripePaymentAccountDto {
  cardType?: CardType;
  brand?: string;
  country: string;
  /** @format int32 */
  expMonth?: number;
  /** @format int32 */
  expYear?: number;
  last4?: string;
}

/** SuggestedLeaseEndDateDto */
export interface SuggestedLeaseEndDateDto {
  /** @format date */
  suggestedEndDate: string;
}

/** SyndicationDto */
export interface SyndicationDto {
  id: string;
  name: string;
  website: string;
  active: boolean;
  type: SyndicationType;
  config?: Record<string, any>;
  /** @format date-time */
  lastSyndicated?: string;
}

/** SyndicationProviderDto */
export interface SyndicationProviderDto {
  type: SyndicationType;
  active: boolean;
  extendedProperties?: Record<string, JsonNode>;
}

/** SyndicationSettingsDto */
export interface SyndicationSettingsDto {
  /** @minLength 1 */
  contactName: string;
  /**
   * @format email
   * @minLength 1
   */
  contactEmail: string;
  /**
   * @minLength 10
   * @maxLength 13
   * @pattern ^\+{0,1}\d{0,1}\d{10}$
   */
  contactPhone: string;
  providers?: SyndicationProviderDto[];
}

/** SyndicationSettingsDtoSettingsWithOverrideDto */
export interface SyndicationSettingsDtoSettingsWithOverrideDto {
  settings?: SyndicationSettingsDto;
  level: SettingsLevel;
  levelId: string;
}

/** SyndicationSettingsDtoSettingsWithOverridesDto */
export interface SyndicationSettingsDtoSettingsWithOverridesDto {
  settings?: SyndicationSettingsDto;
  overrides: SyndicationSettingsDtoSettingsWithOverrideDto[];
}

/** SyndicationStatus */
export enum SyndicationStatus {
  NotPostedAndBlocked = 'notPostedAndBlocked',
  NotPostedAndInvalidData = 'notPostedAndInvalidData',
  Posted = 'posted',
  Unknown = 'unknown',
}

/** SyndicationType */
export enum SyndicationType {
  Zillow = 'zillow',
}

/** TargetType */
export enum TargetType {
  Lease = 'lease',
  Tenant = 'tenant',
  Owner = 'owner',
  Vendor = 'vendor',
}

/** TaxDocumentAccountType */
export enum TaxDocumentAccountType {
  Vendor = 'vendor',
  Owner = 'owner',
}

/** TaxDocumentAnnotation */
export interface TaxDocumentAnnotation {
  id: string;
  /** @format int32 */
  page: number;
  /** @format double */
  x: number;
  /** @format double */
  y: number;
  /** @format double */
  width: number;
  /** @format double */
  height: number;
  /** @format double */
  fontSize: number;
  value: TaxDocumentAnnotationValue;
  text: string;
  type: string;
  dataPath?: string;
}

/** TaxDocumentAnnotationType */
export enum TaxDocumentAnnotationType {
  Text = 'text',
  Currency = 'currency',
}

/** TaxDocumentAnnotationValue */
export interface TaxDocumentAnnotationValue {
  text?: string;
  /** @format double */
  currencyValue?: number;
  type?: TaxDocumentAnnotationType;
  hasValue: boolean;
}

/** TaxDocumentCalendarYearDto */
export interface TaxDocumentCalendarYearDto {
  calendarYears: number[];
}

/** TaxDocumentDto */
export interface TaxDocumentDto {
  id: string;
  /** @format int32 */
  calendarYear: number;
  entityName?: string;
  entityId?: string;
  /** @format double */
  amount: number;
  taxDocumentType: TaxType;
  documentName?: string;
  documentUrl?: string;
  status: ProcessStatus;
  taskErrorMessage?: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  annotations?: TaxDocumentAnnotation[];
}

/** TaxDocumentListDto */
export interface TaxDocumentListDto {
  id: string;
  /** @format int32 */
  calendarYear: number;
  entityName?: string;
  entityId?: string;
  /** @format double */
  amount: number;
  taxDocumentType: TaxType;
  documentName?: string;
  documentUrl?: string;
  status: ProcessStatus;
  taskErrorMessage?: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt?: string;
  annotations?: TaxDocumentAnnotation[];
}

/** TaxDocumentYearDto */
export interface TaxDocumentYearDto {
  /** @format int32 */
  calendarYear: number;
  /** @format int32 */
  taxDocumentsCount: number;
}

/** TaxType */
export enum TaxType {
  Misc = 'misc',
  Nec = 'nec',
}

/** TenantAutoPayDto */
export interface TenantAutoPayDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  tenantPaymentAccountId: string;
  type: TenantAutoPayType;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  fixedAmount?: number;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  maximumAmount?: number;
  frequency: ChargeFrequency;
  /** @format date */
  start: string;
  /** @format date */
  end?: string;
  /** @format date */
  lastPayment?: string;
  /** @format date */
  nextPayment?: string;
}

/** TenantAutoPayFailedNotificationSettingsDto */
export interface TenantAutoPayFailedNotificationSettingsDto {
  sendNotifyOnTenantAutoPayFailed: boolean;
  sendNotifyOnTenantAutoPayFailedViaText: boolean;
  sendNotifyOnTenantAutoPayFailedViaEmail: boolean;
}

/** TenantAutoPayFailedNotificationSettingsDtoSettingsWithOverrideDto */
export interface TenantAutoPayFailedNotificationSettingsDtoSettingsWithOverrideDto {
  settings?: TenantAutoPayFailedNotificationSettingsDto;
  level: SettingsLevel;
  levelId: string;
}

/** TenantAutoPayFailedNotificationSettingsDtoSettingsWithOverridesDto */
export interface TenantAutoPayFailedNotificationSettingsDtoSettingsWithOverridesDto {
  settings?: TenantAutoPayFailedNotificationSettingsDto;
  overrides: TenantAutoPayFailedNotificationSettingsDtoSettingsWithOverrideDto[];
}

/** TenantAutoPayType */
export enum TenantAutoPayType {
  FixedAmount = 'fixedAmount',
  PostedBalance = 'postedBalance',
  CurrentBalance = 'currentBalance',
}

/** TenantBalanceDueNotificationSettingsDto */
export interface TenantBalanceDueNotificationSettingsDto {
  notifyOnBalanceDue: boolean;
  sendBalanceDueNotificationsToEvictionLeases: boolean;
  sendBalanceDueNotificationsToEndedLeases: boolean;
  sendBalanceDueNotificationsAsText: boolean;
  sendBalanceDueNotificationsAsEmail: boolean;
  /**
   * @format int32
   * @min 0
   * @max 100
   */
  notifyBalanceDueEveryXDays: number;
  sendNotificationsOfBalanceDueRightAway: boolean;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  balanceDueNotificationMessage: string;
}

/** TenantBalanceDueNotificationSettingsDtoSettingsWithOverrideDto */
export interface TenantBalanceDueNotificationSettingsDtoSettingsWithOverrideDto {
  settings?: TenantBalanceDueNotificationSettingsDto;
  level: SettingsLevel;
  levelId: string;
}

/** TenantBalanceDueNotificationSettingsDtoSettingsWithOverridesDto */
export interface TenantBalanceDueNotificationSettingsDtoSettingsWithOverridesDto {
  settings?: TenantBalanceDueNotificationSettingsDto;
  overrides: TenantBalanceDueNotificationSettingsDtoSettingsWithOverrideDto[];
}

/** TenantCountConditionDto */
export type TenantCountConditionDto = ConditionDto & {
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  count: number;
};

/** TenantCountsDto */
export interface TenantCountsDto {
  /** @format int32 */
  totalTenants: number;
  /** @format int32 */
  activeTenants: number;
  /** @format int32 */
  newTenantsToday: number;
  /** @format int32 */
  unInvitedTenants: number;
}

/** TenantCreatedDto */
export interface TenantCreatedDto {
  id: string;
  active: boolean;
  email?: string;
  firstName: string;
  lastName?: string;
  phone?: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format date-time */
  lastSeen?: string;
  /** @format date-time */
  lastPortalInvite?: string;
  portalStatus: PortalStatus;
  chatId?: string;
  language?: string;
  ssn?: string;
  driversLicense?: DriverLicenseDto;
  /** @format date */
  dateOfBirth?: string;
  gender?: Gender;
  currentAddress?: AddressDto;
  emergencyContacts?: EmergencyContactDto[];
  icons: string[];
  password: string;
}

/** TenantDirectoryReportDto */
export interface TenantDirectoryReportDto {
  items: TenantDirectoryReportItemDto[];
}

/** TenantDirectoryReportItemDto */
export interface TenantDirectoryReportItemDto {
  tenant: TenantDto;
  leases: TenantDirectoryReportItemLeaseDto[];
}

/** TenantDirectoryReportItemLeaseDto */
export interface TenantDirectoryReportItemLeaseDto {
  lease: LeaseTenantDto;
  unit: UnitDto;
  property: PropertyDto;
}

/** TenantDto */
export interface TenantDto {
  id: string;
  active: boolean;
  email?: string;
  firstName: string;
  lastName?: string;
  phone?: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format date-time */
  lastSeen?: string;
  /** @format date-time */
  lastPortalInvite?: string;
  portalStatus: PortalStatus;
  chatId?: string;
  language?: string;
  ssn?: string;
  driversLicense?: DriverLicenseDto;
  /** @format date */
  dateOfBirth?: string;
  gender?: Gender;
  currentAddress?: AddressDto;
  emergencyContacts?: EmergencyContactDto[];
  icons: string[];
}

/** TenantNotificationTargetDto */
export type TenantNotificationTargetDto = NotificationTargetDto & {
  tenantIds?: string[];
  hasBalanceDue?: boolean;
  hasLeaseWithoutPaymentMethod?: boolean;
  hasActiveLease?: boolean;
  noPortalActivity?: boolean;
};

/** TenantPortalInviteTextNotificationSettingsDto */
export interface TenantPortalInviteTextNotificationSettingsDto {
  /** @minLength 1 */
  portalInviteMessage: string;
}

/** TextSettingsDto */
export interface TextSettingsDto {
  enableTexts: boolean;
  includeAiTag: boolean;
}

/** TextSettingsDtoSettingsWithOverrideDto */
export interface TextSettingsDtoSettingsWithOverrideDto {
  settings?: TextSettingsDto;
  level: SettingsLevel;
  levelId: string;
}

/** TextSettingsDtoSettingsWithOverridesDto */
export interface TextSettingsDtoSettingsWithOverridesDto {
  settings?: TextSettingsDto;
  overrides: TextSettingsDtoSettingsWithOverrideDto[];
}

/** TextStatus */
export enum TextStatus {
  NotSent = 'notSent',
  Disabled = 'disabled',
  NoRecipients = 'noRecipients',
  Sent = 'sent',
  Delivered = 'delivered',
  Failed = 'failed',
}

/** TimeFrameDto */
export interface TimeFrameDto {
  /** @format date-span */
  startTime: string;
  /** @format date-span */
  endTime: string;
  days?: DayOfWeek[];
}

/** TimePeriod */
export enum TimePeriod {
  Days = 'days',
  Months = 'months',
  Years = 'years',
}

/** TimeRange */
export interface TimeRange {
  /** @format date-span */
  start?: string;
  /** @format date-span */
  end?: string;
}

/** TransactionDirection */
export enum TransactionDirection {
  In = 'in',
  Out = 'out',
}

/** TransactionDto */
export interface TransactionDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  /** @format date */
  transactionDate: string;
  transactionIdentity: TransactionIdentity;
  transactionPaymentMethod: TransactionPaymentMethod;
  status: TransactionStatus;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  amount: number;
  memo?: string;
  direction: TransactionDirection;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  bankAccountId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  tenantId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  vendorId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  unitId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  portfolioId?: string;
  /** @format date-time */
  created: string;
  /** @format date */
  transactionFinalizedDate?: string;
  externalTransactionType?: ExternalTransactionType;
  /** @minLength 1 */
  externalTransactionId?: string;
  failureReason?: TransactionFailure;
  paymentProcessorErrorMessage?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  refundTransactionId?: string;
  reference?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  depositSlipId?: string;
  creator: CreatorDto;
}

/** TransactionFailure */
export enum TransactionFailure {
  NoSufficientFunds = 'noSufficientFunds',
  Unknown = 'unknown',
  TransferLimitReached = 'transferLimitReached',
  PaymentProcessorDeclined = 'paymentProcessorDeclined',
  CardLost = 'cardLost',
  StolenCard = 'stolenCard',
  ExpiredCard = 'expiredCard',
  PaymentAccountSetupError = 'paymentAccountSetupError',
  CompanyAccountSetupError = 'companyAccountSetupError',
}

/** TransactionIdentity */
export enum TransactionIdentity {
  Lease = 'lease',
  Vendor = 'vendor',
  Company = 'company',
  ProcessingFees = 'processingFees',
  RentalApplication = 'rentalApplication',
  ManagementFee = 'managementFee',
  OwnerTransfer = 'ownerTransfer',
  LeaseDeposit = 'leaseDeposit',
  ServiceBill = 'serviceBill',
  CompanyPayOut = 'companyPayOut',
  CompanyPropertyCredit = 'companyPropertyCredit',
  CompanyInvoice = 'companyInvoice',
}

/** TransactionPaymentMethod */
export enum TransactionPaymentMethod {
  Ach = 'ach',
  Credit = 'credit',
  DebitCard = 'debitCard',
  Wallet = 'wallet',
  CreditCard = 'creditCard',
  Check = 'check',
  CashiersCheck = 'cashiersCheck',
  MoneyOrder = 'moneyOrder',
  Cash = 'cash',
  Other = 'other',
  Transfer = 'transfer',
}

/** TransactionStatus */
export enum TransactionStatus {
  Pending = 'pending',
  Failed = 'failed',
  Success = 'success',
  Cancelled = 'cancelled',
  Returned = 'returned',
  Refunded = 'refunded',
  Disputing = 'disputing',
  Disputed = 'disputed',
}

/** TransactionType */
export enum TransactionType {
  Payment = 'payment',
  Return = 'return',
  Refund = 'refund',
  Dispute = 'dispute',
}

/** TransactionsDto */
export interface TransactionsDto {
  transactions: TransactionDto[];
  bankAccounts: BankAccountDto[];
  tenants: TenantDto[];
  vendors: VendorDto[];
  leases: LeaseDto[];
  properties: PropertyDto[];
  units: UnitDto[];
}

/** TransferOwnerFundsDto */
export interface TransferOwnerFundsDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  fromPropertyId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  toPropertyId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  ownerId: string;
  /**
   * Value must be a decimal greater than or equal to 0.01 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0.01
   * @max 1000000000000
   */
  amount: number;
  /**
   * @minLength 0
   * @maxLength 150
   */
  memo?: string;
}

/** TranslationDto */
export interface TranslationDto {
  /**
   * @minLength 2
   * @maxLength 10
   */
  language: string;
  /** @minLength 1 */
  value: string;
}

/** TransunionAnswersChoiceDto */
export interface TransunionAnswersChoiceDto {
  /**
   * @minLength 1
   * @maxLength 150
   */
  questionKeyName: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  selectedChoiceKeyName: string;
}

/** TransunionAnswersDto */
export interface TransunionAnswersDto {
  /** @format int32 */
  examId: number;
  answers: TransunionAnswersChoiceDto[];
}

/** TransunionAnswersResultDto */
export interface TransunionAnswersResultDto {
  screeningStatus: ScreeningStatus;
  /** @minLength 1 */
  resultStatus?: string;
}

/** TransunionExamQuestionsDto */
export interface TransunionExamQuestionsDto {
  status: ScreeningStatus;
  /** @format int32 */
  examId?: number;
  /** @format int32 */
  transunionScreeningId?: number;
  /** @format int32 */
  transunionScreeningRequestRenterId?: number;
  questions?: ExamQuestionDto[];
}

/** TransunionReportType */
export enum TransunionReportType {
  Criminal = 'criminal',
  Credit = 'credit',
  Eviction = 'eviction',
}

/** TruliaSyndicationStatusDto */
export interface TruliaSyndicationStatusDto {
  status: SyndicationStatus;
  url: string;
}

/** UnitDto */
export interface UnitDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  name: string;
  address?: AddressDto;
  /**
   * Value must be a double greater than or equal to 0 and evenly divisible by 0.5.
   * @format double
   * @min 0
   */
  beds?: number;
  /**
   * Value must be a double greater than or equal to 0 and evenly divisible by 0.5.
   * @format double
   * @min 0
   */
  baths?: number;
  /**
   * Value must be either null or greater than or equal to 0.
   * @format int32
   * @min 0
   */
  unitSizeSqft?: number;
  /**
   * @format int32
   * @min 1
   * @max 200
   */
  floor?: number;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  portfolioId: string;
  active: boolean;
  imageId?: string;
  icons: string[];
  magicTags?: Record<string, string>;
}

/** UnitListingApplicationInviteDto */
export interface UnitListingApplicationInviteDto {
  /** @minLength 1 */
  name: string;
  /**
   * A valid email address.
   * @pattern ^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$
   */
  email?: string;
  /**
   * Phone number of the applicant, required if email is not provided
   * @minLength 10
   * @maxLength 13
   * @pattern ^\+{0,1}\d{0,1}\d{10}$
   */
  phone?: string;
}

/** UnitListingDto */
export interface UnitListingDto {
  id: string;
  portfolioId: string;
  propertyId: string;
  unitId: string;
  status: UnitListingStatus;
  /** @format double */
  marketRent?: number;
  /** @format double */
  rentalPrice?: number;
  /** @format double */
  securityDeposit?: number;
  /** @format date */
  availableFrom?: string;
  leaseTerm?: LeaseTerm;
  title?: string;
  /** @format date */
  listed?: string;
  /** @format date-time */
  updated: string;
  pinned: boolean;
  primaryImage?: EmbedFileDto;
  primaryVideo?: EmbedFileDto;
  propertyType?: PropertyType;
  singleLineAddress?: string;
  /** @format int32 */
  recentRentalApplications?: number;
}

/** UnitListingStatus */
export enum UnitListingStatus {
  Pending = 'pending',
  Available = 'available',
  Reserved = 'reserved',
  Leased = 'leased',
  Occupied = 'occupied',
  UnderMaintenance = 'underMaintenance',
  Sold = 'sold',
  Other = 'other',
}

/** UnitListingSyndicationStatusDto */
export interface UnitListingSyndicationStatusDto {
  zillowStatus?: ZillowSyndicationStatusDto;
  hotpadsStatus?: HotpadsSyndicationStatusDto;
  truliaStatus?: TruliaSyndicationStatusDto;
}

/** UnitMasterListingDto */
export interface UnitMasterListingDto {
  /** @minLength 1 */
  title: string;
  keywords: string[];
  /** @minLength 1 */
  description: string;
}

/** UnitMasterListingRequestDto */
export interface UnitMasterListingRequestDto {
  /**
   * @minLength 1
   * @maxLength 500
   */
  prompt?: string;
}

/** UnreadMessagePaginationDto */
export interface UnreadMessagePaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: ChatMessageDto[];
  chats: HydratedMagicChatDto[];
}

/** UpdateAssociationViolationRequestDto */
export interface UpdateAssociationViolationRequestDto {
  /** @format date */
  violationReceivedDate: string;
  /** @format date */
  violationDate: string;
  /** @format date */
  fixByDate?: string;
  /** @format double */
  associationFine: number;
  title: string;
  description: string;
}

/** UpdateAssociationViolationStatusRequestDto */
export interface UpdateAssociationViolationStatusRequestDto {
  status: AssociationViolationStatus;
}

/** UpdateBankAccountDto */
export interface UpdateBankAccountDto {
  /**
   * @minLength 1
   * @maxLength 150
   */
  name: string;
  /**
   * @minLength 1
   * @maxLength 500
   */
  description?: string;
  /**
   * A valid 4 to 17 digit account number.
   * @pattern ^[0-9]{4,17}$
   */
  accountNumber?: string;
  /**
   * A valid 9-digit bank routing number.
   * @pattern ^[0-9]{9}$
   */
  routingNumber?: string;
  type?: BankAccountType;
  scheduleSweepDays?: number[];
}

/** UpdateBillAllocations */
export enum UpdateBillAllocations {
  LeavePaymentAsIs = 'leavePaymentAsIs',
  UpdatePaymentToMatchBill = 'updatePaymentToMatchBill',
  FailIfAllocationsExist = 'failIfAllocationsExist',
}

/** UpdateBillDto */
export interface UpdateBillDto {
  /** @maxLength 900 */
  reference?: string;
  /** @maxLength 900 */
  memo?: string;
  /** @format date */
  billDate: string;
  /** @format date */
  dueDate: string;
  /** @minItems 1 */
  lineItems: UpdateBillLineItemDto[];
}

/** UpdateBillFileDto */
export interface UpdateBillFileDto {
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string;
}

/** UpdateBillLineItemDto */
export interface UpdateBillLineItemDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  chartOfAccountId: string;
  description?: string;
  /**
   * Value must be a decimal greater than or equal to 0.01 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0.01
   * @max 1000000000000
   */
  amount: number;
}

/** UpdateChartOfAccountDto */
export interface UpdateChartOfAccountDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  parentId?: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  name: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  offsetChartOfAccountId?: string;
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  number?: number;
}

/** UpdateChatDto */
export interface UpdateChatDto {
  /** @minLength 1 */
  subject: string;
  /**
   * @minLength 2
   * @maxLength 2
   */
  participantLanguage?:
    | 'aa'
    | 'ab'
    | 'ae'
    | 'af'
    | 'ak'
    | 'am'
    | 'an'
    | 'ar'
    | 'as'
    | 'av'
    | 'ay'
    | 'az'
    | 'ba'
    | 'be'
    | 'bg'
    | 'bh'
    | 'bi'
    | 'bm'
    | 'bn'
    | 'bo'
    | 'br'
    | 'bs'
    | 'ca'
    | 'ce'
    | 'ch'
    | 'co'
    | 'cr'
    | 'cs'
    | 'cu'
    | 'cv'
    | 'cy'
    | 'da'
    | 'de'
    | 'dv'
    | 'dz'
    | 'ee'
    | 'el'
    | 'en'
    | 'eo'
    | 'es'
    | 'et'
    | 'eu'
    | 'fa'
    | 'ff'
    | 'fi'
    | 'fj'
    | 'fo'
    | 'fr'
    | 'fy'
    | 'ga'
    | 'gd'
    | 'gl'
    | 'gn'
    | 'gu'
    | 'gv'
    | 'ha'
    | 'he'
    | 'hi'
    | 'ho'
    | 'hr'
    | 'ht'
    | 'hu'
    | 'hy'
    | 'hz'
    | 'ia'
    | 'id'
    | 'ie'
    | 'ig'
    | 'ii'
    | 'ik'
    | 'io'
    | 'is'
    | 'it'
    | 'iu'
    | 'ja'
    | 'jv'
    | 'ka'
    | 'kg'
    | 'ki'
    | 'kj'
    | 'kk'
    | 'kl'
    | 'km'
    | 'kn'
    | 'ko'
    | 'kr'
    | 'ks'
    | 'ku'
    | 'kv'
    | 'kw'
    | 'ky'
    | 'la'
    | 'lb'
    | 'lg'
    | 'li'
    | 'ln'
    | 'lo'
    | 'lt'
    | 'lu'
    | 'lv'
    | 'mg'
    | 'mh'
    | 'mi'
    | 'mk'
    | 'ml'
    | 'mn'
    | 'mr'
    | 'ms'
    | 'mt'
    | 'my'
    | 'na'
    | 'nb'
    | 'nd'
    | 'ne'
    | 'ng'
    | 'nl'
    | 'nn'
    | 'no'
    | 'nr'
    | 'nv'
    | 'ny'
    | 'oc'
    | 'oj'
    | 'om'
    | 'or'
    | 'os'
    | 'pa'
    | 'pi'
    | 'pl'
    | 'ps'
    | 'pt'
    | 'qu'
    | 'rm'
    | 'rn'
    | 'ro'
    | 'ru'
    | 'rw'
    | 'sa'
    | 'sc'
    | 'sd'
    | 'se'
    | 'sg'
    | 'si'
    | 'sk'
    | 'sl'
    | 'sm'
    | 'sn'
    | 'so'
    | 'sq'
    | 'sr'
    | 'ss'
    | 'st'
    | 'su'
    | 'sv'
    | 'sw'
    | 'ta'
    | 'te'
    | 'tg'
    | 'th'
    | 'ti'
    | 'tk'
    | 'tl'
    | 'tn'
    | 'to'
    | 'tr'
    | 'ts'
    | 'tt'
    | 'tw'
    | 'ty'
    | 'ug'
    | 'uk'
    | 'ur'
    | 'uz'
    | 've'
    | 'vi'
    | 'vo'
    | 'wa'
    | 'wo'
    | 'xh'
    | 'yi'
    | 'yo'
    | 'za'
    | 'zh'
    | 'zu';
}

/** UpdateCompanyBusinessInfoDto */
export interface UpdateCompanyBusinessInfoDto {
  /**
   * @minLength 0
   * @maxLength 150
   */
  legalName: string;
  /**
   * A valid SSN or EIN.
   * @minLength 9
   * @maxLength 11
   * @pattern ^(\d{3}-?\d{2}-?\d{4}|\d{9}|\d{2}-?\d{7})$
   */
  ein: string;
  legalEntityType: LegalEntityType;
  businessAddress: RequiredAddressDto;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  businessNameFileId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  businessAddressFileId: string;
  /** @minLength 1 */
  irsFileId: string;
  /** @minItems 1 */
  principals: UpdateCompanyPrincipalDto[];
}

/** UpdateCompanyDto */
export interface UpdateCompanyDto {
  /**
   * @minLength 2
   * @maxLength 150
   */
  name: string;
  /**
   * A valid email address.
   * @minLength 2
   * @maxLength 150
   * @pattern ^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$
   */
  email: string;
  /**
   * @minLength 2
   * @maxLength 2
   */
  language:
    | 'aa'
    | 'ab'
    | 'ae'
    | 'af'
    | 'ak'
    | 'am'
    | 'an'
    | 'ar'
    | 'as'
    | 'av'
    | 'ay'
    | 'az'
    | 'ba'
    | 'be'
    | 'bg'
    | 'bh'
    | 'bi'
    | 'bm'
    | 'bn'
    | 'bo'
    | 'br'
    | 'bs'
    | 'ca'
    | 'ce'
    | 'ch'
    | 'co'
    | 'cr'
    | 'cs'
    | 'cu'
    | 'cv'
    | 'cy'
    | 'da'
    | 'de'
    | 'dv'
    | 'dz'
    | 'ee'
    | 'el'
    | 'en'
    | 'eo'
    | 'es'
    | 'et'
    | 'eu'
    | 'fa'
    | 'ff'
    | 'fi'
    | 'fj'
    | 'fo'
    | 'fr'
    | 'fy'
    | 'ga'
    | 'gd'
    | 'gl'
    | 'gn'
    | 'gu'
    | 'gv'
    | 'ha'
    | 'he'
    | 'hi'
    | 'ho'
    | 'hr'
    | 'ht'
    | 'hu'
    | 'hy'
    | 'hz'
    | 'ia'
    | 'id'
    | 'ie'
    | 'ig'
    | 'ii'
    | 'ik'
    | 'io'
    | 'is'
    | 'it'
    | 'iu'
    | 'ja'
    | 'jv'
    | 'ka'
    | 'kg'
    | 'ki'
    | 'kj'
    | 'kk'
    | 'kl'
    | 'km'
    | 'kn'
    | 'ko'
    | 'kr'
    | 'ks'
    | 'ku'
    | 'kv'
    | 'kw'
    | 'ky'
    | 'la'
    | 'lb'
    | 'lg'
    | 'li'
    | 'ln'
    | 'lo'
    | 'lt'
    | 'lu'
    | 'lv'
    | 'mg'
    | 'mh'
    | 'mi'
    | 'mk'
    | 'ml'
    | 'mn'
    | 'mr'
    | 'ms'
    | 'mt'
    | 'my'
    | 'na'
    | 'nb'
    | 'nd'
    | 'ne'
    | 'ng'
    | 'nl'
    | 'nn'
    | 'no'
    | 'nr'
    | 'nv'
    | 'ny'
    | 'oc'
    | 'oj'
    | 'om'
    | 'or'
    | 'os'
    | 'pa'
    | 'pi'
    | 'pl'
    | 'ps'
    | 'pt'
    | 'qu'
    | 'rm'
    | 'rn'
    | 'ro'
    | 'ru'
    | 'rw'
    | 'sa'
    | 'sc'
    | 'sd'
    | 'se'
    | 'sg'
    | 'si'
    | 'sk'
    | 'sl'
    | 'sm'
    | 'sn'
    | 'so'
    | 'sq'
    | 'sr'
    | 'ss'
    | 'st'
    | 'su'
    | 'sv'
    | 'sw'
    | 'ta'
    | 'te'
    | 'tg'
    | 'th'
    | 'ti'
    | 'tk'
    | 'tl'
    | 'tn'
    | 'to'
    | 'tr'
    | 'ts'
    | 'tt'
    | 'tw'
    | 'ty'
    | 'ug'
    | 'uk'
    | 'ur'
    | 'uz'
    | 've'
    | 'vi'
    | 'vo'
    | 'wa'
    | 'wo'
    | 'xh'
    | 'yi'
    | 'yo'
    | 'za'
    | 'zh'
    | 'zu';
  address: RequiredAddressDto;
}

/** UpdateCompanyOnboardingStatusDto */
export interface UpdateCompanyOnboardingStatusDto {
  /**
   * @minLength 0
   * @maxLength 150
   */
  status: string;
}

/** UpdateCompanyPrincipalDto */
export interface UpdateCompanyPrincipalDto {
  /** @minLength 1 */
  firstName: string;
  /** @minLength 1 */
  lastName: string;
  /**
   * A valid email address.
   * @minLength 1
   * @pattern ^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$
   */
  email: string;
  /**
   * @minLength 10
   * @maxLength 13
   * @pattern ^\+{0,1}\d{0,1}\d{10}$
   */
  phone: string;
  address: RequiredAddressDto;
  /**
   * A valid SSN or EIN.
   * @minLength 9
   * @maxLength 11
   * @pattern ^(\d{3}-?\d{2}-?\d{4}|\d{9}|\d{2}-?\d{7})$
   */
  ssn: string;
  /** @format date */
  dateOfBirth: string;
  type: PrincipalType;
  /**
   * Required if type is `BeneficialOwner`, otherwise optional. Value must be between 25 and 100.
   * @format int32
   */
  ownership?: number;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  ssnCardFileId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  driversLicenseFileId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  personalAddressFileId: string;
}

/** UpdateCustomFieldDto */
export interface UpdateCustomFieldDto {
  /**
   * @minLength 1
   * @maxLength 100
   */
  name?: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string;
  public?: boolean;
  filterable?: boolean;
  listable?: boolean;
  /** @format int32 */
  order?: number;
  options?:
    | CustomStringFieldOptionsDto
    | CustomNumberFieldOptionsDto
    | CustomBooleanFieldOptionsDto
    | CustomDateTimeFieldOptionsDto
    | CustomReferenceFieldOptionsDto;
  active?: boolean;
}

/** UpdateFileAttachmentDto */
export interface UpdateFileAttachmentDto {
  /**
   * @minLength 1
   * @maxLength 250
   */
  fileName: string;
  /**
   * @minLength 1
   * @maxLength 1000
   */
  description?: string;
}

/** UpdateLeaseDocumentDto */
export interface UpdateLeaseDocumentDto {
  /** @minLength 1 */
  name: string;
  signers: UpdateLeaseDocumentSignerDto[];
  annotations: LeaseDocumentAnnotationDto[];
}

/** UpdateLeaseDocumentSignerDto */
export interface UpdateLeaseDocumentSignerDto {
  /** @minLength 1 */
  id: string;
  /**
   * @minLength 1
   * @maxLength 100
   */
  name: string;
  /**
   * @minLength 1
   * @maxLength 100
   */
  signatureName: string;
  /**
   * @minLength 1
   * @maxLength 10
   */
  signatureInitials: string;
  type: LeaseDocumentSignerType;
}

/** UpdateLeaseDto */
export interface UpdateLeaseDto {
  /** @format date */
  start: string;
  /** @format date */
  end?: string;
  eviction: boolean;
  monthToMonth: boolean;
  icons: string[];
}

/** UpdateLeaseEvictionStatusDto */
export interface UpdateLeaseEvictionStatusDto {
  eviction: boolean;
}

/** UpdateLeaseRecurringOfflinePaymentDto */
export interface UpdateLeaseRecurringOfflinePaymentDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  tenantId: string;
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount: number;
  chargeFrequency: ChargeFrequency;
  /** @format date */
  startFrom: string;
  /** @format date */
  end?: string;
  /** @minLength 1 */
  description?: string;
  paymentMethod?: OfflineTransactionPaymentMethod;
  /**
   * @minLength 0
   * @maxLength 150
   */
  reference?: string;
  updatePastPayments: boolean;
}

/** UpdateLeaseRentersInsuranceDto */
export interface UpdateLeaseRentersInsuranceDto {
  /**
   * @minLength 1
   * @maxLength 200
   */
  carrierName: string;
  /**
   * @minLength 1
   * @maxLength 200
   */
  policyNumber?: string;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  coverageAmount?: number;
  /** @format date */
  policyStartDate?: string;
  /** @format date */
  policyEndDate?: string;
  /** @format date */
  policyCanceledDate?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  insurancePolicyFileId?: string;
  /**
   * @minLength 1
   * @maxLength 100
   */
  externalIdentifier?: string;
}

/** UpdateLeaseTemplateDto */
export interface UpdateLeaseTemplateDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseTemplateCategoryId: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  name: string;
  description?: string;
  signers: LeaseTemplateSignerDto[];
  annotations: LeaseDocumentAnnotationDto[];
  type?: LeaseTemplateType;
}

/** UpdateMaintenanceRequestDto */
export interface UpdateMaintenanceRequestDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  requesterId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  assignedPropertyManagerId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseId: string;
  files?: UpdateMaintenanceRequestFileDto[];
  /**
   * @minLength 1
   * @maxLength 150
   */
  title: string;
  /** @minLength 1 */
  description: string;
  /** @minLength 1 */
  internalDescription?: string;
  status: MaintenanceRequestStatus;
  urgency: Urgency;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  categoryId?: string;
  permissionToEnter: boolean;
  /** @format date */
  due?: string;
}

/** UpdateMaintenanceRequestFileDto */
export interface UpdateMaintenanceRequestFileDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  fileId: string;
  description?: string;
}

/** UpdateMaintenanceRequestSelectedCategoryDto */
export interface UpdateMaintenanceRequestSelectedCategoryDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  categoryId?: string;
}

/** UpdateMaintenanceRequestStatusDto */
export interface UpdateMaintenanceRequestStatusDto {
  status: MaintenanceRequestStatus;
}

/** UpdateMaintenanceRequestUrgencyDto */
export interface UpdateMaintenanceRequestUrgencyDto {
  urgency: Urgency;
}

/** UpdateMeetingScheduleDto */
export interface UpdateMeetingScheduleDto {
  /**
   * @minLength 0
   * @maxLength 200
   */
  title: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  description?: string;
  /**
   * @minLength 0
   * @maxLength 200
   */
  link?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  externalProvider?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  externalIdentifier?: string;
  /** @format date-time */
  startTime: string;
  /** @format date-time */
  startTimeUtc?: string;
  /** @format date-time */
  endTime: string;
  /** @format date-time */
  endTimeUtc?: string;
  /** @format date-time */
  cancelled?: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  cancellationReason?: string;
}

/** UpdateNotificationScheduleDto */
export interface UpdateNotificationScheduleDto {
  target: TenantNotificationTargetDto;
  template: NotificationTemplateDto;
  /** @format date-time */
  time: string;
}

/** UpdateOwnerDto */
export interface UpdateOwnerDto {
  /**
   * @minLength 1
   * @maxLength 150
   */
  firstName: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  lastName?: string;
  isCompany: boolean;
  /**
   * A valid email address.
   * @minLength 0
   * @maxLength 250
   * @pattern ^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$
   */
  email?: string;
  /**
   * @minLength 10
   * @maxLength 13
   * @pattern ^\+{0,1}\d{0,1}\d{10}$
   */
  phone?: string;
  federalTaxInformation?: FederalTaxInformationDto;
  /**
   * @minLength 2
   * @maxLength 2
   */
  language?:
    | 'aa'
    | 'ab'
    | 'ae'
    | 'af'
    | 'ak'
    | 'am'
    | 'an'
    | 'ar'
    | 'as'
    | 'av'
    | 'ay'
    | 'az'
    | 'ba'
    | 'be'
    | 'bg'
    | 'bh'
    | 'bi'
    | 'bm'
    | 'bn'
    | 'bo'
    | 'br'
    | 'bs'
    | 'ca'
    | 'ce'
    | 'ch'
    | 'co'
    | 'cr'
    | 'cs'
    | 'cu'
    | 'cv'
    | 'cy'
    | 'da'
    | 'de'
    | 'dv'
    | 'dz'
    | 'ee'
    | 'el'
    | 'en'
    | 'eo'
    | 'es'
    | 'et'
    | 'eu'
    | 'fa'
    | 'ff'
    | 'fi'
    | 'fj'
    | 'fo'
    | 'fr'
    | 'fy'
    | 'ga'
    | 'gd'
    | 'gl'
    | 'gn'
    | 'gu'
    | 'gv'
    | 'ha'
    | 'he'
    | 'hi'
    | 'ho'
    | 'hr'
    | 'ht'
    | 'hu'
    | 'hy'
    | 'hz'
    | 'ia'
    | 'id'
    | 'ie'
    | 'ig'
    | 'ii'
    | 'ik'
    | 'io'
    | 'is'
    | 'it'
    | 'iu'
    | 'ja'
    | 'jv'
    | 'ka'
    | 'kg'
    | 'ki'
    | 'kj'
    | 'kk'
    | 'kl'
    | 'km'
    | 'kn'
    | 'ko'
    | 'kr'
    | 'ks'
    | 'ku'
    | 'kv'
    | 'kw'
    | 'ky'
    | 'la'
    | 'lb'
    | 'lg'
    | 'li'
    | 'ln'
    | 'lo'
    | 'lt'
    | 'lu'
    | 'lv'
    | 'mg'
    | 'mh'
    | 'mi'
    | 'mk'
    | 'ml'
    | 'mn'
    | 'mr'
    | 'ms'
    | 'mt'
    | 'my'
    | 'na'
    | 'nb'
    | 'nd'
    | 'ne'
    | 'ng'
    | 'nl'
    | 'nn'
    | 'no'
    | 'nr'
    | 'nv'
    | 'ny'
    | 'oc'
    | 'oj'
    | 'om'
    | 'or'
    | 'os'
    | 'pa'
    | 'pi'
    | 'pl'
    | 'ps'
    | 'pt'
    | 'qu'
    | 'rm'
    | 'rn'
    | 'ro'
    | 'ru'
    | 'rw'
    | 'sa'
    | 'sc'
    | 'sd'
    | 'se'
    | 'sg'
    | 'si'
    | 'sk'
    | 'sl'
    | 'sm'
    | 'sn'
    | 'so'
    | 'sq'
    | 'sr'
    | 'ss'
    | 'st'
    | 'su'
    | 'sv'
    | 'sw'
    | 'ta'
    | 'te'
    | 'tg'
    | 'th'
    | 'ti'
    | 'tk'
    | 'tl'
    | 'tn'
    | 'to'
    | 'tr'
    | 'ts'
    | 'tt'
    | 'tw'
    | 'ty'
    | 'ug'
    | 'uk'
    | 'ur'
    | 'uz'
    | 've'
    | 'vi'
    | 'vo'
    | 'wa'
    | 'wo'
    | 'xh'
    | 'yi'
    | 'yo'
    | 'za'
    | 'zh'
    | 'zu';
  address?: AddressDto;
}

/** UpdateOwnerPasswordDto */
export interface UpdateOwnerPasswordDto {
  /**
   * @minLength 1
   * @maxLength 150
   */
  password: string;
}

/** UpdatePortalSettingsDto */
export interface UpdatePortalSettingsDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  iconFileId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  logoFileId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  coverFileId?: string;
  metadata?: WebsiteMetadata;
  contact?: ContactPhoneEmailDto;
  socialLinks?: {
    twitter?: string;
    facebook?: string;
    instagram?: string;
    linkedIn?: string;
    youTube?: string;
    tikTok?: string;
  };
  /**
   * @minLength 2
   * @maxLength 2
   */
  translationLanguages?:
    | 'aa'
    | 'ab'
    | 'ae'
    | 'af'
    | 'ak'
    | 'am'
    | 'an'
    | 'ar'
    | 'as'
    | 'av'
    | 'ay'
    | 'az'
    | 'ba'
    | 'be'
    | 'bg'
    | 'bh'
    | 'bi'
    | 'bm'
    | 'bn'
    | 'bo'
    | 'br'
    | 'bs'
    | 'ca'
    | 'ce'
    | 'ch'
    | 'co'
    | 'cr'
    | 'cs'
    | 'cu'
    | 'cv'
    | 'cy'
    | 'da'
    | 'de'
    | 'dv'
    | 'dz'
    | 'ee'
    | 'el'
    | 'en'
    | 'eo'
    | 'es'
    | 'et'
    | 'eu'
    | 'fa'
    | 'ff'
    | 'fi'
    | 'fj'
    | 'fo'
    | 'fr'
    | 'fy'
    | 'ga'
    | 'gd'
    | 'gl'
    | 'gn'
    | 'gu'
    | 'gv'
    | 'ha'
    | 'he'
    | 'hi'
    | 'ho'
    | 'hr'
    | 'ht'
    | 'hu'
    | 'hy'
    | 'hz'
    | 'ia'
    | 'id'
    | 'ie'
    | 'ig'
    | 'ii'
    | 'ik'
    | 'io'
    | 'is'
    | 'it'
    | 'iu'
    | 'ja'
    | 'jv'
    | 'ka'
    | 'kg'
    | 'ki'
    | 'kj'
    | 'kk'
    | 'kl'
    | 'km'
    | 'kn'
    | 'ko'
    | 'kr'
    | 'ks'
    | 'ku'
    | 'kv'
    | 'kw'
    | 'ky'
    | 'la'
    | 'lb'
    | 'lg'
    | 'li'
    | 'ln'
    | 'lo'
    | 'lt'
    | 'lu'
    | 'lv'
    | 'mg'
    | 'mh'
    | 'mi'
    | 'mk'
    | 'ml'
    | 'mn'
    | 'mr'
    | 'ms'
    | 'mt'
    | 'my'
    | 'na'
    | 'nb'
    | 'nd'
    | 'ne'
    | 'ng'
    | 'nl'
    | 'nn'
    | 'no'
    | 'nr'
    | 'nv'
    | 'ny'
    | 'oc'
    | 'oj'
    | 'om'
    | 'or'
    | 'os'
    | 'pa'
    | 'pi'
    | 'pl'
    | 'ps'
    | 'pt'
    | 'qu'
    | 'rm'
    | 'rn'
    | 'ro'
    | 'ru'
    | 'rw'
    | 'sa'
    | 'sc'
    | 'sd'
    | 'se'
    | 'sg'
    | 'si'
    | 'sk'
    | 'sl'
    | 'sm'
    | 'sn'
    | 'so'
    | 'sq'
    | 'sr'
    | 'ss'
    | 'st'
    | 'su'
    | 'sv'
    | 'sw'
    | 'ta'
    | 'te'
    | 'tg'
    | 'th'
    | 'ti'
    | 'tk'
    | 'tl'
    | 'tn'
    | 'to'
    | 'tr'
    | 'ts'
    | 'tt'
    | 'tw'
    | 'ty'
    | 'ug'
    | 'uk'
    | 'ur'
    | 'uz'
    | 've'
    | 'vi'
    | 'vo'
    | 'wa'
    | 'wo'
    | 'xh'
    | 'yi'
    | 'yo'
    | 'za'
    | 'zh'
    | 'zu';
}

/** UpdatePropertyDto */
export interface UpdatePropertyDto {
  /**
   * @minLength 1
   * @maxLength 150
   */
  name?: string;
  address: RequiredAddressDto;
  type: PropertyType;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  imageId?: string;
  icons?: string[];
  magicTags?: Record<string, string>;
  /**
   * @format int32
   * @min 1
   * @max 200
   */
  totalFloors?: number;
}

/** UpdatePropertyMagicTagDto */
export interface UpdatePropertyMagicTagDto {
  magicTags: Record<string, string>;
}

/** UpdatePropertyManagerActiveDto */
export interface UpdatePropertyManagerActiveDto {
  active: boolean;
}

/** UpdatePropertyManagerDto */
export interface UpdatePropertyManagerDto {
  /**
   * @minLength 1
   * @maxLength 150
   */
  firstName: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  lastName?: string;
  /**
   * A valid email address.
   * @minLength 1
   * @pattern ^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$
   */
  email: string;
}

/** UpdatePropertyManagerMeDto */
export interface UpdatePropertyManagerMeDto {
  /**
   * @minLength 1
   * @maxLength 150
   */
  firstName: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  lastName?: string;
  /**
   * A valid email address.
   * @minLength 0
   * @maxLength 250
   * @pattern ^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$
   */
  email: string;
}

/** UpdatePropertyManagerMePasswordDto */
export interface UpdatePropertyManagerMePasswordDto {
  /**
   * @minLength 5
   * @maxLength 150
   */
  clearTextPassword: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  currentPassword: string;
}

/** UpdatePropertyManagerPasswordDto */
export interface UpdatePropertyManagerPasswordDto {
  /**
   * @minLength 5
   * @maxLength 150
   */
  clearTextPassword: string;
}

/** UpdateReconciliationDto */
export interface UpdateReconciliationDto {
  /** @format date */
  asOf?: string;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  additions?: number;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  subtractions?: number;
  memo?: string;
}

/** UpdateRecurringLeaseChargeDto */
export interface UpdateRecurringLeaseChargeDto {
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount: number;
  chargeFrequency: ChargeFrequency;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  chartOfAccountId: string;
  /** @minLength 1 */
  description?: string;
  companyCharge?: boolean;
  /** @format date */
  startFrom: string;
  /** @format date */
  end?: string;
  updatePastCharges: boolean;
}

/** UpdateRecurringVendorBillDto */
export interface UpdateRecurringVendorBillDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  unitId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  vendorId: string;
  reference?: string;
  memo?: string;
  companyCharge: boolean;
  /** @format int32 */
  dueDays?: number;
  lineItems: BillLineItemBaseDto[];
  chargeFrequency: ChargeFrequency;
  /** @format date */
  ends?: string;
}

/** UpdateRentalApplicationDecisionDto */
export interface UpdateRentalApplicationDecisionDto {
  decision: ApplicationDecision;
}

/** UpdateRentalApplicationFileDto */
export interface UpdateRentalApplicationFileDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  fileId: string;
  /**
   * @minLength 1
   * @maxLength 100
   */
  name: string;
  /**
   * @minLength 0
   * @maxLength 200
   */
  description?: string;
  /** @deprecated */
  type?: FileType;
}

/** UpdateRunBookDefaultPropertyManagerDto */
export interface UpdateRunBookDefaultPropertyManagerDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  defaultPropertyManagerId: string;
}

/** UpdateRunBookDefaultVendorDto */
export interface UpdateRunBookDefaultVendorDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  defaultVendorId: string;
}

/** UpdateRunBookDto */
export interface UpdateRunBookDto {
  /** @maxLength 150 */
  title?: string;
  /** @maxLength 250 */
  description?: string;
  /** @minLength 50 */
  script: string;
}

/** UpdateServiceBillDto */
export interface UpdateServiceBillDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  unitId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseId?: string;
  /**
   * Value must be a decimal greater than or equal to 1 and less than or equal to 1000000000000.
   * @format decimal
   * @min 1
   * @max 1000000000000
   */
  amount: number;
  /**
   * @minLength 0
   * @maxLength 150
   */
  propertyBillMemo?: string;
  /**
   * @minLength 0
   * @maxLength 150
   */
  companyBillMemo?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyChartOfAccountId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  companyChartOfAccountId: string;
}

/** UpdateSyndicationDto */
export interface UpdateSyndicationDto {
  active: boolean;
  config?: Record<string, any>;
}

/** UpdateTenantDto */
export interface UpdateTenantDto {
  /**
   * @minLength 1
   * @maxLength 150
   */
  firstName: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  lastName?: string;
  /**
   * A valid email address.
   * @minLength 0
   * @maxLength 250
   * @pattern ^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$
   */
  email?: string;
  /**
   * @minLength 10
   * @maxLength 13
   * @pattern ^\+{0,1}\d{0,1}\d{10}$
   */
  phone?: string;
  /**
   * @minLength 5
   * @maxLength 150
   */
  password?: string;
  /**
   * @minLength 2
   * @maxLength 2
   */
  language?:
    | 'aa'
    | 'ab'
    | 'ae'
    | 'af'
    | 'ak'
    | 'am'
    | 'an'
    | 'ar'
    | 'as'
    | 'av'
    | 'ay'
    | 'az'
    | 'ba'
    | 'be'
    | 'bg'
    | 'bh'
    | 'bi'
    | 'bm'
    | 'bn'
    | 'bo'
    | 'br'
    | 'bs'
    | 'ca'
    | 'ce'
    | 'ch'
    | 'co'
    | 'cr'
    | 'cs'
    | 'cu'
    | 'cv'
    | 'cy'
    | 'da'
    | 'de'
    | 'dv'
    | 'dz'
    | 'ee'
    | 'el'
    | 'en'
    | 'eo'
    | 'es'
    | 'et'
    | 'eu'
    | 'fa'
    | 'ff'
    | 'fi'
    | 'fj'
    | 'fo'
    | 'fr'
    | 'fy'
    | 'ga'
    | 'gd'
    | 'gl'
    | 'gn'
    | 'gu'
    | 'gv'
    | 'ha'
    | 'he'
    | 'hi'
    | 'ho'
    | 'hr'
    | 'ht'
    | 'hu'
    | 'hy'
    | 'hz'
    | 'ia'
    | 'id'
    | 'ie'
    | 'ig'
    | 'ii'
    | 'ik'
    | 'io'
    | 'is'
    | 'it'
    | 'iu'
    | 'ja'
    | 'jv'
    | 'ka'
    | 'kg'
    | 'ki'
    | 'kj'
    | 'kk'
    | 'kl'
    | 'km'
    | 'kn'
    | 'ko'
    | 'kr'
    | 'ks'
    | 'ku'
    | 'kv'
    | 'kw'
    | 'ky'
    | 'la'
    | 'lb'
    | 'lg'
    | 'li'
    | 'ln'
    | 'lo'
    | 'lt'
    | 'lu'
    | 'lv'
    | 'mg'
    | 'mh'
    | 'mi'
    | 'mk'
    | 'ml'
    | 'mn'
    | 'mr'
    | 'ms'
    | 'mt'
    | 'my'
    | 'na'
    | 'nb'
    | 'nd'
    | 'ne'
    | 'ng'
    | 'nl'
    | 'nn'
    | 'no'
    | 'nr'
    | 'nv'
    | 'ny'
    | 'oc'
    | 'oj'
    | 'om'
    | 'or'
    | 'os'
    | 'pa'
    | 'pi'
    | 'pl'
    | 'ps'
    | 'pt'
    | 'qu'
    | 'rm'
    | 'rn'
    | 'ro'
    | 'ru'
    | 'rw'
    | 'sa'
    | 'sc'
    | 'sd'
    | 'se'
    | 'sg'
    | 'si'
    | 'sk'
    | 'sl'
    | 'sm'
    | 'sn'
    | 'so'
    | 'sq'
    | 'sr'
    | 'ss'
    | 'st'
    | 'su'
    | 'sv'
    | 'sw'
    | 'ta'
    | 'te'
    | 'tg'
    | 'th'
    | 'ti'
    | 'tk'
    | 'tl'
    | 'tn'
    | 'to'
    | 'tr'
    | 'ts'
    | 'tt'
    | 'tw'
    | 'ty'
    | 'ug'
    | 'uk'
    | 'ur'
    | 'uz'
    | 've'
    | 'vi'
    | 'vo'
    | 'wa'
    | 'wo'
    | 'xh'
    | 'yi'
    | 'yo'
    | 'za'
    | 'zh'
    | 'zu';
  /**
   * A valid SSN or EIN.
   * @minLength 9
   * @maxLength 11
   * @pattern ^(\d{3}-?\d{2}-?\d{4}|\d{9}|\d{2}-?\d{7})$
   */
  ssn?: string;
  driversLicense?: DriverLicenseDto;
  /** @format date */
  dateOfBirth?: string;
  gender?: Gender;
  currentAddress?: AddressDto;
  emergencyContacts?: EmergencyContactDto[];
  icons?: string[];
}

/** UpdateTenantPasswordDto */
export interface UpdateTenantPasswordDto {
  /**
   * @minLength 1
   * @maxLength 150
   */
  password: string;
}

/** UpdateTransactionDto */
export interface UpdateTransactionDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  bankAccountId: string;
  /**
   * Value must be a decimal greater than or equal to 0.01 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0.01
   * @max 1000000000000
   */
  amount: number;
  /** @maxLength 900 */
  memo?: string;
  /** @format date-time */
  transactionDate: string;
  /** @format date-time */
  transactionFinalizedDate?: string;
  externalTransactionType?: ExternalTransactionType;
  /** @maxLength 900 */
  externalTransactionId?: string;
  paymentMethod: TransactionPaymentMethod;
  status: TransactionStatus;
  failureReason?: TransactionFailure;
}

/** UpdateUnitDto */
export interface UpdateUnitDto {
  /**
   * @minLength 1
   * @maxLength 200
   */
  name: string;
  address?: RequiredAddressDto;
  /**
   * Value must be a double greater than or equal to 0 and evenly divisible by 0.5.
   * @format double
   * @min 0
   */
  beds?: number;
  /**
   * Value must be a double greater than or equal to 0 and evenly divisible by 0.5.
   * @format double
   * @min 0
   */
  baths?: number;
  /**
   * Value must be either null or greater than or equal to 0.
   * @format int32
   * @min 0
   */
  unitSizeSqft?: number;
  /**
   * @format int32
   * @min 1
   * @max 200
   */
  floor?: number;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  imageId?: string;
  icons?: string[];
  magicTags?: Record<string, string>;
}

/** UpdateUnitListingDto */
export interface UpdateUnitListingDto {
  status?: UnitListingStatus;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  marketRent?: number;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  rentalPrice?: number;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  securityDeposit?: number;
  /** @format date */
  availableFrom?: string;
  leaseTerm?: LeaseTerm;
  /**
   * @minLength 1
   * @maxLength 150
   */
  title?: string;
  /**
   * @minLength 1
   * @maxLength 2500
   */
  description?: string;
  /** @maxItems 50 */
  images?: EmbedFileDto[];
  /** @maxItems 5 */
  videos?: EmbedFileDto[];
  /** @maxItems 50 */
  tags?: string[];
  petPolicy?: PetPolicyDto;
  /** @maxItems 30 */
  amenities?: AmenityDto[];
  /** @maxLength 10 */
  terms?: Record<string, string>;
  listed?: boolean;
  pinned?: boolean;
}

/** UpdateUnitMagicTagDto */
export interface UpdateUnitMagicTagDto {
  magicTags: Record<string, string>;
}

/** UpdateVendorBillDto */
export interface UpdateVendorBillDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  vendorId: string;
  reference?: string;
  memo?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  unitId?: string;
  /** @format date */
  billDate: string;
  /** @format date */
  dueDate: string;
  /** @minItems 1 */
  lineItems: BillLineItemDto[];
  /** @default false */
  companyBill: boolean;
  allocationHandling: UpdateBillAllocations;
}

/** UpdateVendorPasswordDto */
export interface UpdateVendorPasswordDto {
  /**
   * @minLength 1
   * @maxLength 150
   */
  password: string;
}

/** UpdateWorkOrderDto */
export interface UpdateWorkOrderDto {
  status: WorkOrderStatus;
  urgency: Urgency;
  /** @format date */
  dueDate?: string;
  permissionToEnter: boolean;
  /**
   * @minLength 0
   * @maxLength 150
   */
  title: string;
  /** @minLength 1 */
  description: string;
  internalDescription?: string;
  assignedPropertyManagerId?: string;
}

/** UpdateWorkOrderFileDto */
export interface UpdateWorkOrderFileDto {
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string;
}

/** UpdateWorkOrderLeaseDto */
export interface UpdateWorkOrderLeaseDto {
  propertyId?: string;
  unitId?: string;
  leaseId?: string;
}

/** UpdateWorkOrderMaintenanceRequestDto */
export interface UpdateWorkOrderMaintenanceRequestDto {
  newMaintenanceRequestId?: string;
}

/** UpdateWorkOrderStatusDto */
export interface UpdateWorkOrderStatusDto {
  status: WorkOrderStatus;
}

/** UpdateWorkOrderUrgencyDto */
export interface UpdateWorkOrderUrgencyDto {
  urgency: Urgency;
}

/** UpdateWorkOrderVendorDto */
export interface UpdateWorkOrderVendorDto {
  newVendorId?: string;
}

/** UploadResultDto */
export interface UploadResultDto {
  fileId: string;
  signedUrl: string;
  thumbSignedUrl?: string;
}

/** Urgency */
export enum Urgency {
  Urgent = 'urgent',
  High = 'high',
  Medium = 'medium',
  Low = 'low',
  None = 'none',
}

/** ValidPropertyDto */
export interface ValidPropertyDto {
  property: PropertyDto;
  owners: PropertyOwnerIdDto[];
}

/** ValidateDto */
export interface ValidateDto {
  isValid: boolean;
}

/** VendorBillAchResultsDto */
export interface VendorBillAchResultsDto {
  successful: VendorBillResultDto[];
  scheduled: VendorBillResultDto[];
  failed: FailedVendorBillResultDto[];
}

/** VendorBillPaymentDto */
export interface VendorBillPaymentDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  billId: string;
  /**
   * Value must be a decimal greater than or equal to 0.01 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0.01
   * @max 1000000000000
   */
  amount: number;
}

/** VendorBillPaymentResultDto */
export interface VendorBillPaymentResultDto {
  bill: BillDto;
  /** @format double */
  amount: number;
}

/** VendorBillPrintCheckResultDto */
export interface VendorBillPrintCheckResultDto {
  vendor: VendorDto;
  bankAccount: BankAccountDto;
  transaction: TransactionDto;
  payments: VendorBillPaymentResultDto[];
  check: HydratedCheckDto;
}

/** VendorBillResultDto */
export interface VendorBillResultDto {
  vendor: VendorDto;
  bankAccount: BankAccountDto;
  transaction: TransactionDto;
  payments: VendorBillPaymentResultDto[];
}

/** VendorBillsToPayDto */
export interface VendorBillsToPayDto {
  properties: BillPayProperty[];
  vendors: HydratedVendorDto[];
}

/** VendorCategoryDto */
export interface VendorCategoryDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  name: string;
}

/** VendorCommunicationsDto */
export interface VendorCommunicationsDto {
  /** @format int32 */
  messagesCount: number;
  /** @format int32 */
  unreadMessagesCount: number;
}

/** VendorCreatedDto */
export interface VendorCreatedDto {
  id: string;
  name: string;
  language: string;
  contact: ContactDto;
  memo?: string;
  active: boolean;
  website?: string;
  irs1099Form?: FederalTaxInformationDto;
  insurancePolicy?: InsurancePolicyDto;
  chatId?: string;
  icons: string[];
  type: VendorType;
  defaultMemo?: string;
  paymentSettings: PaymentSettingsDto;
  /** @format date-time */
  lastSeen?: string;
  /** @format date-time */
  lastPortalInvite?: string;
  portalStatus: PortalStatus;
  password: string;
}

/** VendorDto */
export interface VendorDto {
  id: string;
  name: string;
  language: string;
  contact: ContactDto;
  memo?: string;
  active: boolean;
  website?: string;
  irs1099Form?: FederalTaxInformationDto;
  insurancePolicy?: InsurancePolicyDto;
  chatId?: string;
  icons: string[];
  type: VendorType;
  defaultMemo?: string;
  paymentSettings: PaymentSettingsDto;
  /** @format date-time */
  lastSeen?: string;
  /** @format date-time */
  lastPortalInvite?: string;
  portalStatus: PortalStatus;
}

/** VendorOverviewDto */
export interface VendorOverviewDto {
  vendor: VendorDto;
  unpaidBills: VendorUnpaidBillsDto;
  workOrders: VendorWorkOrdersDto;
  transactions: VendorTransactionsDto;
  communications: VendorCommunicationsDto;
  references: VendorOverviewReferenceDto;
  /** @format date-time */
  cacheDate: string;
}

/** VendorOverviewReferenceDto */
export interface VendorOverviewReferenceDto {
  properties: Record<string, PropertyDto>;
  units: Record<string, UnitDto>;
}

/** VendorPortalInviteResponseDto */
export interface VendorPortalInviteResponseDto {
  /** @minLength 1 */
  newPassword: string;
}

/** VendorTaxAmountDto */
export interface VendorTaxAmountDto {
  accountId: string;
  /** @format int32 */
  calendarYear: number;
  /** @format double */
  amount: number;
  documentAlreadyExists: boolean;
  amountHasChanged: boolean;
  hasTaxId: boolean;
  vendor: VendorDto;
}

/** VendorTaxDocumentPaginationDto */
export interface VendorTaxDocumentPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: TaxDocumentListDto[];
}

/** VendorTransactionsDto */
export interface VendorTransactionsDto {
  items: Record<string, VendorTransactionsItem>;
  /** @format double */
  totalAmount: number;
  /** @format int32 */
  totalCount: number;
}

/** VendorTransactionsItem */
export interface VendorTransactionsItem {
  /** @format int32 */
  transactions: number;
  /** @format double */
  amount: number;
  /** @format double */
  due: number;
  /** @format double */
  paid: number;
}

/** VendorType */
export enum VendorType {
  Hoa = 'hoa',
  PropertyManager = 'propertyManager',
  Other = 'other',
}

/** VendorUnpaidBillsDto */
export interface VendorUnpaidBillsDto {
  items: BillDto[];
  /** @format double */
  totalAmount: number;
  /** @format double */
  totalDue: number;
}

/** VendorWorkOrdersDto */
export interface VendorWorkOrdersDto {
  items: WorkOrderListDto[];
  /** @format double */
  totalCount: number;
}

/** VersionStatus */
export enum VersionStatus {
  Ok = 'ok',
  Maintenance = 'maintenance',
  Upgrade = 'upgrade',
}

/** VoidCheckRequestDto */
export interface VoidCheckRequestDto {
  /**
   * @minLength 0
   * @maxLength 900
   */
  voidReason?: string;
}

/** WebsiteMetadata */
export interface WebsiteMetadata {
  title: string;
  titleTemplate: string;
  description: string;
  keywords: string[];
  themeColor: string;
  theme: WebsiteTheme;
}

/** WebsiteTheme */
export enum WebsiteTheme {
  Default = 'default',
  Blue = 'blue',
  Orange = 'orange',
  Green = 'green',
  Purple = 'purple',
  Black = 'black',
}

/** WorkOrderBillDto */
export interface WorkOrderBillDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  files?: WorkOrderDraftBillFileDto[];
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  billId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  bankAccountId?: string;
  approved: boolean;
  /** @format date */
  billDate: string;
  /** @format date */
  dueDate?: string;
  lineItems: WorkOrderBillLineItemDto[];
}

/** WorkOrderBillLineItemDto */
export interface WorkOrderBillLineItemDto {
  /**
   * @minLength 0
   * @maxLength 150
   */
  memo?: string;
  /**
   * Value must be a decimal greater than or equal to 0 and less than or equal to 1000000000000.
   * @format decimal
   * @min 0
   * @max 1000000000000
   */
  amount: number;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  chartOfAccountId?: string;
}

/** WorkOrderDraftBillFileDto */
export interface WorkOrderDraftBillFileDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  fileId: string;
  fileName: string;
  signedUrl: string;
  signedThumbUrl?: string;
  /** @format int64 */
  fileSize: number;
  /** @format date-time */
  uploaded: string;
  /**
   * @minLength 0
   * @maxLength 250
   */
  description?: string;
}

/** WorkOrderFileDto */
export interface WorkOrderFileDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  fileId: string;
  fileName: string;
  signedUrl: string;
  signedThumbUrl?: string;
  /** @format int64 */
  fileSize: number;
  /** @format date-time */
  uploaded: string;
  description?: string;
  /** @format date */
  addedOn: string;
}

/** WorkOrderListDto */
export interface WorkOrderListDto {
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  id: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  portfolioId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  propertyId: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  unitId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  leaseId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  vendorId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  chatId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  groupChatId?: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  assignedPropertyManagerId?: string;
  reference: string;
  /**
   * @format snowflake
   * @minLength 19
   * @maxLength 19
   */
  maintenanceRequestId?: string;
  status: WorkOrderStatus;
  /**
   * @minLength 1
   * @maxLength 150
   */
  title: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated?: string;
  /** @format date */
  dueDate?: string;
  urgency: Urgency;
}

/** WorkOrderSettingsDto */
export interface WorkOrderSettingsDto {
  sendVendorsTextMessageWhenAssigned: boolean;
  sendVendorsEmailMessageWhenAssigned: boolean;
  sendTenantVendorCoordinationMessage: boolean;
}

/** WorkOrderSettingsDtoSettingsWithOverrideDto */
export interface WorkOrderSettingsDtoSettingsWithOverrideDto {
  settings?: WorkOrderSettingsDto;
  level: SettingsLevel;
  levelId: string;
}

/** WorkOrderSettingsDtoSettingsWithOverridesDto */
export interface WorkOrderSettingsDtoSettingsWithOverridesDto {
  settings?: WorkOrderSettingsDto;
  overrides: WorkOrderSettingsDtoSettingsWithOverrideDto[];
}

/** WorkOrderStatus */
export enum WorkOrderStatus {
  Closed = 'closed',
  Pending = 'pending',
  InProgress = 'inProgress',
  Completed = 'completed',
  Cancelled = 'cancelled',
}

/** WorkOrdersPaginationDto */
export interface WorkOrdersPaginationDto {
  /** @format int32 */
  currentPage: number;
  /** @format int32 */
  totalPages: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
  items: WorkOrderListDto[];
  portfolios: PortfolioDto[];
  properties: PropertyDto[];
  units: UnitDto[];
  leases: LeaseDto[];
  vendors: VendorDto[];
  propertyManagers: PropertyManagerDto[];
  tenants: TenantDto[];
}

/** ZillowSyndicationStatusDto */
export interface ZillowSyndicationStatusDto {
  status: SyndicationStatus;
  url: string;
}
